{
  "admin": {
    "detail": {
      "reload_error": "Handlingen er avsluttet, men de oppdaterte opplysningene kunne ikke lastes. Oppdater før du gjør flere endringer.",
      "reload_retry": "Prøv å oppdatere igjen",
      "history_error": "Kunne ikke laste historikken. Prøv igjen.",
      "leave_draft": "Vil du forlate siden og forkaste endringene du ikke har lagret?",
      "discard_draft": "Vil du forkaste endringene du ikke har lagret?",
      "credit_reason_required": "Skriv en begrunnelse for krediteringen.",
      "company_field_blank": "Fyll ut feltet.",
      "company_field_invalid": "Skriv en gyldig verdi.",
      "company_field_too_long": "Forkort verdien.",
      "company_field_unpermitted": "Feltet kan ikke endres lokalt."
    },
    "case_documents": {
      "preview_ready": "Forhåndsvisningen er klar – åpne PDF",
      "refresh_error": "Dokumentet ble oppdatert, men saken kunne ikke hentes på nytt. Prøv å oppdatere saken før du gjør flere endringer.",
      "sharing_error": "Kunne ikke endre delingen av dokumentet. Prøv igjen."
    },
    "billing": {
      "reconcile_queued": "Avstemming er lagt i kø. Oppdater for å kontrollere resultatet.",
      "refresh_error": "Kunne ikke oppdatere kjøringen. Viser sist hentede status; prøv å oppdatere igjen.",
      "title": "Fakturering",
      "subtitle": "Nye mestre faktureres daglig. Betaling kontrolleres mot Tripletex hver kveld.",
      "waiting": "Venter på første betaling",
      "invoices": "Fakturaer",
      "person": "Person",
      "trade": "Fag",
      "period": "År",
      "amount": "Beløp",
      "state": "Status",
      "invoice": "Fakturanummer",
      "invoice_line": "Årsgebyr %{year}",
      "kid": "KID",
      "checked": "Sist kontrollert",
      "action": "Handling",
      "issue": "Send faktura",
      "retry": "Prøv igjen",
      "reconcile": "Kontroller betaling",
      "refresh": "Oppdater oversikten",
      "done": "Handlingen er utført. En betalingskontroll vises når jobben er ferdig.",
      "error": "Handlingen kunne ikke fullføres. Se status og kontroller opplysningene før du prøver igjen.",
      "uncertain_title": "En overføring må kontrolleres i Tripletex",
      "uncertain_body": "Vi vet ikke sikkert om Tripletex fullførte overføringen. Automatisk gjentakelse er stoppet for å unngå dobbeltfakturering. Oppgi person, fag og år til regnskapsansvarlig.",
      "empty": "Ingen fakturaer eller nye mestre i denne oversikten.",
      "pagination": "Sider i fakturaoversikten",
      "previous": "Forrige",
      "next": "Neste",
      "count": "Side %{page} · %{total} oppføringer",
      "status": {
        "ready": "Klar til fakturering",
        "draft": "Klar til overføring",
        "sent": "Venter på betaling",
        "paid": "Betalt",
        "credited": "Kreditert",
        "uncertain": "Må kontrolleres i Tripletex",
        "failed": "Overføring feilet",
        "not_billable": "Skal ikke faktureres",
        "already_covered": "Årsgebyret er allerede dekket",
        "register_review": "Avventer registerkontroll",
        "reconciliation_failed": "Avstemming må kontrolleres"
      },
      "dashboard": {
        "records": "Poster i grunnlaget",
        "processed": "%{count} av %{total} poster behandlet",
        "progress_help": "Behandlede poster inkluderer fullførte, utelatte og feilede poster.",
        "failed_help": "%{count} poster feilet. Kontroller resultatene i tabellen før du prøver igjen."
      },
      "reconciliation": {
        "external_credit": "Kreditering bekreftet ved avstemming mot Tripletex"
      },
      "preview": {
        "title": "Kontroller fakturagrunnlaget",
        "credit_title": "Kontroller krediteringsgrunnlaget",
        "notice": "Ingenting er overført til Tripletex.",
        "ready": "Klare til overføring",
        "credit_ready": "Klare til kreditering",
        "total": "Sum til overføring",
        "credit_total": "Sum til kreditering",
        "terms": "%{channel} · Forfall %{date}",
        "details": "Vis utvalg og vilkår",
        "all": "Alle",
        "ready_filter": "Klare",
        "skipped_filter": "Utelatte",
        "result": "Kontrollresultat",
        "excluded": "%{count} utelatte poster blir ikke behandlet.",
        "nothing": "Ingen poster kan behandles fra dette grunnlaget",
        "nothing_body": "Se årsakene i tabellen. Lag et nytt grunnlag når opplysningene eller utvalget er endret.",
        "no_matches": "Ingen poster i dette filteret.",
        "back": "Tilbake til fakturering",
        "transfer_one": "Overfør 1 faktura",
        "transfer_many": "Overfør %{count} fakturaer",
        "credit_one": "Opprett 1 kreditnota",
        "credit_many": "Opprett %{count} kreditnotaer"
      },
      "recovery": {
        "title": "Avklar overføring",
        "body": "Vi henter fakturaen fra Tripletex og kontrollerer kunde, beløp og referanse. Dette registrerer ikke betaling og oppretter ingen ny faktura.",
        "reference": "Forventet referanse",
        "invoice_id": "Faktura-ID i Tripletex",
        "completed": "Jeg har kontrollert at overføringen er fullført i Tripletex",
        "save": "Kontroller og lagre avklaring"
      },
      "runs": {
        "credit_preview": "Vis grunnlag",
        "title": "Kontrollerte kjøringer",
        "operation": "Type kjøring",
        "issue": "Fakturakjøring",
        "credit": "Massekreditering",
        "limit": "Maks antall i kjøringen",
        "batch": "Antall per bunt",
        "cohort": "Målgruppe",
        "channel": "Sendemåte for kjøringen",
        "due_days": "Dager til forfall",
        "number_from": "Mesterbrevnummer fra",
        "number_to": "Mesterbrevnummer til",
        "master_number": "Mesterbrevnummer",
        "reason": "Begrunnelse",
        "preview": "Kun kontroll – vis grunnlag",
        "preview_notice": "Forhåndskontroll – ingenting er overført",
        "preview_body": "Kontroller personer, beløp og avvik. Start overfører bare postene som er klare i dette lagrede grunnlaget.",
        "start": "Start kontrollert kjøring",
        "resume": "Gjenoppta uferdige poster",
        "retry_failed": "Prøv feilede poster igjen",
        "next_part": "Lag grunnlag for neste delutvalg",
        "open_next_part": "Åpne neste delutvalg",
        "previous_part": "Forrige delutvalg",
        "selection_summary": "%{selected} av %{candidates} kandidater valgt. Mesterbrevnummer i grunnlaget: %{from}–%{to}. Gjenstod ved forhåndskontroll: %{remaining}.",
        "continuation_help": "Neste delutvalg får en ny forhåndskontroll med samme utvalgsvilkår og dagens grunnlagsdato. Tidligere valgte poster tas ikke med igjen. Følg opp utelatte og feilede poster i kjøringen de tilhører. Bunter behandles automatisk innenfor én godkjent kjøring.",
        "back": "Tilbake til fakturering og avklaring av overføringer",
        "recent": "Siste kjøringer",
        "result": "Resultat / avvik",
        "credit_note": "Kreditnota-ID",
        "credit_selection": "Valgt %{count} fakturaer. Kontroller år og begrunnelse før du viser grunnlaget.",
        "credit_scope": "Oppretter kreditnotaer i Tripletex for valgte åpne årsavgifter. Betalte fakturaer og refusjoner inngår ikke. Utvalgsregelen «trukket tilbake» avventer nemnda. Kreditnotaene sendes ikke automatisk til mottakeren.",
        "select_invoice": "Velg faktura %{number}",
        "select_page": "Velg åpne fakturaer på siden",
        "clear_selection": "Tøm utvalget",
        "invalid_selection": "Velg minst én faktura fra valgt år, innenfor maksantallet.",
        "daily": "Opprettelsesforsøk i dag: %{used} av %{limit}.",
        "totals": "%{count} poster i grunnlaget. Sum for poster som kan behandles: %{amount}.",
        "terms": "%{cohort} · %{channel} · Grunnlagsdato %{date} · %{days} dager til forfall · %{batch} per bunt",
        "progress": "Klare: %{pending} · Under arbeid: %{working} · Fullført: %{succeeded} · Utelatt: %{skipped} · Feilet: %{failed}",
        "cohorts": {
          "active": "Aktive mestre – årsfornyelse",
          "new_masters": "Nye mestre",
          "reactivating": "Bortfalte mesterbrev – reaktivering",
          "foreign_address": "Adresse i utlandet",
          "unpaid": "Ikke betalt – kontroll av eksisterende fakturaer"
        },
        "channels": {
          "email": "E-post",
          "efaktura": "eFaktura",
          "paper": "Papir"
        },
        "states": {
          "preview": "Forhåndskontroll",
          "running": "Under arbeid",
          "completed": "Ferdig behandlet"
        },
        "items": {
          "pending": "Klar",
          "working": "Under arbeid",
          "succeeded": "Fullført",
          "skipped": "Utelatt",
          "failed": "Feilet"
        },
        "results": {
          "selection_exhausted": "Ingen flere poster i utvalget. Det er ikke opprettet noe nytt grunnlag.",
          "part_not_finished": "Behandle det gjeldende grunnlaget før du går til neste delutvalg.",
          "operation_busy": "En annen operasjon behandler denne posten. Oppdater oversikten.",
          "another_run_active": "En annen kjøring pågår. Vent til den er ferdig.",
          "nothing_to_process": "Ingen poster er klare for behandling.",
          "preview_changed": "Opplysninger eller status er endret siden kontrollen. Lag et nytt grunnlag.",
          "amount_changed": "Beløpet er endret siden kontrollen.",
          "draft_options_changed": "Sendemåten avviker fra den lagrede fakturaen.",
          "not_billable": "Personen eller mesterbrevet skal ikke faktureres.",
          "already_covered": "Årsavgiften er allerede dekket for perioden.",
          "already_invoiced": "Perioden er allerede fakturert. Ingen ny faktura opprettes.",
          "uncertain": "Overføringen må avklares mot Tripletex.",
          "register_review": "Avventer kontroll av registeropplysninger.",
          "missing_email": "E-postadresse mangler.",
          "missing_address": "Papirfaktura krever adresse, postnummer, sted og landkode.",
          "not_yet_granted": "Mesterbrevet er ikke innvilget per fakturadato.",
          "not_creditable": "Fakturaen kan ikke krediteres i denne kjøringen.",
          "blank_reason": "Begrunnelse er påkrevd.",
          "provider_error": "Tripletex-operasjonen kunne ikke fullføres. Kontroller fakturaen før omkjøring.",
          "unexpected_error": "En feil stoppet posten. Kontroller jobb- og fakturaloggen.",
          "invalid_recovery": "Oppgi gyldig faktura-ID og begrunnelse.",
          "not_recoverable": "Denne fakturaen kan ikke avklares med denne handlingen.",
          "identity_mismatch": "Kunde, beløp eller referanse i Tripletex samsvarer ikke med denne fakturaen.",
          "invoice_already_linked": "Tripletex-fakturaen er allerede knyttet til en annen post.",
          "credit_requires_review": "Krediteringsforsøket må kontrolleres i Tripletex.",
          "delivery_requires_confirmation": "Utsending er allerede forsøkt. Bekreft resultatet i Tripletex før du fullfører avklaringen.",
          "still_processing": "Kjøringen er fortsatt i kø eller under arbeid. Oppdater status før du forsøker å gjenoppta den.",
          "provider_authorization": "Tilgangen til Tripletex ble avvist.",
          "provider_unavailable": "Tripletex er midlertidig utilgjengelig.",
          "provider_rejected": "Tripletex avviste operasjonen."
        }
      },
      "overview": {
        "subtitle": "Fakturaer og førstegangsgebyr samlet på ett sted.",
        "search_short": "Søk i oversikten",
        "total": "Oppføringer totalt",
        "all": "Alle fakturaer og nye mestre",
        "all_statuses": "Alle statuser",
        "search": "Søk etter navn, nummer eller KID"
      },
      "tabs": {
        "waiting": "Nye mestre",
        "issue": "Ny fakturakjøring",
        "credit": "Kreditering",
        "credit_form": "Kontroller krediteringen",
        "scope": "År og omfang",
        "recipients": "Mottakere og utsending",
        "waiting_help": "Nye mestre som venter på første årsgebyr. Følg opp enkeltfakturaer og avklar overføringer her.",
        "invoices_help": "Alle årsgebyrfakturaer med betalingsstatus og mulighet for oppfølging.",
        "waiting_header": "Nye mestre som venter på første årsgebyr faktureres daglig. Følg opp fakturaer og avklar overføringer her. Betaling kontrolleres mot Tripletex hver kveld.",
        "invoices_header": "Alle årsgebyrfakturaer med betalingsstatus og oppfølging. Nye mestre faktureres daglig, og betaling kontrolleres mot Tripletex hver kveld.",
        "credit_help": "Velg åpne fakturaer som skal krediteres. Utvalget beholdes når du sorterer eller bytter fane. Gå til «Kontroller krediteringen» for å kontrollere grunnlaget.",
        "credit_review_help": "Kontroller år og begrunnelse for de valgte fakturaene. Forhåndskontrollen oppretter ingen kreditnotaer.",
        "runs_help": "Tidligere forhåndskontroller og kjøringer. Åpne en kjøring for å se resultater, avvik eller gjenoppta arbeidet.",
        "select_loaded": "Velg alle fakturaer",
        "loaded": "Viser %{count} av %{total} oppføringer",
        "loading": "Laster flere …",
        "load_more": "Last inn flere",
        "selected": "%{count} fakturaer valgt",
        "no_runs": "Ingen kjøringer er opprettet ennå.",
        "created": "Opprettet",
        "requested_by": "Opprettet av",
        "started": "Startet",
        "completed": "Ferdig behandlet",
        "run_counts": "%{done} fullført · %{failed} feilet",
        "back_runs": "Tilbake til siste kjøringer",
        "open_invoices": "Åpne fakturaoversikten",
        "run_status": "Status for kjøringen",
        "items": "Grunnlag og resultater",
        "details": "Kjøringsdetaljer"
      },
      "workflow": {
        "selection": "%{count} av %{total} fakturaer valgt for %{year}",
        "invalid_year": "Velg et gyldig fakturaår.",
        "selection_too_large": "Utvalget overstiger grensen på 9999 fakturaer. Velg et mindre utvalg manuelt.",
        "limit_exceeded": "%{count} fakturaer er valgt, men maksantallet er %{limit}. Reduser utvalget eller øk maksantallet før kontroll.",
        "edit_preview": "Endre grunnlag",
        "empty_title": "Ingen treff i utvalget",
        "empty_body": "Ingen poster samsvarer med utvalgsvilkårene. Allerede fakturerte eller dekkede perioder kan være utelatt fra kandidatlisten. Endre utvalget og prøv igjen.",
        "completed": "Fullført",
        "completed_errors": "Avsluttet med feil",
        "completed_skipped": "Avsluttet med utelatte poster",
        "selected_amount": "Beløp i grunnlaget",
        "credited_amount": "Kreditert beløp",
        "transferred_amount": "Overført beløp",
        "failed_amount": "Beløp som feilet",
        "last_attempt": "Siste forsøk startet",
        "last_checked": "Status oppdatert",
        "processing": "Kjøringen er i kø eller under arbeid. Status oppdateres automatisk.",
        "stalled": "Ingen aktivitet er registrert de siste fem minuttene, og ingen jobb behandler kjøringen nå. Du kan forsøke å gjenoppta den.",
        "credit_delivery": "Opprettede kreditnotaer er ikke sendt automatisk til mottakerne. Følg opp utsending i Tripletex.",
        "guidance": {
          "wait_retry": "Vent litt og oppdater status før du prøver igjen.",
          "contact_admin": "Be systemansvarlig kontrollere tilgangen til Tripletex før omkjøring.",
          "check_provider": "Kontroller fakturaen og referansen i Tripletex. Avklar en usikker overføring fra fakturaoversikten før omkjøring.",
          "correct_preview": "Kontroller opplysningene på personen og fakturaen. Lag et nytt grunnlag hvis opplysningene må endres."
        }
      }
    },
    "dashboard": {
      "greeting": {
        "morning": "God morgen, %{name}",
        "day": "God dag, %{name}",
        "evening": "God kveld, %{name}"
      },
      "title": "Oversikt",
      "openCaseCount": {
        "one": "%{count} åpen sak",
        "other": "%{count} åpne saker"
      },
      "kpi": {
        "openCases": "Mine aktive saker",
        "deadlinesWithin7Days": "Frister innen 7 dager",
        "overdueSuffix": "%{count} forfalt",
        "intakeLast30Days": "Nye saker siste 30 dager",
        "intakeDelta": "%{value} % mot forrige periode",
        "avgProcessingTime": "Gjennomsnittlig saksbehandlingstid",
        "placeholder": "—"
      },
      "intakeChart": {
        "title": "Saksinngang",
        "subtitle": "Nye saker per måned siste 12 måneder",
        "legend": "Totalt %{count}",
        "months": [
          "jan",
          "feb",
          "mar",
          "apr",
          "mai",
          "jun",
          "jul",
          "aug",
          "sep",
          "okt",
          "nov",
          "des"
        ]
      },
      "distribution": {
        "title": "Fordeling på status",
        "state": {
          "submitted": "Innsendt",
          "under_review": "Under behandling",
          "awaiting_documentation": "Avventer dokumentasjon",
          "ready_for_decision": "Klar for vedtak",
          "awaiting_board": "Til nemnda",
          "appeal_under_review": "Klage under behandling",
          "open": "Åpen",
          "in_progress": "Under arbeid"
        }
      },
      "urgentCases": {
        "title": "Saker som haster",
        "empty": "Ingen saker med nær frist.",
        "emptyHint": "Saker med frist innen sju dager dukker opp her.",
        "overdue": "Frist utløpt",
        "seeAll": "Se alle saker"
      },
      "recentlyAssigned": {
        "title": "Nylig tildelt meg",
        "empty": "Ingen nylig tildelte saker.",
        "emptyHint": "Saker som blir tildelt deg, vises her."
      },
      "note": {
        "title": "Mine notater",
        "label": "Notat",
        "hint": "Bare du ser dette notatet. Skriv gjerne huskelisten din her.",
        "save": "Lagre notat",
        "saved": "Lagret",
        "unsaved": "Ulagrede endringer",
        "error": "Klarte ikke å lagre notatet. Prøv igjen."
      },
      "actions": {
        "newCase": "Ny sak",
        "reports": "Statistikk"
      },
      "breadcrumb": {
        "home": "Hjem",
        "overview": "Oversikt"
      }
    },
    "reports": {
      "title": "Nøkkeltall / Statistikk",
      "subtitle": "%{period}",
      "breadcrumb": {
        "home": "Hjem",
        "overview": "Nøkkeltall"
      },
      "priorQuarter": "mot forrige kvartal",
      "delta": "%{value} %",
      "figure": {
        "new": "Nye mestere",
        "active": "Aktive mestere",
        "passive": "Passive mestere",
        "reactivated": "Reaktiverte mestere",
        "lapsedRevokedSuffix": "%{count} bortfalt/tilbakekalt"
      },
      "distribution": {
        "title": "Aktive mesterbrev per faggruppe",
        "empty": "Ingen aktive mesterbrev.",
        "share": "%{count} (%{percent} %)"
      },
      "tradeGroup": {
        "byggfag": "Byggfag",
        "mat_og_servicefag": "Mat- og servicefag",
        "designfag": "Designfag",
        "ovrige_handverksfag": "Øvrige håndverksfag",
        "unknown": "Ukjent faggruppe"
      }
    },
    "home": {
      "subtitle": "Intern saksbehandlerarbeidsflate."
    },
    "nav": {
      "cases": "Saker",
      "register": "Register",
      "internal_users": "Brukere",
      "profile": "Profil",
      "jobs": "Jobber",
      "pghero": "Databasehelse",
      "feedback_reports": "Tilbakemeldinger",
      "overview": "Oversikt",
      "case_inbox": "Saksinnboks",
      "my_cases": "Mine saker",
      "due_cases": "Saker med frist",
      "unassigned": "Til tildeling",
      "appeals": "Klagebehandling",
      "sanctions": "Sanksjon og tilbakekall",
      "signing": "Til signering",
      "advance_notices": "Forhåndsvarsler",
      "register_people": "Personer",
      "register_companies": "Bedrifter",
      "membership_feed": "Firmatilknytninger",
      "review_tasks": "Til oppfølging",
      "billing": "Fakturering",
      "journal": "Journal og arkiv",
      "journal_overview": "Journal",
      "templates": "Maler",
      "reports": "Rapporter",
      "groups": {
        "cases": "Saksbehandling",
        "register": "Register",
        "economy": "Økonomi",
        "archive": "Arkiv",
        "governance": "Styring",
        "ops": "Drift"
      }
    },
    "changelog": {
      "title": "Hva er nytt",
      "trigger": "Hva er nytt i %{version}",
      "loading": "Henter endringene …",
      "error": "Klarte ikke å hente endringene. Prøv igjen.",
      "empty": "Ingen utgivelser er registrert ennå.",
      "pr_link": "Se endring nummer %{number}"
    },
    "feedback_reports": {
      "title": "Tilbakemeldinger",
      "subtitle": "Meldinger fra «Meld feil» på alle tre flatene. Systemet sletter dem automatisk etter %{days} dager.",
      "filters": {
        "open": "Åpne",
        "resolved": "Løst",
        "dismissed": "Avvist",
        "all": "Alle"
      },
      "empty": "Ingen tilbakemeldinger her.",
      "columns": {
        "created_at": "Mottatt",
        "surface": "Flate",
        "category": "Type",
        "reporter": "Melder",
        "page": "Side",
        "status": "Status"
      },
      "anonymous": "Anonym",
      "screenshot": "Skjermbilde",
      "no_screenshot": "Uten skjermbilde",
      "screenshot_failed": "Kunne ikke laste skjermbildet.",
      "user_agent": "Nettleser",
      "actions": {
        "resolve": "Marker som løst",
        "dismiss": "Avvis",
        "reopen": "Åpne igjen",
        "open": "Åpne"
      },
      "update_failed": "Vi fikk ikke oppdatert statusen. Prøv igjen.",
      "diagnostics": {
        "viewport": "Vindusstørrelse",
        "errors": "JS-feil",
        "breadcrumbs": "Navigasjon før rapporten"
      }
    },
    "placeholder": {
      "journal_title": "Samlet journaloversikt er ikke tilgjengelig ennå",
      "journal_body": "Du kan se journal- og arkivstatus for en enkelt sak. Åpne saken fra Saksinnboks, velg dokumentene og deretter «Journal og arkiv». Den samlede oversikten på tvers av saker er under utvikling.",
      "eyebrow": "Kommer",
      "title": "%{destination} er ikke tilgjengelig ennå",
      "body": "Denne delen av saksbehandlingsløsningen er under utvikling og kommer i en senere leveranse.",
      "back": "Tilbake til oversikten"
    },
    "user_menu": {
      "profile": "Min profil",
      "display": "Visning og tema",
      "help": "Hjelp og lovgrunnlag",
      "switch_context": "Bytt rolle",
      "switch_context_hint": "Kommer senere",
      "logout": "Logg ut",
      "aria_label": "Brukermeny"
    },
    "help": {
      "title": "Hjelp og lovgrunnlag",
      "close": "Lukk",
      "shortcuts_heading": "Hurtigtaster",
      "laws_heading": "Lovgrunnlag",
      "support_heading": "Support",
      "shortcut_search": "Åpne søk i saker og sider",
      "shortcut_close": "Lukk åpen dialog eller panel",
      "shortcut_navigate": "Bla i søkeresultater",
      "shortcut_open": "Åpne valgt treff",
      "support_body": "Saksbehandlerstøtte: support@mesterbrev.no · 22 00 00 00 (hverdager 09–15). Lovlenker åpnes på lovdata.no i ny fane.",
      "laws_note": "Åpnes på lovdata.no i ny fane"
    },
    "cases": {
      "v2": {
        "phase4d_discard_draft": "Forkast utkastet og hent siste versjon",
        "phase4d_discard_confirm": "Vil du forkaste utkastet og hente den sist lagrede versjonen?",
        "phase4d_conflict_hint": "Utkastet ditt er beholdt. Kopier teksten du vil ta vare på, og forkast deretter utkastet for å hente og vurdere siste versjon.",
        "assessment_tools": "Vurderingsvalg og dokumenter",
        "requirements_heading": "Dokumentasjonskrav",
        "requirements_hint": "Behandle hvert krav og dokumentene som hører til.",
        "request_documentation": "Be om dokumentasjon",
        "add_documentation": "Legg til dokumentasjon",
        "documentation_requirement": "Dokumentasjonskrav",
        "document_category": "Kategori",
        "whole_case": "Hele saken (uten dokumentasjonskrav)",
        "documentation_action_unavailable": "Dokumentasjon kan bare legges til mens saken er åpen.",
        "request_documentation_unavailable": "Nye dokumentasjonskrav kan ikke opprettes i denne statusen.",
        "show": "Vis",
        "all_requirements": "Alle",
        "active_requirements": "Aktive",
        "sort": "Sorter",
        "newest_first": "Nyeste først",
        "deadline_first": "Frist først",
        "no_requirements": "Ingen krav å vise",
        "requirement": "Dokumentasjonskrav",
        "deadline": "Frist",
        "status": "Status",
        "action": "Handling",
        "no_deadline": "Ingen frist",
        "overdue": "Frist utløpt",
        "collapse": "Lukk detaljer",
        "open_requirement": "Se krav",
        "requested_documentation": "Dette er etterspurt",
        "linked_documents": "Dokumenter til kravet",
        "no_linked_documents": "Ingen dokumenter er koblet til dette kravet.",
        "choose_documents": "Koble dokumenter til kravet",
        "no_documents": "Ingen dokumenter registrert.",
        "review_note": "Saksbehandlers merknad",
        "requirement_notes": "Interne notater til kravet",
        "new_requirement_note": "Nytt notat til kravet",
        "internal_note_hint": "Internt. Vises ikke til søkeren.",
        "save_note": "Lagre merknad og koblinger",
        "record_response": "Registrer mottatt svar",
        "resolve": "Avklar kravet",
        "supplement": "Be om supplering",
        "cancel_requirement": "Annuller kravet",
        "resolve_hint": "Registrer mottatt svar før kravet avklares. Avklaringen gjelder bare dette kravet og er ikke et vedtak.",
        "requirement_history": "Historikk for kravet",
        "stale_error": "En annen har endret opplysningene. Behold teksten din, oppdater siden og sammenlign før du lagrer igjen.",
        "save_error": "Endringen kunne ikke lagres. Kontroller opplysningene og prøv igjen. Teksten din er beholdt.",
        "saved": "Lagret",
        "back": "Tilbake",
        "confirm": "Bekreft",
        "saving": "Lagrer …",
        "confirm_respond": "Registrer mottatt svar?",
        "confirm_respond_hint": "Bekreft at svaret er mottatt. Kravet vil fortsatt vente på saksbehandlers avklaring.",
        "confirm_resolve": "Avklar dette kravet?",
        "confirm_resolve_hint": "Dette avslutter bare det valgte dokumentasjonskravet. Andre krav og sakens status endres ikke.",
        "confirm_supplement": "Be søkeren om supplering?",
        "confirm_supplement_hint": "Kravet åpnes igjen. Meldingen og fristen vises på Min side, og søkeren varsles gjennom den eksisterende varslingsflyten.",
        "confirm_cancel": "Annuller dette kravet?",
        "confirm_cancel_hint": "Oppgi hvorfor dokumentasjonen ikke lenger er nødvendig. Kravet og historikken blir bevart.",
        "message_to_applicant": "Melding til søkeren",
        "reason": "Begrunnelse",
        "all_documents": "Alle dokumenter",
        "document": "Dokument",
        "documents": "dokumenter",
        "preview": "Forhåndsvisning",
        "select_document": "Velg et dokument",
        "open_separately": "Åpne i ny fane",
        "search_documents": "Søk i dokumenter",
        "name": "Navn",
        "generated": "Generert",
        "no_documents_found": "Ingen dokumenter passer søket.",
        "unknown_format": "Ukjent format",
        "sensitive": "Skjermet dokument",
        "download": "Last ned",
        "share": "Del med søkeren",
        "unshare": "Fjern deling",
        "linked_requirements": "Tilknyttede krav",
        "no_linked_requirements": "Dokumentet er ikke knyttet til et krav.",
        "assessment": "Vurdering",
        "assessment_hint": "Vurderingen er et utkast. Vedtak fattes separat.",
        "new_assessment": "Ny vurdering",
        "continue_assessment": "Fortsett vurdering",
        "view_assessments": "Se vurderinger",
        "finalized": "Ferdigstilt",
        "draft": "Utkast",
        "unsaved": "Ulagrede endringer",
        "readonly_assessment": "Ferdigstilt · skrivebeskyttet",
        "close_keep_draft": "Lukk",
        "save_draft": "Lagre utkast",
        "finalize": "Ferdigstill vurdering",
        "finalize_confirm": "Er vurderingen klar til å låses?",
        "finalize_hint": "Begrunnelse, konklusjoner og dokumentgrunnlag lagres. Vurderingen kan deretter ikke endres. Dette fatter ikke vedtak i saken.",
        "confirm_finalize": "Lagre og ferdigstill",
        "assessment_points": "Vurderingspunkter",
        "overall_assessment": "Samlet vurdering",
        "not_assessed": "Ikke vurdert",
        "points_assessed": "punkter vurdert",
        "no_configured_points": "Denne søknadstypen har ingen konfigurerte vurderingspunkter. Skriv den samlede vurderingen nedenfor.",
        "rationale": "Begrunnelse",
        "statute": "Vis regelverksgrunnlag",
        "conclusion": "Konklusjon",
        "complete_points": "Alle vurderingspunkter må ha en konklusjon før ferdigstilling.",
        "select_conclusion_first": "Velg konklusjon før du skriver merknad til punktet.",
        "preview_document": "Dokument som vises",
        "leave_draft": "Du har ulagret tekst i saken. Vil du forlate siden og forkaste teksten?",
        "received": "Mottatt",
        "nearest_deadline": "Nærmeste frist",
        "open_requirements": "åpne krav",
        "awaiting_applicant": "Venter på søkerens svar",
        "responses_received": "svar mottatt",
        "needs_review": "Må vurderes av saksbehandler",
        "assessment_draft": "Vurdering pågår",
        "assessment_completed": "Vurdering ferdigstilt",
        "no_assessment": "Vurdering ikke startet",
        "continue_hint": "Fortsett der du slapp",
        "assessment_summary_hint": "Se vurdering og dokumentgrunnlag",
        "requirements_not_applicable": "Denne sakstypen har ingen dokumentasjonskrav.",
        "application_details": "Søknadsopplysninger",
        "latest_activity": "Siste aktivitet",
        "all_history": "Hele historikken",
        "loading": "Laster …",
        "load_error": "Kunne ikke hente opplysningene.",
        "retry": "Prøv igjen",
        "no_activity": "Ingen hendelser registrert.",
        "work_on_case": "Arbeid med saken",
        "assignee": "Saksansvarlig",
        "reviewer": "Kontrollør",
        "next_step": "Neste steg",
        "next_review_requirements": "Behandle mottatte svar og avklar kravene før du går videre.",
        "next_assessment": "Vurder dokumentasjonen og bruk saksflyten nedenfor for å gå videre.",
        "internal_notes": "Interne notater",
        "refresh": "Oppdater",
        "load_more": "Vis eldre hendelser",
        "queue_hint": "Åpne saken fra innboksen for å bla mellom saker.",
        "previous_case": "Forrige sak",
        "next_case": "Neste sak",
        "reopen_case": "Gjenåpne saken",
        "resolve_first": "Avklar eller annuller alle aktive krav før saksbehandlingen gjenopptas.",
        "statuses": {
          "open": "Åpen",
          "responded": "Svar mottatt",
          "resolved": "Avklart",
          "cancelled": "Annullert"
        },
        "history_fields": {
          "status": "Status",
          "review_note": "Intern merknad",
          "reason": "Melding",
          "due_at": "Frist"
        },
        "document_filters": {
          "all": "Alle",
          "incoming": "Inngående",
          "generated": "Produsert",
          "unlinked": "Uten kravkobling"
        },
        "archive_status": "Journal og arkivstatus",
        "archive_hint": "Status fra arkivintegrasjonens siste synkronisering.",
        "archive_error": "Synkronisering feilet",
        "archived": "Arkivert",
        "not_archived": "Ikke arkivert",
        "case_file": "Saksmappe",
        "last_synced": "Sist synkronisert",
        "no_archive_records": "Ingen journalposter registrert i arkivet.",
        "journal_number": "Journalnummer",
        "readonly": "Kun lesetilgang",
        "view_response": "Vis svar",
        "response_received_on": "Svar mottatt",
        "requirement_created": "Krav sendt til søker",
        "response_review_hint": "Svar mottatt – må gjennomgås. Besvart betyr ikke avklart.",
        "file_received_open": "Fil er koblet til kravet. Mottatt svar er ennå ikke registrert.",
        "applicant_claims_hint": "Opplysninger fra søker",
        "application_basis": "Søknadsgrunnlag",
        "all_application_details": "Vis alle søknadsopplysninger",
        "next_await_response": "Saken venter på svar fra søkeren. Du kan forberede vurderingen og følge opp kravene.",
        "next_resume": "Alle krav er behandlet. Gjenoppta saksbehandlingen for å gå videre.",
        "next_closed": "Saken er avsluttet. Se vedtak, dokumenter og historikk, eller tilgjengelige oppfølgingshandlinger.",
        "next_decided": "Følg opp underretning og klagefrist før saken avsluttes.",
        "next_decision": "Gjennomgå vedtaksgrunnlaget og kontrollørens signering før vedtaket fattes.",
        "next_prepare": "Vurderingen er ferdigstilt. Gjennomgå grunnlaget og klargjør saken for vedtak.",
        "case_progress": "Videre saksbehandling",
        "other_actions": "Andre handlinger",
        "new_internal_note": "Nytt internt notat",
        "notes_saved": "Ingen ulagrede notater",
        "save_internal_note": "Lagre notat",
        "payment_details": "Vis betalingsdetaljer",
        "points_remaining": "vurderingspunkter gjenstår",
        "rationale_required": "Samlet begrunnelse mangler",
        "outstanding_requirements": "dokumentasjonskrav er aktive.",
        "can_save_draft": "Du kan lagre vurderingen som utkast.",
        "case_document": "Saksdokument",
        "shared": "Delt med søker",
        "requirement_resolved_hint": "Kravet er avklart. Søknaden vurderes separat.",
        "requirement_cancelled_hint": "Kravet er annullert. Dokumenter og historikk er bevart.",
        "declared_practice": "Se oppgitte arbeidsforhold",
        "practice_heading": "Oppgitt praksis",
        "practice_hint": "Periodene er oppgitt av søkeren. Kontroller datoer og dokumentasjon før praksisen vurderes.",
        "practice_period": "Periode",
        "practice_duration": "Varighet",
        "practice_evidence": "Dokumentasjon",
        "practice_evidence_attached": "Vis vedlegg",
        "practice_evidence_missing": "Ingen koblet attest",
        "practice_leadership": "Lederpraksis",
        "open_requirement_singular": "åpent krav",
        "change_details": "Vis endringsdetaljer",
        "previous_page": "Forrige side",
        "next_page": "Neste side",
        "page": "Side",
        "zoom": "Zoom",
        "fit_width": "Tilpass bredde",
        "document_text": "Les sidens tekst",
        "reduce_preview": "Tilbake til arbeidsflaten",
        "requirement_events": {
          "open": "Supplering etterspurt",
          "responded": "Svar mottatt",
          "resolved": "Krav avklart",
          "cancelled": "Krav annullert",
          "updated": "Merknad eller opplysninger endret"
        },
        "previous_assessments": "Lagrede vurderinger",
        "select_saved_assessment": "Velg en lagret vurdering",
        "create_assessment": "Opprett ny vurdering",
        "continue_new_assessment": "Fortsett nytt utkast",
        "assessment_kinds": {
          "initial": "Førstegangsvurdering",
          "reconsideration": "Revurdering",
          "appeal_response": "Klagevurdering"
        },
        "review_responses": "Vurder mottatte svar (%{count})",
        "view_open_requirements": "Se åpne krav (%{count})",
        "blocking_requirements": "Vis krav som blokkerer (%{count})",
        "group_by_document_type": "Grupper etter dokumenttype"
      },
      "title": "Saker",
      "work_modes": {
        "aria_label": "Arbeidsmodus for saksvisningen",
        "classic": "Original",
        "queue": "Kø",
        "split": "Delt skjerm",
        "compact": "Kompakt",
        "viewer": {
          "download": "Last ned",
          "enlarge": "Åpne stort",
          "close": "Lukk",
          "prev_doc": "Forrige dokument",
          "next_doc": "Neste dokument",
          "position": "%{index} av %{total}",
          "no_document": "Velg et dokument i listen",
          "no_preview": "Dokumentet har ingen forhåndsvisning",
          "docx_text_only": "Tekstutdrag fra Word-filen. Formatering, bilder og tabelloppsett vises ikke. Last ned originalen for å kontrollere hele dokumentet."
        },
        "conditions": {
          "title": "Vurdering av vilkår",
          "progress": "%{done} av %{total} vilkår vurdert",
          "source": "Kilde",
          "note_label": "Merknad",
          "note_placeholder": "Skriv en merknad …",
          "save_failed": "Kunne ikke lagre vurderingen – prøv igjen.",
          "note_save": "Lagre merknad",
          "empty_title": "Ingen vilkårssjekkliste",
          "empty_body": "Sjekklisten for denne sakstypen er ikke konfigurert ennå.",
          "no_round_title": "Ingen aktiv vurdering",
          "no_round_body": "Start en vurderingsrunde med «Ny vurdering» under Handlinger."
        },
        "queue_bar": {
          "position": "Sak %{position} av %{total} i køen",
          "done_next": "Neste sak",
          "keys_hint": "J/K bytt sak · ⌘↵ neste",
          "outside": "Åpnet utenfor køen",
          "back": "Til saksinnboksen"
        },
        "core_info": {
          "deficiency_fallback": "Etterspurt dokumentasjon",
          "empty": "Ingen kjerneinformasjon registrert ennå",
          "title": "Kjerneinformasjon",
          "reminder": "purring %{date}",
          "fee_paid": "Behandlingsgebyr: betalt",
          "fee_unpaid": "Behandlingsgebyr: ikke betalt",
          "fee_credited": "Behandlingsgebyr: kreditert",
          "fee_not_applicable": "Behandlingsgebyr: ikke aktuelt",
          "trade_certificate": "Fagbrev: %{title}",
          "passed_exam": "Mesterprøve bestått (%{year})",
          "tone_ok": "Oppfylt",
          "tone_warn": "Krever oppfølging",
          "tone_none": "Ikke aktuelt",
          "basis": "Søknadsgrunnlag",
          "company": "Bedrift",
          "residence": "Bosted",
          "months": "%{months} mnd",
          "decided_at": "Vedtaksdato",
          "precedent": "Prinsipiell sak",
          "precedent_yes": "Ja"
        },
        "practice": {
          "title": "Praksis",
          "months_chip": "%{months} mnd",
          "undated_chip": "Uten datoer",
          "ongoing": "pågår",
          "total_documented": "Dokumentert praksis: %{months} mnd",
          "no_entries": "Ingen praksisoppføringer i søknaden"
        },
        "feed": {
          "journal_tab": "Journal",
          "history_tab": "Historikk",
          "kind_note": "Notat",
          "kind_outgoing": "Utgående",
          "kind_incoming": "Innkommende",
          "kind_status": "Status",
          "kind_change": "Endring",
          "empty": "Ingen hendelser ennå",
          "show_all": "Vis full historikk"
        },
        "next_action": {
          "title": "Neste handling",
          "none": "Ingen foreslått handling i denne tilstanden"
        },
        "chrome": {
          "case_position": "Sak %{index} av %{total}",
          "actions_title": "Handlinger",
          "documents_title": "Dokumenter"
        },
        "v2": "V2"
      },
      "new_case": "Ny sak",
      "filter_department": "Velg avdeling",
      "search_placeholder": "Søk på saksnummer, navn …",
      "empty": "Ingen saker i denne listen.",
      "toggle_all_departments": "Alle avdelinger",
      "kinds": {
        "ordinary_grant": "Mesterbrev – utdanning eller innvilget fritak",
        "prior_learning_assessment": "Realkompetansevurdering",
        "equivalent_education_exemption": "Annen utdanning / fritak",
        "foreign_qualification": "Mesterkvalifikasjon fra andre land",
        "special_grounds_dispensation": "Særlige grunner (dispensasjon)",
        "master_certificate_with_exemption_letter": "Mesterbrev med innvilget fritak",
        "exemption_from_master_education": "Fritak for mesterutdanning"
      },
      "case_types": {
        "application": "Søknad",
        "appeal": "Klage",
        "sanction": "Ulovlig bruk",
        "change": "Endring",
        "access_request": "Innsynskrav"
      },
      "buckets": {
        "new": "Nye",
        "mine": "Mine",
        "all": "Alle",
        "decided": "Avgjorte",
        "written_off": "Henlagte",
        "short_deadline": "Kort frist"
      },
      "states": {
        "draft": "Utkast",
        "submitted": "Innsendt",
        "under_review": "Under behandling",
        "awaiting_documentation": "Avventer dokumentasjon",
        "ready_for_decision": "Klar for vedtak",
        "awaiting_board": "Til nemnda",
        "decided": "Vedtatt",
        "appeal_under_review": "Klage under behandling",
        "appeal_resolved": "Klage avgjort",
        "closed": "Avsluttet",
        "withdrawn": "Trukket",
        "awaiting_payment": "Venter på betaling",
        "written_off": "Avskrevet",
        "open": "Åpen",
        "in_progress": "Under arbeid",
        "awaiting_response": "Avventer tilbakemelding",
        "response_received": "Tilsvar mottatt"
      },
      "next_step": {
        "draft": "Fullfør registrering",
        "submitted": "Start saksbehandling",
        "under_review": "Vurder og forbered vedtak",
        "awaiting_documentation": "Avventer søker",
        "ready_for_decision": "Fatt vedtak",
        "awaiting_board": "Til nemndsbehandling",
        "decided": "Send underretning / avslutt",
        "appeal_under_review": "Behandle klage",
        "appeal_resolved": "Klage behandlet",
        "closed": "Ingen videre handling",
        "withdrawn": "Ingen videre handling",
        "awaiting_payment": "Avventer betaling",
        "written_off": "Ingen videre handling",
        "open": "Start saksbehandling",
        "in_progress": "Under arbeid"
      },
      "markers": {
        "overdue": "Frist utløpt",
        "overdue_count": "%{count} forfalt",
        "flagged": "Redigert av annen saksbehandler",
        "flagged_by": "Redigert av %{name}",
        "flagged_helptext": "Samarbeidssignal, ikke habilitet (fvl §6). Ingen automatisk effekt på vedtaket.",
        "changed": "Endringer siden sist",
        "changed_helptext": "Saken er endret etter at du sist åpnet den. Nye saker du aldri har åpnet er ikke merket.",
        "reviewer": "Kontrollør",
        "party_person": "Person",
        "party_company": "Bedrift"
      },
      "deadline": {
        "overdue": "Forfalt %{date}",
        "today": "I dag",
        "soon": "Om %{days} d · %{date}"
      },
      "unassigned": "Ikke tildelt",
      "empty_filtered": "Ingen treff med valgte filtre.",
      "empty_reset": "Nullstill filtre",
      "overview_feedback": {
        "shown": "%{count} saker vist",
        "load_more": "Last flere saker",
        "loading": "Laster flere saker…",
        "load_error": "Kunne ikke laste flere saker. Prøv igjen.",
        "retry": "Prøv igjen",
        "bulk_error": "Kunne ikke bekrefte oppdateringen. Utvalget er beholdt; prøv igjen.",
        "copy_error": "Kunne ikke kopiere saks-ID.",
        "validation_summary": "Kontroller saksopplysningene",
        "missing_slug": "Serveren returnerte ingen saksreferanse. Saken kan ha blitt opprettet. Oppdater innboksen før du prøver igjen."
      },
      "filters": {
        "status": "Status",
        "case_type": "Sakstype",
        "kind": "Søknadstype",
        "trade": "Fag",
        "assignee": "Saksbehandler",
        "period": "Periode",
        "all": "Alle",
        "unassigned": "Ikke tildelt",
        "period_7d": "Siste 7 dager",
        "period_30d": "Siste 30 dager",
        "period_90d": "Siste 90 dager",
        "period_all": "Hele perioden",
        "active_count": "%{count} aktive",
        "reset": "Nullstill",
        "label": "Filter"
      },
      "views": {
        "label": "Visning",
        "table": "Tabell",
        "kanban": "Kanban",
        "cards": "Kort",
        "kanban_columns": {
          "intake": "Ny / tildelt",
          "in_progress": "Under behandling",
          "awaiting": "Avventer",
          "ready": "Klar for vedtak",
          "done": "Avsluttet"
        }
      },
      "bulk": {
        "selected_count": {
          "one": "%{count} valgt",
          "other": "%{count} valgt"
        },
        "clear": "Nullstill valg",
        "assign": "Tildel",
        "assign_to": "Tildel valgte til",
        "unassign": "Fjern tildeling",
        "status": "Endre status",
        "status_to": "Sett status",
        "archive": "Arkiver",
        "archive_disabled_hint": "Arkivering er ikke tilgjengelig ennå",
        "result": {
          "one": "%{succeeded} oppdatert",
          "other": "%{succeeded} oppdatert"
        },
        "result_with_skipped": "%{succeeded} oppdatert, %{skipped} hoppet over",
        "skipped_reason": {
          "not_found": "Fant ikke saken",
          "invalid_transition": "Ugyldig statusovergang",
          "guard_failed": "Vilkår ikke oppfylt",
          "forbidden": "Ingen tilgang",
          "error": "Kunne ikke oppdatere"
        }
      },
      "export": {
        "button": "Eksporter",
        "hint": "Last ned synlige saker som CSV"
      },
      "row_menu": {
        "actions": "Handlinger",
        "open": "Åpne sak",
        "copy_id": "Kopier saks-ID",
        "copy_id_done": "Kopierte %{slug}",
        "assign_to_me": "Tildel til meg",
        "assign_to_me_done": "Sak %{slug} tildelt deg",
        "assign_to_me_error": "Kunne ikke tildele sak %{slug}",
        "archive": "Arkiver sak",
        "archive_disabled_hint": "Arkivering er ikke tilgjengelig ennå"
      },
      "columns": {
        "case_number": "Saksnummer",
        "case": "Sak",
        "title": "Tittel",
        "applicant": "Søker",
        "party": "Part",
        "trade": "Fag",
        "kind": "Type",
        "state": "Status",
        "assignee": "Saksbehandler",
        "reviewer": "Kontrollør",
        "deficiencies": "Mangler",
        "deadline": "Frist / oppfølging",
        "department": "Avdeling",
        "date": "Oppdatert"
      },
      "claims": {
        "title": "Søknadsopplysninger",
        "groups": {
          "personalia": "Personalia",
          "trade": "Fag",
          "education": "Utdanning",
          "practice": "Praksis",
          "other_documentation": "Annen dokumentasjon"
        },
        "address_from_registry": "Adresse fra Folkeregisteret",
        "contact_from_registry": "Kontakt fra ID-porten",
        "contact_email": "E-post oppgitt i søknaden",
        "contact_mobile_number": "Telefon oppgitt i søknaden",
        "third_party_verification_consent": "Samtykke til kontroll hos tredjepart",
        "value_yes": "Ja",
        "value_no": "Nei",
        "trade_name": "Fag",
        "trade_certificate_title": "Fag-/svennebrevets tittel",
        "passed_exam_date": "Dato for bestått prøve",
        "practice": {
          "type": "Type",
          "employer": "Arbeidssted / bedrift",
          "years": "Periode",
          "type_employed": "Ansatt",
          "type_self_employed": "Selvstendig",
          "implausible_years": "Kontroller årstallene"
        },
        "empty": "Ingen strukturerte søknadsopplysninger (manuelt registrert sak)"
      },
      "show": {
        "title": "Sak %{slug}",
        "nav": {
          "prev": "Forrige sak",
          "next": "Neste sak"
        },
        "action_gate": {
          "needs_finalized_assessment": "Fullfør en vurdering for å gå videre",
          "needs_ready": "Saken må være klar for vedtak",
          "unavailable": "Handlingen er ikke tilgjengelig i denne tilstanden",
          "needs_notification": "Registrer underretning før saken kan avsluttes",
          "appeal_window_running": "Klagefristen løper til %{date} — saken kan avsluttes etter det"
        },
        "case_details": "Saksopplysninger",
        "applicant_label": "Søker",
        "trade_label": "Fag",
        "kind_label": "Søknadstype",
        "state_label": "Status",
        "submitted_at_label": "Innsendt",
        "intake_channel_label": "Kanal",
        "manual_intake_by": "Manuelt registrert av %{name}",
        "precedent_setting_label": "Presedenssak",
        "precedent_setting_yes": "Ja",
        "precedent_setting_no": "Nei",
        "assessments_heading": "Vurderinger",
        "no_assessments": "Ingen vurderinger registrert.",
        "decision_heading": "Vedtak",
        "no_decision": "Ikke vedtatt ennå.",
        "documents_heading": "Dokumenter",
        "no_documents": "Ingen dokumenter lastet opp.",
        "transitions_heading": "Handlinger",
        "outcomes": {
          "granted": "Innvilget",
          "partially_granted": "Delvis innvilget",
          "denied": "Avslått",
          "returned": "Returnert",
          "written_off": "Henlagt",
          "upheld": "Stadfestet",
          "overturned": "Omgjort",
          "partially_upheld": "Delvis stadfestet"
        },
        "decided_by_body": {
          "secretariat": "Sekretariatet",
          "board": "Nemnda",
          "appeals_board": "Klagenemnda"
        },
        "transitions": {
          "pick_up": "Start saksbehandling",
          "request_documentation": "Be om dokumentasjon",
          "documentation_received": "Gjenoppta saksbehandling",
          "prepare_decision": "Klargjør for vedtak",
          "refer_to_board": "Send til nemnda",
          "decide": "Fatt vedtak",
          "close": "Avslutt sak",
          "notify": "Registrer underretning",
          "withdraw": "Trekk søknad",
          "file_appeal": "Registrer klage",
          "appeal_resolved": "Registrer klageutfall",
          "start": "Start behandling",
          "write_off": "Avskriv saken",
          "reopen": "Gi ny sjanse",
          "send_advance_notice": "Send forhåndsvarsel"
        },
        "send_notification": {
          "phase4d_queued": "Varslet er lagt i kø. Du kan følge statusen i kommunikasjonshistorikken.",
          "title": "Send varsel",
          "template_label": "Mal",
          "template_placeholder": "Velg en mal",
          "channel_override_label": "Send via",
          "channel_override_default": "Standard (mottakers preferanse)",
          "channel_override_email": "E-post",
          "channel_override_sms": "SMS",
          "send_button": "Send",
          "sent": "Varsel sendt",
          "no_templates": "Ingen standardsvar tilgjengelig for denne saken.",
          "preview_button": "Forhåndsvis",
          "preview_subject_label": "Emne",
          "preview_body_label": "Innhold"
        },
        "write_off_form": {
          "heading": "Avskriv saken",
          "reason_label": "Begrunnelse for avskriving",
          "submit": "Avskriv saken",
          "confirm": "Er du sikker på at du vil avskrive saken?"
        },
        "assessment_form": {
          "heading": "Ny vurdering",
          "kind_label": "Vurderingstype",
          "outcome_label": "Anbefalt utfall",
          "outcome_placeholder": "Velg utfall",
          "rationale_label": "Begrunnelse",
          "rationale_placeholder": "Skriv vurdering …",
          "facts_snapshot_label": "Faktum (JSON)",
          "submit": "Lagre vurdering",
          "kinds": {
            "initial": "Første vurdering",
            "reconsideration": "Ny vurdering",
            "appeal_response": "Klagevurdering"
          }
        },
        "decision_form": {
          "heading": "Fatt vedtak",
          "outcome_label": "Utfall",
          "outcome_placeholder": "Velg utfall",
          "rationale_label": "Begrunnelse",
          "rationale_placeholder": "Begrunnelse for vedtaket (fvl §§24–25) …",
          "legal_basis_label": "Hjemmel",
          "legal_basis_placeholder": "f.eks. mesterbrevloven §2",
          "legal_basis_hint": "Oppgi hjemmelen vedtaket bygger på (fvl §25), f.eks. mesterbrevloven §2 jf. forskrift om vilkår for å få mesterbrev §2",
          "decided_by_body_label": "Vedtaksorgan",
          "decided_by_body_placeholder": "Velg organ",
          "cited_assessment_ids_label": "Siterte vurderinger",
          "submit": "Fatt vedtak"
        },
        "notify_form": {
          "heading": "Registrer underretning",
          "notified_at_label": "Underretningsdato",
          "submit": "Lagre underretning"
        },
        "assignment_form": {
          "heading": "Tildeling",
          "save_error": "Kunne ikke lagre tildelingen",
          "assignee_label": "Saksbehandler",
          "assignee_placeholder": "Velg saksbehandler",
          "clear_assignee": "Fjern tildeling",
          "save_assignee": "Lagre tildeling",
          "edit_assignee": "Endre",
          "assign_assignee": "Tildel",
          "assign_me": "Tildel meg",
          "reviewer_heading": "Kontrollør",
          "reviewer_label": "Kontrollør",
          "reviewer_placeholder": "Velg kontrollør",
          "clear_reviewer": "Fjern kontrollør",
          "save_reviewer": "Lagre kontrollør",
          "sign_off_heading": "Signering",
          "sign_off_label": "Kontroll registrert",
          "sign_off_button": "Registrer signering",
          "no_reviewer": "Ikke tildelt",
          "no_assignee": "Ikke tildelt",
          "no_sign_off_notice": "Ingen kontrollør har signert. Vedtaket kan likevel fattes."
        },
        "deficiencies": {
          "heading": "Mangler",
          "legal_anchor": "Hjemmel: forvaltningsloven §17 (utrednings- og informasjonsplikt)",
          "empty": "Ingen mangler registrert.",
          "awaiting_empty": "Saken avventer dokumentasjon – ingen mangler er registrert ennå.",
          "overdue_marker": "Frist utløpt",
          "due_at_label": "Frist",
          "no_due_at": "Ingen frist",
          "responded_at_label": "Svart",
          "resolved_at_label": "Løst",
          "requested_by_label": "Registrert av",
          "respond_button": "Registrer svar",
          "cancel_button": "Trekk mangel",
          "statuses": {
            "open": "Åpen",
            "responded": "Besvart",
            "resolved": "Løst",
            "cancelled": "Trukket"
          },
          "document_kinds_label": "Dokumenter",
          "columns": {
            "summary": "Mangel",
            "status": "Status",
            "actions": "Handlinger"
          }
        },
        "communication_history": {
          "unknown_template": "Varsel",
          "event_labels": {
            "case": {
              "submitted": "Søknad mottatt",
              "documentation_requested": "Dokumentasjon etterspurt",
              "decided": "Underretning om vedtak"
            },
            "document": {
              "shared": "Dokument delt med søker"
            },
            "mastership": {
              "granted": "Mesterbrev tildelt",
              "lapsed": "Mesterbrev bortfalt"
            }
          },
          "heading": "Varsler sendt",
          "empty": "Ingen varsler sendt.",
          "created_at_label": "Opprettet:",
          "sent_at_label": "Sendt:",
          "delivered_at_label": "Levert:",
          "columns": {
            "template": "Mal",
            "channel": "Kanal",
            "status": "Status",
            "legal_basis": "Hjemmel",
            "timestamps": "Tidspunkt"
          },
          "channels": {
            "in_app": "I appen",
            "email": "E-post",
            "sms": "SMS"
          },
          "statuses": {
            "queued": "I kø",
            "sent": "Sendt",
            "delivered": "Levert",
            "failed": "Feilet",
            "routed_paper": "Rutet til papir"
          },
          "paper_reasons": {
            "reserved": "Mottaker reservert mot elektronisk kommunikasjon",
            "missing_contact": "Mangler gyldig kontaktinformasjon",
            "inactive": "Mottakerkonto er ikke aktiv",
            "not_notifiable": "Kontaktkanal ikke gyldig i KRR"
          }
        },
        "deficiency_form": {
          "heading": "Registrer mangel",
          "delivery_hint": "Registrering sender varsel til søkeren. For å dele selve PDF-brevet må du åpne mangelen og velge «Opprett brev og del på Min side».",
          "document_kinds_label": "Dokumenter som mangler",
          "document_kinds_hint": "Kryss av for dokumentene søkeren må sende inn.",
          "summary_label": "Kort beskrivelse/Overskrift",
          "summary_help": "En kort beskrivelse av mangelen. Teksten brukes også som overskrift for forespørselen. Eksempel: «Praksisattest med stillingsprosent».",
          "summary_placeholder": "Beskriv det som ikke står i listen over",
          "nothing_named": "Velg minst ett dokument, eller beskriv hva som mangler.",
          "reason_label": "Melding til søker",
          "reason_help": "Den utfyllende beskjeden: hva som er utilstrekkelig, og hva søkeren må sende inn. Eksempel: «Attesten du har sendt inn, oppgir ikke stillingsprosent. Last opp en ny attest hvor arbeidsgiver bekrefter dette.»",
          "reason_placeholder": "Detaljert melding til søkeren …",
          "due_at_label": "Frist",
          "submit": "Registrer mangel"
        },
        "state_context": {
          "ready_heading": "Vurderingsgrunnlag",
          "no_finalized": "Ingen ferdigstilte vurderinger ennå."
        },
        "tabs": {
          "oversikt": "Oversikt",
          "saksflyt": "Saksflyt",
          "dokumenter": "Dokumenter",
          "vedtak": "Vedtak",
          "historikk": "Historikk",
          "parter": "Parter & roller",
          "journal": "Journal"
        },
        "open_flow": "Åpne saksflyt",
        "resize_left": "Endre bredden på venstre kolonne",
        "resize_right": "Endre bredden på høyre kolonne",
        "summary_heading": "Sakdetaljer",
        "company_heading": "Foretak",
        "case_type_label": "Sakstype",
        "created_at_label": "Opprettet",
        "updated_at_label": "Sist endret",
        "company_name_label": "Navn",
        "company_orgnr_label": "Org.nr",
        "company_status_label": "Status",
        "company_status_active": "Aktiv (Brreg)",
        "no_company": "Ingen foretak knyttet til saken",
        "quick_actions_heading": "Hurtighandlinger",
        "vilkaar_heading": "Vilkårsvurdering",
        "document_meta_heading": "Dokumentdetaljer",
        "document_filename_label": "Filnavn",
        "document_kind_label": "Type",
        "document_state_label": "Status",
        "document_classification_label": "Gradering",
        "document_source_label": "Kilde",
        "document_received_label": "Mottatt",
        "select_document": "Velg et dokument for å se detaljer.",
        "classifications": {
          "ordinary": "Ordinær",
          "sensitive": "Sensitiv (jf. fvl §13)"
        },
        "parties_heading": "Parter i saken",
        "applicant_role": "Søker",
        "company_role": "Foretak",
        "history_heading": "Saksforløp",
        "history_load_more": "Vis flere",
        "history_empty": "Ingen hendelser registrert ennå.",
        "history_loading": "Laster saksforløp …",
        "comments": {
          "title": "Interne notater",
          "add_placeholder": "Skriv et internt notat …",
          "submit": "Legg til",
          "empty": "Ingen interne notater på denne saken ennå.",
          "author_at": "%{author} · %{date}",
          "toast": {
            "added": "Notat lagt til.",
            "error": "Noe gikk galt. Prøv igjen."
          },
          "errors": {
            "blank": "Notatet kan ikke være tomt."
          }
        }
      },
      "payment": {
        "heading": "Behandlingsgebyr",
        "amount_label": "Beløp",
        "status_label": "Status",
        "not_applicable": "Ikke aktuelt",
        "statuses": {
          "unpaid": "Ubetalt",
          "paid": "Betalt",
          "credited": "Kreditert"
        },
        "references": {
          "transaction_id": "Transaksjons-id",
          "kid": "KID",
          "invoice_id": "Faktura-id"
        },
        "captured_at_label": "Betalt",
        "credited_at_label": "Kreditert"
      },
      "work_surface": {
        "preview": {
          "select": "Velg et dokument",
          "enlarge": "Forstørr",
          "none": "Ingen forhåndsvisning",
          "download": "Last ned",
          "unavailable": "Forhåndsvisning ikke tilgjengelig"
        },
        "confirm": {
          "title": "Bekreft handling",
          "body": "Vil du utføre denne handlingen?",
          "cancel": "Avbryt",
          "confirm": "Bekreft",
          "bodies": {
            "pick_up": "Saksbehandlingen starter, og saken tildeles deg. Dette registreres i historikken.",
            "prepare_decision": "Du kan ikke vurdere saken mer etter dette. Saken går videre til vedtak — gjør eventuelle endringer nå.",
            "documentation_received": "Når du bekrefter, registreres følgende:",
            "close": "Saken avsluttes og arkiveres. Klagefristen må ha løpt ut (fvl §29).",
            "notify": "Du registrerer underretningen nå, og klagefristen på tre uker regnes fra denne datoen (fvl §27 og §29). Etter §29 løper fristen fra underretningen kom fram til parten.",
            "withdraw": "Saken avsluttes som trukket. Et innbetalt behandlingsgebyr blir ikke refundert."
          },
          "details": {
            "documentation_received": {
              "case_state": "Saken flyttes fra «Avventer dokumentasjon» til «Under behandling».",
              "resolve_deficiency": "Dokumentasjonsmangelen «%{name}» markeres som løst.",
              "history": "Handlingen registreres i sakshistorikken."
            }
          }
        },
        "reference": {
          "menu_label": "Mer"
        },
        "pickup": {
          "heading": "Start saksbehandling",
          "body": "Saken er innsendt. Du kan starte saksbehandlingen eller be om dokumentasjon først."
        },
        "under_review": {
          "docs_heading": "Dokumenter",
          "checklist_heading": "Vilkårsvurdering"
        },
        "awaiting_documentation": {
          "heading": "Venter på dokumentasjon"
        },
        "decision": {
          "heading": "Vedtak",
          "awaiting_board": "Saken er sendt til nemnda og venter på behandling."
        },
        "decided": {
          "heading": "Vedtatt",
          "klagefrist": "Klagefrist",
          "notify_hint": "Underretning etter forvaltningsloven §27 — starter klagefristen på 3 uker",
          "notified_at": "Underrettet",
          "not_notified": "Ikke underrettet ennå"
        },
        "appeal": {
          "heading": "Klagebehandling"
        },
        "closed": {
          "heading": "Avsluttet sak"
        },
        "baseline": {
          "heading": "Saksbehandling"
        },
        "document_groups": {
          "practice_documentation": "Praksis",
          "education_documentation": "Utdanning",
          "correspondence_documentation": "Korrespondanse",
          "system_generated": "Generert",
          "other": "Andre dokumenter"
        },
        "doc_actions": {
          "open": "Åpne",
          "enlarge": "Forstørr",
          "download": "Last ned",
          "share": "Del med søker",
          "unshare": "Fjern deling",
          "shared_badge": "Delt med søker"
        },
        "unknown_state": "Ukjent status — viser kun oppsummering."
      },
      "placeholders": {
        "not_applicable": "Ikke aktuelt for denne sakstypen.",
        "saksflyt_viz": {
          "title": "Interaktiv saksflyt kommer senere",
          "body": "Den fulle tilstandsmaskinen med gyldige overganger og guards bygges i en senere leveranse. Tilgjengelige handlinger vises til venstre."
        },
        "ai_assist": {
          "title": "KI-assistanse kommer senere",
          "body": "Automatisk forslag til vurdering og vedtaksutkast er planlagt, men ikke aktivt ennå."
        },
        "journal_tab": {
          "title": "Journal kommer senere",
          "body": "Journalføring mot arkivet (Documaster/Noark) er ikke koblet på ennå."
        },
        "internal_notes": {
          "title": "Interne notater",
          "body": "Ingen interne notater på denne saken ennå."
        },
        "access_history": {
          "title": "Tilgangshistorikk kommer senere",
          "body": "Oversikt over hvem som har sett saken bygges i en senere leveranse."
        }
      },
      "intake": {
        "title": "Ny sak",
        "subtitle": "Registrer en papir- eller realkompetansesøknad på vegne av søkeren.",
        "breadcrumb_cases": "Saker",
        "breadcrumb_new": "Ny sak",
        "applicant_heading": "Søker",
        "full_name_label": "Navn",
        "full_name_hint": "Påkrevd. Oppgi søkerens fulle navn.",
        "email_label": "E-post",
        "email_hint": "Valgfritt. Brukes for å finne en eksisterende søker.",
        "national_id_label": "Fødselsnummer",
        "national_id_hint": "Valgfritt. Vi bruker nummeret til oppslag i Folkeregisteret. Vi lagrer det kryptert, viser det skjult og logger hver visning.",
        "national_id_invalid": "Oppgi et gyldig fødselsnummer med 11 siffer, eller la feltet stå tomt.",
        "freg_lookup_button": "Hent fra folkeregister",
        "freg_no_match": "Ingen treff i folkeregisteret. Fortsett med oppgitte opplysninger.",
        "freg_error": "Kunne ikke hente opplysninger fra Folkeregisteret. Prøv igjen eller fortsett med oppgitte opplysninger.",
        "error_summary": "Kontroller opplysningene",
        "general_error_label": "Saken kunne ikke opprettes",
        "case_heading": "Sak",
        "trade_label": "Fag",
        "trade_placeholder": "Velg fag",
        "kind_label": "Søknadstype",
        "notes_label": "Notater",
        "notes_placeholder": "Interne notater, f.eks. «Papirsøknad mottatt 2026-06-10».",
        "submit": "Opprett sak",
        "cancel": "Avbryt",
        "case_type_label": "Sakstype",
        "basis_label": "Søknadsgrunnlag",
        "party_type_label": "Part",
        "party_person": "Person",
        "party_company": "Bedrift",
        "name_label_person": "Navn på søker",
        "name_label_company": "Foretaksnavn",
        "name_too_short": "Oppgi navn på parten.",
        "org_number_label": "Org.nr",
        "org_number_hint": "9 siffer. Verifiseres mot Enhetsregisteret ved innsending.",
        "org_number_invalid": "Org.nr må være 9 siffer.",
        "assignee_label": "Tildel saksbehandler",
        "assignee_placeholder": "Til tildeling",
        "note_label": "Intern merknad",
        "note_optional": "valgfritt",
        "note_placeholder": "Kort notat om saken …",
        "deadline_label": "Behandlingsfrist",
        "deadline_preset_3w": "3 uker",
        "deadline_preset_6w": "6 uker",
        "deadline_preset_3m": "3 mnd",
        "deadline_due": "Forfaller %{date}",
        "errors": {
          "forbidden": "Du har ikke tilgang til å opprette saker.",
          "invalid_case_type": "Ugyldig sakstype.",
          "missing_party_identity": "Oppgi navn på parten.",
          "missing_organization_number": "Org.nr er påkrevd for bedrift.",
          "invalid_organization_number": "Skriv et gyldig organisasjonsnummer. Kontroller sifrene og prøv igjen.",
          "company_not_found": "Fant ikke foretaket i Enhetsregisteret.",
          "validation_failed": "Kunne ikke opprette saken. Kontroller feltene.",
          "generic": "Noe gikk galt. Prøv igjen."
        }
      }
    },
    "internal_users": {
      "validation": {
        "summary": "Kontroller opplysningene",
        "name_required": "Oppgi navn.",
        "email_required": "Oppgi e-postadresse.",
        "email_taken": "E-postadressen er allerede i bruk.",
        "role_invalid": "Velg en gyldig rolle.",
        "department_invalid": "Velg en gyldig avdeling."
      },
      "title": "Brukere",
      "new_user": "Ny bruker",
      "empty": "Ingen interne brukere ennå.",
      "columns": {
        "name": "Navn",
        "email": "E-post",
        "role": "Rolle",
        "department": "Avdeling",
        "active": "Status",
        "actions": "Handlinger"
      },
      "active_yes": "Aktiv",
      "active_no": "Inaktiv",
      "activate": "Aktiver",
      "deactivate": "Deaktiver",
      "deactivate_self_disabled": "Du kan ikke deaktivere din egen konto.",
      "deactivate_last_admin_disabled": "Kan ikke deaktivere den siste aktive administratoren.",
      "modal": {
        "create_title": "Ny bruker",
        "edit_title": "Rediger bruker",
        "name": "Navn",
        "email": "E-post",
        "role": "Rolle",
        "department": "Avdeling",
        "department_none": "Ingen avdeling",
        "save": "Lagre",
        "cancel": "Avbryt"
      },
      "toast": {
        "created": "Bruker opprettet.",
        "updated": "Bruker oppdatert.",
        "activated": "Bruker aktivert.",
        "deactivated": "Bruker deaktivert.",
        "error": "Noe gikk galt. Prøv igjen."
      }
    },
    "register": {
      "people": {
        "title": "Personregister",
        "search_placeholder": "Søk på navn eller e-post …",
        "filter_municipality": "Kommune",
        "filter_status": "Status",
        "filter_all": "Alle",
        "filter_has_mastership": "Mesterbrev",
        "filter_trade": "Fag",
        "filter_caseworker": "Saksbehandler",
        "filter_passive_reason": "Passiv-årsak",
        "has_mastership": {
          "all": "Alle",
          "yes": "Har mesterbrev",
          "no": "Uten mesterbrev"
        },
        "status": {
          "all": "Alle",
          "active": "Aktive",
          "passive": "Passive",
          "opted_out": "Reservert mot oppføring"
        },
        "empty": "Ingen personer funnet.",
        "result_count": "Viser %{shown} av %{total}",
        "load_more": "Vis flere",
        "paging_error": "Vi kunne ikke laste flere personer. Prøv igjen.",
        "paging_retry": "Prøv igjen",
        "columns": {
          "name": "Navn",
          "email": "E-post",
          "municipality": "Kommune",
          "masterships": "Mesterbrev",
          "status": "Status"
        },
        "badge": {
          "passive": "Passiv",
          "opted_out": "Reservert"
        },
        "visibility": {
          "listed": "Synlig i register",
          "hidden": "Skjult"
        },
        "view": {
          "table": "Tabell",
          "cards": "Kort"
        },
        "tabs": {
          "overview": "Oversikt",
          "masterships": "Mesterbrev",
          "cases": "Saker",
          "history": "Historikk",
          "comments": "Kommentarer",
          "communication": "Kommunikasjon",
          "company_memberships": "Bedriftstilknytning",
          "invoices": "Fakturaer"
        },
        "cases": {
          "empty": "Ingen saker registrert på denne personen.",
          "columns": {
            "case_number": "Saksnr.",
            "type": "Type",
            "trade": "Fag",
            "state": "Status",
            "date": "Registrert",
            "assigned_to": "Saksbehandler"
          },
          "unassigned": "Ikke tildelt"
        },
        "company_memberships": {
          "empty": "Ingen bedriftstilknytninger registrert på denne personen.",
          "ongoing": "Løpende",
          "status_active": "Aktiv",
          "status_ended": "Avsluttet",
          "status_revoked": "Trukket tilbake",
          "columns": {
            "company": "Bedrift",
            "trade": "Fag",
            "role": "Rolle",
            "position_percent": "Stillingsandel",
            "period": "Periode",
            "status": "Status"
          }
        },
        "comments_stub": "Kommentarer kommer i en senere leveranse.",
        "register_sourced": {
          "notice": "Hentet fra Folkeregisteret — kan ikke endres her.",
          "legal_name": "Juridisk navn",
          "address": "Adresse",
          "birth_date": "Fødselsdato",
          "deceased": "Død",
          "unavailable": "Ikke tilgjengelig"
        },
        "fields": {
          "email": "E-post",
          "gender": "Kjønn",
          "reference_number": "Referansenummer",
          "municipality": "Kommune",
          "passive_reason": "Passiv-årsak",
          "passivated_at": "Passivert",
          "comments_count": "Antall kommentarer"
        },
        "national_id": {
          "label": "Fødselsnummer",
          "unknown": "Ikke registrert",
          "reveal": "Vis",
          "copy": "Kopier",
          "hide": "Skjul",
          "copied": "Kopiert til utklippstavlen",
          "error": "Kunne ikke hente fødselsnummeret"
        },
        "masterships": {
          "empty": "Ingen mesterbrev registrert.",
          "trade": "Fag",
          "trade_group": "Fagområde",
          "state": "Status",
          "svennebrev": "Svennebrev",
          "granted_at": "Innvilget",
          "mesterbrev_sent_at": "Mesterbrev sendt",
          "lapsed_at": "Bortfalt",
          "revoked_at": "Tilbakekalt",
          "fee_paid_through": "Avgift betalt til",
          "arsgebyr": {
            "label": "Årsgebyr",
            "issue": "Send årsgebyr faktura",
            "credit": "Krediter faktura",
            "credit_prompt": "Oppgi årsak til kreditering:",
            "latest_invoice": "Siste faktura",
            "demand": "Påkrav sendt",
            "demand_channel": {
              "registered_mail": "rekommandert brev",
              "secure_electronic": "sikker elektronisk kanal"
            },
            "status": {
              "paid": "Betalt",
              "invoiced": "Fakturert",
              "overdue": "Forfalt",
              "lapsed": "Bortfalt",
              "none": "Ikke fakturert"
            },
            "toast": {
              "issued": "Årsgebyr fakturert",
              "credited": "Faktura kreditert",
              "error": "Kunne ikke fakturere årsgebyr"
            }
          }
        },
        "history": {
          "empty": "Ingen hendelser registrert.",
          "loading": "Laster historikk …",
          "load_more": "Last flere",
          "from_case": "Sak %{reference}"
        },
        "scheduled_notice": "Planlagt passivering %{date}",
        "invoices": {
          "original_invoice": "Gjelder faktura",
          "credited_at": "Kreditert dato",
          "help": "Årsgebyrer, behandlingsgebyrer og kreditnotaer registrert på personen, på tvers av fag og år. Kreditnotaer vises med negativt beløp og kan søkes opp med kreditnota-ID. Leverandørlenkene åpner portalen der du kan slå opp den viste referansen.",
          "kind": "Type",
          "all": "Alle oppføringer",
          "reference": "Fakturanummer / betalingsreferanse",
          "search_label": "Søk på fakturanummer, KID eller betalingsreferanse",
          "search": "Søk",
          "reset": "Nullstill",
          "paid_at": "Betalt dato",
          "manual": "Manuelt registrert",
          "tripletex": "Tripletex",
          "nexi": "Nexi",
          "attention": "Trenger oppfølging",
          "empty": "Ingen fakturaer eller betalinger i dette utvalget",
          "loading": "Laster fakturahistorikk …",
          "load_more": "Last inn flere",
          "retry": "Prøv igjen",
          "error": "Kunne ikke hente fakturahistorikken. Prøv igjen.",
          "count": "Viser %{count} av %{total} oppføringer",
          "kinds": {
            "credit_note": "Kreditnota",
            "annual_fee": "Årsgebyr",
            "processing_fee": "Behandlingsgebyr"
          },
          "statuses": {
            "draft": "Utkast",
            "sent": "Sendt – ikke betalt",
            "paid": "Betalt",
            "credited": "Kreditert",
            "awaiting_payment": "Venter på betaling",
            "refunded": "Tilbakebetalt"
          }
        }
      },
      "passivation": {
        "title": "Passivering",
        "set_passive": "Sett passiv",
        "reactivate": "Reaktiver",
        "reason_label": "Årsak",
        "reason_placeholder": "Velg årsak …",
        "current_passive": "Passiv",
        "current_active": "Aktiv",
        "scheduled_overdue": "Planlagt passivering %{date} — forfalt",
        "schedule": "Planlegg passivering",
        "reschedule": "Endre",
        "cancel_schedule": "Avbryt",
        "schedule_title": "Planlegg passivering",
        "schedule_date_label": "Dato",
        "schedule_submit": "Lagre",
        "cancel": "Avbryt",
        "confirm_passive": "Bekreft",
        "error_title": "Handlingen ble ikke utført",
        "errors": {
          "invalid_date": "Ugyldig dato. Bruk formatet dd.mm.åååå.",
          "invalid_reason": "Ugyldig årsak. Velg et av alternativene i listen.",
          "blank": "Feltet må fylles ut.",
          "invalid": "Ugyldig verdi."
        },
        "toast": {
          "passivated": "Person passivert.",
          "reactivated": "Person reaktivert.",
          "scheduled": "Passivering planlagt.",
          "rescheduled": "Planlagt passivering endret.",
          "cancelled": "Planlagt passivering avbrutt.",
          "error": "Noe gikk galt. Prøv igjen."
        }
      },
      "opt_out": {
        "label": "Reservert mot oppføring",
        "on": "Reservert",
        "off": "Ikke reservert",
        "set": "Reserver",
        "clear": "Fjern reservasjon",
        "error_title": "Handlingen ble ikke utført",
        "toast": {
          "set": "Reservasjon registrert.",
          "cleared": "Reservasjon fjernet.",
          "error": "Noe gikk galt. Prøv igjen."
        }
      },
      "comments": {
        "title": "Kommentarer",
        "add_placeholder": "Skriv en kommentar …",
        "submit": "Legg til",
        "empty": "Ingen kommentarer ennå.",
        "author_at": "%{author} · %{date}",
        "toast": {
          "added": "Kommentar lagt til.",
          "error": "Noe gikk galt. Prøv igjen."
        }
      },
      "export": {
        "button": "Eksporter persondata",
        "hint": "Last ned alle registrerte opplysninger om personen (GDPR)."
      },
      "review_tasks": {
        "title": "Kontrolloppgaver",
        "subtitle": "Endringer fra registeret som krever bekreftelse fra saksbehandler.",
        "empty": "Ingen åpne kontrolloppgaver.",
        "columns": {
          "subject": "Gjelder",
          "kind": "Type",
          "created_at": "Opprettet",
          "action": "Handling"
        },
        "subject": {
          "organization_number": "Org.nr. %{number}",
          "unknown": "Ukjent"
        },
        "resolve": "Bekreft",
        "modal": {
          "title": "Bekreft kontrolloppgave",
          "person_body": "Bekreft at kontrolloppgaven er behandlet. Oppgi rettslig grunnlag. Bekreftelsen tilbakekaller ikke firmatilknytninger.",
          "validation_summary": "Oppgi rettslig grunnlag",
          "body": "Bekreftelse tilbakekaller aktive firmatilknytninger for emnet. Oppgi rettslig grunnlag.",
          "legal_basis_label": "Rettslig grunnlag",
          "legal_basis_hint": "Påkrevd. Vis til vedtak, lovhjemmel eller registerendring.",
          "legal_basis_required": "Rettslig grunnlag er påkrevd.",
          "confirm": "Bekreft og tilbakekall",
          "cancel": "Avbryt"
        },
        "toast": {
          "resolved": "Kontrolloppgave bekreftet.",
          "error": "Noe gikk galt. Prøv igjen."
        },
        "payload": {
          "fields": {
            "name": "Navn",
            "address": "Adresse",
            "registry_presence": "Oppføring i Folkeregisteret"
          },
          "stored": "Lagret",
          "register": "I registeret",
          "confidence": "Nivå %{level}",
          "confidence_levels": {
            "high": "høy",
            "medium": "middels",
            "low": "lav"
          },
          "values": {
            "present": "Registrert",
            "not_found": "Ikke funnet"
          }
        }
      }
    },
    "login": {
      "title": "Logg inn",
      "cta": "Logg inn med arbeidsbruker"
    },
    "job_overview": {
      "refresh": "Oppdater",
      "refreshing": "Oppdaterer …",
      "refresh_failed": "Kunne ikke oppdatere jobboversikten. Prøv igjen.",
      "hostname": "Vertsmaskin",
      "no_workers_reported": "Ingen arbeidere er registrert i denne oversikten. Kontroller jobbsystemet.",
      "stale_workers_reported": "Én eller flere arbeidere har ikke meldt livstegn nylig. Andre arbeidere kan fortsatt behandle køene.",
      "title": "Jobber",
      "subtitle": "Status for bakgrunnsjobber, køer og planlagte kjøringer.",
      "unavailable_title": "Jobbsystemet er ikke tilgjengelig her",
      "unavailable_body": "Køen kjører bare i produksjon. I dette miljøet finnes ingen jobbtabeller å lese fra.",
      "workers_heading": "Arbeidere",
      "workers_empty": "Ingen arbeidere har meldt seg. Køen blir ikke tømt.",
      "worker_stale": "Svarer ikke",
      "worker_healthy": "Kjører",
      "last_heartbeat": "Siste livstegn",
      "queues_heading": "Køer",
      "queues_empty": "Ingen jobber i kø.",
      "queue_name": "Kø",
      "queue_ready": "Klare",
      "queue_scheduled": "Planlagte",
      "recurring_heading": "Planlagte kjøringer",
      "recurring_empty": "Ingen planlagte kjøringer er registrert.",
      "recurring_key": "Jobb",
      "recurring_schedule": "Plan",
      "recurring_last_run": "Sist kjørt",
      "never_run": "Aldri kjørt",
      "failed_heading": "Feilede jobber",
      "failed_empty": "Ingen feilede jobber.",
      "failed_job": "Jobb",
      "failed_queue": "Kø",
      "failed_error": "Feil",
      "failed_at": "Tidspunkt",
      "advanced": "Åpne Mission Control"
    },
    "templates": {
      "open_pdf": "Åpne PDF i ny fane"
    },
    "shell": {
      "identity": "%{name} · %{role}"
    },
    "profile": {
      "title": "Min profil",
      "account_heading": "Din konto",
      "name": "Navn",
      "email": "E-post",
      "no_email": "Ingen e-post registrert",
      "role": "Rolle",
      "no_role": "Ingen rolle registrert",
      "department": "Avdeling",
      "no_department": "Ingen avdeling",
      "account_note": "Du kan ikke endre kontoopplysningene dine her. Rolle og avdeling administreres av virksomheten din.",
      "settings_heading": "Personlige innstillinger",
      "language_heading": "Språk",
      "language_description": "Velg språket du vil bruke i løsningen.",
      "display_heading": "Visning og tilgjengelighet",
      "display_description": "Tilpass tema, tekststørrelse, avstand, kontrast og bevegelse.",
      "display_action": "Tilpass visningen",
      "settings_note": "Endringer i visningen brukes med en gang.",
      "help_heading": "Er noen opplysninger feil?",
      "help_body": "Kontakt den som administrerer brukertilgangen i virksomheten din. Navn og e-post kan også måtte rettes i innloggingsløsningen."
    },
    "regulation_checklist": {
      "heading": "Vurdering mot forskrift",
      "overlay_heading": "Vurdering av praksis",
      "empty_text": "Ingen forskriftssjekkliste gjelder for denne sakstypen.",
      "note_label": "Merknad",
      "state_labels": {
        "met": "Oppfylt",
        "not_met": "Ikke oppfylt",
        "not_applicable": "Ikke aktuelt",
        "needs_documentation": "Trenger dokumentasjon"
      },
      "finalize": {
        "button_label": "Ferdigstill vurdering",
        "blocked_warning": "Alle punkter må konkluderes før vurderingen kan ferdigstilles."
      }
    },
    "companies": {
      "title": "Firma",
      "search_label": "Søk etter firmanavn eller organisasjonsnummer",
      "empty": "Ingen firma funnet",
      "columns": {
        "name": "Firmanavn",
        "organization_number": "Org.nr.",
        "status": "Status",
        "municipality": "Kommune",
        "mesterbedrift": "Mesterbedrift",
        "active_masters": "Aktive mestere"
      },
      "mesterbedrift": {
        "qualified": "Mesterbedrift",
        "not_qualified": "Ikke mesterbedrift"
      },
      "register": {
        "title": "Registerdata",
        "owned_hint": "Registereide felt — kan ikke endres her. Hentet fra Enhetsregisteret (BRREG).",
        "synced_at": "Sist synkronisert",
        "never_synced": "Aldri synkronisert",
        "legal_name": "Firmanavn",
        "organization_number": "Organisasjonsnummer",
        "org_form": "Organisasjonsform",
        "status": "Status",
        "business_address": "Forretningsadresse",
        "municipality": "Kommune",
        "details": "Utfyllende BRREG-opplysninger",
        "industry_codes": "Næringskoder",
        "activity": "Virksomhetens aktivitet",
        "registered_on": "Registrert i Enhetsregisteret",
        "vat_registered": "Merverdiavgiftsregisteret",
        "enterprise_registered": "Foretaksregisteret",
        "registered": "Registrert",
        "not_registered": "Ikke registrert",
        "unknown": "Ikke oppgitt"
      },
      "refresh": {
        "button": "Oppdater fra BRREG",
        "changed_title": "Registerdata oppdatert",
        "changed_body": "Endrede felt: %{fields}",
        "unchanged_title": "Ingen endringer",
        "unchanged_body": "Firmaet er uendret i Enhetsregisteret.",
        "not_found_title": "Ikke funnet i Enhetsregisteret",
        "not_found_body": "Det er opprettet en kontrolloppgave for oppfølging.",
        "unreachable_title": "Enhetsregisteret er utilgjengelig",
        "unreachable_body": "Kunne ikke nå registeret. Prøv igjen om litt.",
        "error_title": "Oppdateringen feilet",
        "error_body": "Noe gikk galt. Prøv igjen."
      },
      "local": {
        "title": "Lokal kontaktinformasjon",
        "hint": "Disse feltene eies lokalt og kan endres her.",
        "contact_url": "Nettside",
        "contact_phone": "Telefon",
        "contact_email": "E-post",
        "display_address": "Visningsadresse",
        "save": "Lagre",
        "saved": "Endringene er lagret.",
        "error": "Kunne ikke lagre. Endringene er tilbakestilt."
      },
      "memberships": {
        "title": "Mestertilknytninger",
        "empty": "Ingen mestertilknytninger",
        "columns": {
          "mester": "Mester",
          "role": "Rolle",
          "position_percent": "Stillingsprosent",
          "period": "Periode",
          "status": "Status"
        },
        "ongoing": "løpende",
        "status_active": "Aktiv",
        "status_ended": "Avsluttet",
        "status_revoked": "Tilbakekalt"
      },
      "cases": {
        "title": "Saker",
        "empty": "Ingen tilknyttede saker",
        "columns": {
          "case_number": "Saksnummer",
          "kind": "Sakstype",
          "state": "Status"
        }
      },
      "review_tasks": {
        "title": "Åpne kontrolloppgaver",
        "empty": "Ingen åpne kontrolloppgaver",
        "view_all": "Gå til kontrolloppgaver"
      }
    },
    "membership_feed": {
      "title": "Firmatilknytninger",
      "subtitle": "Endringer i tilknytninger mellom mester og firma, på tvers av portal, saksbehandling og register.",
      "empty": "Ingen endringer i valgt tidsrom.",
      "columns": {
        "occurred_at": "Tidspunkt",
        "mester": "Mester",
        "company": "Firma",
        "change_type": "Endring",
        "source": "Kilde"
      },
      "window_label": "Tidsrom",
      "window_7": "Siste 7 dager",
      "window_14": "Siste 14 dager",
      "window_30": "Siste 30 dager",
      "sources": {
        "portal": "Portal",
        "caseworker": "Saksbehandler",
        "register": "Register",
        "system": "System"
      },
      "change_types": {
        "created": "Opprettet",
        "revoked": "Tilbakekalt"
      }
    },
    "people": {
      "refresh_register": {
        "button": "Oppdater fra DSF",
        "in_sync_title": "Samsvarer med Folkeregisteret",
        "in_sync_body": "Ingen avvik mellom lagrede opplysninger og registeret.",
        "discrepancy_title": "Avvik funnet",
        "discrepancy_body": "Det er opprettet kontrolloppgave(r) for avvikene.",
        "view_tasks": "Gå til kontrolloppgaver",
        "deceased_title": "Registrert død i Folkeregisteret",
        "deceased_body": "Det er opprettet en kontrolloppgave for oppfølging.",
        "not_found_title": "Ikke funnet i Folkeregisteret",
        "not_found_body": "Personen finnes ikke i registeret. Det er opprettet en kontrolloppgave for oppfølging.",
        "no_identifier_title": "Fødselsnummer er ikke tilgjengelig ennå",
        "no_identifier_body": "Plattformen lagrer ikke fødselsnummer, og oppslag mot Folkeregisteret er derfor ikke mulig for denne personen ennå.",
        "unreachable_title": "Folkeregisteret svarer ikke",
        "unreachable_body": "Kunne ikke nå registeret. Prøv igjen senere.",
        "error_title": "Oppdateringen feilet",
        "error_body": "Noe gikk galt. Prøv igjen."
      }
    },
    "sanctions": {
      "title": "Ulovlig bruk",
      "next_action": "Neste handling",
      "assess_response": "Vurder tilsvar",
      "open_documents": "Åpne dokumenter",
      "states": {
        "open": "Ikke behandlet",
        "in_progress": "Under vurdering",
        "awaiting_response": "Avventer tilbakemelding",
        "response_received": "Tilsvar mottatt",
        "closed": "Avsluttet"
      },
      "basis": "Saksgrunnlag",
      "company": "Innmeldt bedrift",
      "missing_company": "Denne eldre saken mangler bedrift. Registrer organisasjonsnummeret for å knytte riktig bedrift til saken.",
      "link_company": "Knytt bedrift til saken",
      "tip_text": "Originalt tips",
      "tip_received_on": "Mottaksdato for tipset",
      "original_tip_hint": "Tidligere versjoner bevares. Tipsopplysningene låses når varselet er sendt.",
      "tipster": "Tipser",
      "tipster_contact": "Tipserens kontaktopplysninger",
      "tipster_hint": "Valgfritt. Holdes atskilt fra bedriftens mottakeropplysninger og tas ikke med i varselet.",
      "category": "Hva gjelder forholdet?",
      "choose_category": "Velg kategori",
      "categories": {
        "mark": "Bruk av mestermerket",
        "title": "Bruk av mestertittel",
        "mark_and_title": "Bruk av mestermerket og -tittel",
        "other": "Annet"
      },
      "description": "Beskrivelse av forholdet",
      "assessment": "Saksbehandlers vurdering",
      "source_url": "Nettadresse til observasjonen",
      "observed_on": "Observasjonsdato",
      "evidence": "Dokumentasjon og tilsvar",
      "file": "Velg dokument eller bilde",
      "selected_file": "Valgt fil: %{filename}",
      "upload": "Last opp",
      "upload_error": "Kunne ikke laste opp. Kontroller filtype og størrelse. Tillatte filer er PDF, PNG, JPEG, TIFF og DOCX.",
      "notice_title": "Varsel om mulig gebyr",
      "notice_body": "Brevtekst",
      "notice_recipient": "Mottaker og adresse",
      "notice_hint": "Skriv og kontroller brevteksten. Kategori, beskrivelse, vurdering og mottaker må være lagret før varselet kan lages.",
      "preview": "Forhåndsvis varsel",
      "issue": "Lag PDF-varsel",
      "view_notice": "Åpne varselet",
      "register_dispatch": "Registrer utsending",
      "external_dispatch_hint": "Send brevet utenfor systemet først. Registrer deretter utsendelsen av dette dokumentet. Denne handlingen sender ikke brevet.",
      "sent_on": "Utsendelsesdato",
      "channel": "Utsendelseskanal",
      "channels": {
        "post": "Post",
        "email": "E-post"
      },
      "sent_notice": "Utsendt varsel",
      "follow_up_on": "Oppfølgingsdato",
      "default_follow_up": "Tomt felt gir tre uker fra utsendelsesdatoen.",
      "saving": "Lagrer …",
      "unsaved": "Endringer venter på lagring",
      "saved": "Alle endringer er lagret",
      "save_error": "Kunne ikke lagre siste endring. Kontroller opplysningene og prøv igjen. Teksten din er beholdt.",
      "conflict": "Saken er endret av en annen handling. Ta vare på teksten din og last inn saken på nytt.",
      "close_case": "Avslutt uten gebyr",
      "closure_reason": "Intern begrunnelse for avslutning",
      "closure_body": "Brevtekst til bedriften",
      "closure_recipient": "Mottaker og adresse for avslutningsbrevet",
      "form_changed": "Brevet eller saken er endret. Lukk dialogen og åpne handlingen på nytt før du fortsetter. Innholdet du har skrevet, er beholdt.",
      "closure": {
        "open_draft": "Åpne lokalt avslutningsutkast",
        "discard_draft": "Forkast lokalt avslutningsutkast",
        "title": "Avslutningsbrev",
        "hint": "Begrunnelsen er intern. Skriv selv brevteksten til bedriften. Klargjøring avslutter ikke saken; saken avsluttes når utsending av det godkjente brevet registreres.",
        "prepare": "Klargjør avslutningsbrev",
        "edit": "Rediger avslutningsbrev",
        "preview": "Forhåndsvis avslutningsbrev",
        "view_notice": "Åpne avslutningsbrevet",
        "register_dispatch": "Registrer utsending og avslutt",
        "without_letter": "Avslutt uten brev",
        "cancel": "Avbryt klargjøring",
        "sent": "Utsendt avslutningsbrev",
        "review": {
          "reviewer": "Godkjenner av avslutningsbrevet",
          "approve": "Godkjenn avslutningsbrevet"
        }
      },
      "responses": {
        "discard_draft": "Forkast tilsvarsutkast",
        "open_draft": "Åpne tilsvarsutkast",
        "resolve_before_close": "Registrer eller forkast tilsvarsutkastet før saken avsluttes.",
        "register": "Registrer tilsvar",
        "received_on": "Mottaksdato for tilsvaret",
        "summary": "Sammendrag av tilsvaret",
        "recorded_by": "Registrert av",
        "attachments_hint": "Vedlegg er valgfritt. Velg nye filer eller dokumenter som allerede er lastet opp på saken.",
        "files": "Velg filer",
        "remove_file": "Fjern %{filename}",
        "existing_documents": "Opplastede dokumenter",
        "open_summary": "Åpne sammendrag (PDF)",
        "refresh": "Oppdater saken",
        "conflict_hint": "Saken er endret. Oppdater saken før du prøver igjen. Tilsvaret og de valgte filene beholdes.",
        "refresh_error": "Kunne ikke oppdatere saken. Tilsvaret og de valgte filene er beholdt. Prøv å oppdatere igjen.",
        "unavailable_documents": "Noen valgte dokumenter er ikke lenger tilgjengelige som vedlegg. Fjern dem fra tilsvaret og velg eventuelt andre dokumenter før du registrerer.",
        "remove_document": "Fjern dokumentet %{filename}"
      },
      "review": {
        "title": "Godkjenning av varsel",
        "reviewer": "Godkjenner av varselet",
        "choose_reviewer": "Velg godkjenner",
        "request": "Send til godkjenning",
        "reassign": "Bytt godkjenner",
        "view_document": "Åpne PDF-en til godkjenning",
        "approve": "Godkjenn varselet",
        "comment": "Begrunnelse for retur",
        "return": "Returner for endringer",
        "status": {
          "pending": "Venter på godkjenning",
          "approved": "Godkjent",
          "returned": "Returnert for endringer",
          "outdated": "Innholdet er endret — send til godkjenning på nytt"
        }
      },
      "errors": {
        "closure_not_ready": "Lagre intern begrunnelse, brevtekst og mottaker først.",
        "closure_not_started": "Klargjør avslutningsbrevet først.",
        "closure_already_started": "Avslutningsbrevet er allerede under klargjøring. Last inn saken på nytt.",
        "closure_letter_required": "Saken krever et godkjent avslutningsbrev med registrert utsending.",
        "closure_not_approved": "Avslutningsbrevet må godkjennes før utsendingen kan registreres.",
        "invalid_closure_document": "PDF-en samsvarer ikke med det gjeldende avslutningsbrevet. Send til godkjenning på nytt.",
        "closure_generation_failed": "Kunne ikke lage avslutningsbrevet som PDF. Prøv igjen. Opplysningene dine er beholdt.",
        "closure_in_progress": "Avbryt klargjøringen av avslutningsbrevet før du fortsetter med varselet.",
        "notice_generation_failed": "Kunne ikke lage PDF-varselet. Prøv å sende til godkjenning igjen. Opplysningene dine er beholdt.",
        "response_not_allowed": "Tilsvar kan bare registreres på en åpen sak etter at varselet er sendt.",
        "invalid_response_date": "Mottaksdatoen må være fra og med utsendelsesdatoen til og med dagens dato.",
        "invalid_response_summary": "Skriv et sammendrag på maksimalt 30 000 tegn.",
        "invalid_response_documents": "Velg innkommende dokumenter på denne saken som ikke er trukket tilbake.",
        "forbidden": "Du har ikke tilgang til å utføre denne handlingen.",
        "invalid_source_url": "Skriv en gyldig nettadresse, for eksempel https://www.example.com.",
        "invalid_tip_received_on": "Skriv en gyldig mottaksdato for tipset.",
        "invalid_observed_on": "Skriv en gyldig observasjonsdato.",
        "invalid_follow_up_on": "Skriv en gyldig oppfølgingsdato.",
        "invalid_sent_date": "Skriv en gyldig utsendelsesdato.",
        "invalid_follow_up": "Oppfølgingsdatoen kan ikke være før utsendelsesdatoen.",
        "invalid_notice_document": "PDF-en samsvarer ikke med det gjeldende varselet. Send til godkjenning på nytt.",
        "notice_not_approved": "Varselet må godkjennes før utsendingen kan registreres.",
        "notice_not_ready": "Lagre kategori, beskrivelse, vurdering, brevtekst og mottaker først.",
        "invalid_reviewer": "Velg en annen aktiv seniorsaksbehandler eller administrator enn den som ber om godkjenning eller er tildelt saken.",
        "review_not_pending": "Brevet venter ikke lenger på godkjenning. Last inn saken på nytt.",
        "review_already_requested": "Det er allerede bedt om godkjenning av dette brevet.",
        "reason_required": "Skriv en begrunnelse før du fortsetter."
      }
    }
  },
  "portal": {
    "applications": {
      "feedback": {
        "help_button": "Vis hjelp: %{topic}",
        "save_failed": "Endringene kunne ikke lagres. Prøv igjen før du går videre.",
        "help_title": "Hjelp og dokumentasjonskrav",
        "foreign_certificate_title": "Utenlandsk fag-/svennebrev?",
        "foreign_certificate": "Utenlandsk fag- eller svennebrev må være godkjent av HK-dir. Last opp ditt originale fag-/svennebrev og godkjenningen fra HK-dir.",
        "optional_certificate": "Opplasting av fag-/svennebrev er valgfritt i denne søknaden.",
        "practice_title": "Praksiskrav:",
        "practice_rules": "minst 6 års praksis i faget eller minst 2 års praksis i faget etter svenneprøve/fagprøve",
        "practice_recency": "Som hovedregel må praksisen ligge innenfor siste 10-årsperiode.",
        "executive_practice_rules": "minst 6 års utøvende praksis i faget eller minst 2 års utøvende praksis i faget etter svenneprøve/fagprøve",
        "practice_documents": "Slik dokumenterer du praksis",
        "employed_title": "Ansatt",
        "employed_documents": "Ansatt? Legg ved attest fra arbeidsgiver(e) med arbeidsoppgaver, periode, stillingsprosent og signatur.",
        "company_title": "Er du daglig leder i et AS, legg ved:",
        "company_statement": "Uttalelse fra regnskapsfører, styreleder eller revisor. Uttalelsen må beskrive din rolle, stillingsprosent og varighet",
        "company_documents": "Firmaattest og årsregnskap",
        "sole_trader_title": "Driver du et Enkeltpersonforetak (ENK), legg ved:",
        "sole_trader_statement": "Uttalelse fra regnskapsfører eller revisor, eller",
        "sole_trader_documents": "Firmaattest og næringsspesifikasjon fra skattemelding for årene du ønsker å dokumentere praksis fra",
        "leadership_title": "Lederpraksis",
        "leadership_rules": "Du må dokumentere minst 6 års praksis innenfor de siste 10 årene som næringsdrivende eller leder i faget, med faglig og forretningsmessig ansvar.",
        "leadership_responsibility": "Å ha faglig og forretningsmessig ansvar innebærer som hovedregel at du driver egen håndverksbedrift i det aktuelle mesterfaget, eventuelt er øverste leder med ansvar for hele for bedriften. Det er i utgangspunktet formelle og registrerte roller som tillegges vekt i vurderingen av om du har faglig og forretningsmessig ansvar.",
        "leadership_exclusions": "De som ikke vil oppfylle dette kravet er f.eks.: håndverkere uten tilleggsansvar, prosjektledere med kun prosjektansvar, formenn, byggeledere, bas eller avdelingsledere. Personer med disse funksjonene kan derfor ikke søke om mesterbrev på bakgrunn av realkompetanse.",
        "leadership_full_time": "Antall år med praksis skal tilsvare praksis på full tid.",
        "leadership_certificate": "Attest/bekreftelse på praksis som leder",
        "financial_documents": "Næringsoppgave/næringsspesifikasjon/årsregnskap",
        "company_certificate": "Firmaattest",
        "employment_percentage": "Stillingsprosent",
        "percentage_invalid": "Oppgi en stillingsprosent større enn 0 og høyst 100.",
        "calendar_duration": "Kalenderlengde",
        "practice_upload": "Last opp praksisdokumentasjon for denne perioden. En samlet PDF er tillatt.",
        "practice_add_hint": "Registrer praksisperioden og velg «Legg til» for å laste opp dokumentasjon.",
        "provider": "Utdanningsaktør",
        "provider_placeholder": "Velg utdanningsaktør",
        "provider_required": "Velg utdanningsaktøren for mesterutdanningen.",
        "country": "Land utdanningen er fra",
        "foreign_education_title": "Utenlandsk mesterutdanning",
        "translations": "All dokumentasjon skal foreligge på norsk. Utenlandsk dokumentasjon må være oversatt av autorisert oversetter.",
        "norwegian_requirements_title": "Norske myndighetskrav og bransjestandarder",
        "norwegian_requirements": "Last opp dokumentasjon på at du har kompetanse i gjeldende norske myndighetskrav og bransjestandarder innen mesterfaget. Dette inkluderer lover, forskrifter og standarder. Dette kan bekreftes med uttalelse fra tidligere arbeidsgivere, kursbevis, vitnemål m.m.",
        "legacy_documents": "Tidligere opplastede dokumenter",
        "supplementary_documents": "Vedlegg til egenvurderingen",
        "self_assessment_upload": "Last opp samlet egenvurdering for fagområdet.",
        "self_assessment_templates": "Last ned maler for egenvurdering",
        "self_assessment_template_instruction": "Bruk Mesterbrevnemndas maler for egenvurdering, og legg ved dokumentasjon som støtter egenvurderingen under samme fagområde.",
        "exemption_title": "Fritak",
        "exemption_help_title": "Krav til fritak og dokumentasjon",
        "exemption_intro": "Du kan søke om fritak for hele eller deler av mesterutdanningen med bakgrunn i annen utdanning.",
        "exemption_requirements": "Da stilles følgende krav:",
        "exemption_level": "Utdanningen må i grove trekk samsvare med mesterutdanningen når det gjelder nivå og faglig innhold.",
        "exemption_leadership": "Utdanningen må som hovedregel gi lederkompetanse, og omfatte etablererkunnskap.",
        "exemption_grade": "Eksamen må bestås med karakter D eller bedre i fag som inngår i vurderingsgrunnlaget. I fag hvor det ikke avlegges eksamen må standpunktkarakteren tilfredsstille karakterkravet.",
        "exemption_recency": "Utdanningen må som hovedregel ikke være eldre enn 10 år på det tidspunktet det søkes om mesterbrev.",
        "exemption_documentation": "Dokumentasjonskrav:",
        "exemption_diploma": "Fullstendig vitnemål som viser emner, studiepoeng og oppnådd karakter.",
        "exemption_curriculum": "Emnebeskrivelser / fagplaner som viser læringsutbytte, innhold og nivå på utdanningen",
        "exemption_select": "Velg fagområdene eller modulene du søker fritak for.",
        "exemption_modules_hint": "Du kan søke fritak for hver enkelt modul innen bedriftsledelse. For faglig ledelse og faglig fordypning må hele det aktuelle fagområdet godkjennes.",
        "exemption_upload": "Last opp vitnemål og emnebeskrivelser/fagplaner som dokumenterer dette valget. En samlet PDF er tillatt.",
        "exemption_required": "Velg minst ett fagområde eller én modul, og legg ved dokumentasjon.",
        "exemption_fee": "Behandlingsgebyr for valgte fagområder",
        "business_management": "Hele fagområdet bedriftsledelse",
        "business_modules": "Moduler i bedriftsledelse",
        "business_modules_included": "Alle tre modulene inngår når du velger hele fagområdet bedriftsledelse.",
        "assessment_registered": "Egenvurdering registrert"
      },
      "education": {
        "types": {
          "master_education": "Vitnemål mesterutdanning",
          "foreign_master_certificate": "Kopi av det utenlandske mesterbrevet",
          "foreign_curriculum": "Kopi av den utenlandske mesterkvalifikasjonens studieplan",
          "master_exam_business_management": "Vitnemål mestereksamen i bedriftsledelse",
          "master_exam_technical_leadership_or_specialization": "Vitnemål mestereksamen i faglig ledelse og/eller faglig fordypning",
          "pre_approved_education": "Vitnemål fra utdanning godkjent av Mesterbrevnemnda (fagskole, NEAK)",
          "exemption_letter": "Brev fra Mesterbrevnemnda om fritak for mesterutdanning"
        },
        "heading": "Velg din utdanning",
        "upload_all_pages": "Last opp alle sidene i dokumentene du bruker som grunnlag.",
        "records": {
          "heading": "Utdanning %{number}",
          "summary": "Oppgitt utdanning",
          "institution": "Navn på utdanningssted",
          "program": "Utdanning / linje",
          "completed_on": "Fullført dato",
          "add": "Legg til utdanning",
          "remove": "Fjern utdanning",
          "diploma_required": "Last opp minst ett vitnemål for denne utdanningen. Ta med alle sidene.",
          "remove_documents_first": "Fjern vedleggene før du fjerner utdanningen eller velger bort typen. Oppføringer med tilbaketrukket dokumentasjon må beholdes.",
          "invalid_date": "Oppgi en gyldig fullføringsdato fra 1900 og frem til i dag.",
          "too_long": "Bruk høyst 200 tegn.",
          "complete_fields": "Fyll ut navn på utdanningssted, linje og fullføringsdato for hver utdanning."
        }
      },
      "missing": {
        "institution": "Utdanningsaktør for mesterutdanningen",
        "origin_country": "Land utdanningen er fra",
        "practice_entry_documents": "Dokumentasjon for hver praksisperiode",
        "norwegian_requirements": "Dokumentasjon på kompetanse i norske myndighetskrav og bransjestandarder",
        "exemption_subjects": "Fagområder eller moduler du søker fritak for",
        "exemption_documents": "Vitnemål og emnebeskrivelser/fagplaner for valgene du søker fritak for",
        "exemption_scope": "Omfang av fritak",
        "given_name": "Fornavn",
        "family_name": "Etternavn",
        "email": "E-post",
        "street_address": "Adresse",
        "postcode": "Postnr",
        "city": "Poststed",
        "country": "Land",
        "mobile_number": "Mobilnr",
        "country_code": "Landkode",
        "trade": "Fag",
        "passed_exam_date": "Dato for bestått prøve",
        "trade_certificate": "Fag-/svennebrev",
        "education_types": "Utdanning",
        "practice_entries": "Praksisperiode",
        "practice_entry_fields": "Opplysninger om praksisperiodene",
        "other_documentation_note": "Beskrivelse",
        "declaration_confirmed": "Egenerklæring",
        "third_party_verification_consent": "Samtykke til kontroll hos tredjepart",
        "practice_employed_entries": "Praksis i faget",
        "practice_employed_entry_fields": "Opplysninger om praksis i faget",
        "practice_employed_entry_documents": "Attester for praksis i faget",
        "leadership_practice_entries": "Praksis som næringsdrivende eller leder",
        "leadership_practice_entry_fields": "Opplysninger om lederpraksis",
        "leadership_practice_entry_documents": "Dokumentasjon på lederpraksis",
        "self_assessment_business_entries": "Egenvurdering i bedriftsledelse",
        "self_assessment_business_entry_fields": "Fagområde i bedriftsledelse",
        "self_assessment_business_entry_documents": "Dokumentasjon til egenvurdering i bedriftsledelse",
        "self_assessment_leadership_entries": "Egenvurdering i faglig ledelse",
        "self_assessment_leadership_entry_fields": "Fagområde i faglig ledelse",
        "self_assessment_leadership_entry_documents": "Dokumentasjon til egenvurdering i faglig ledelse",
        "self_assessment_specialization_entries": "Egenvurdering i faglig fordypning",
        "self_assessment_specialization_entry_fields": "Fagområde i faglig fordypning",
        "self_assessment_specialization_entry_documents": "Dokumentasjon til egenvurdering i faglig fordypning",
        "duplicate_entry_ids": "Unike referanser for dokumentasjonsoppføringene",
        "entries": "Oppføring",
        "entry_documents": "Vedlegg til oppføringene",
        "incomplete": "Ufullstendige opplysninger",
        "education_documents": "Vitnemål for hver utdanning og eventuelt fritaksbrev",
        "education_entry_fields": "Navn på utdanningssted, linje og fullføringsdato for hver utdanning"
      },
      "nav": {
        "my_applications": "Mine søknader"
      },
      "index": {
        "title": "Mine søknader",
        "empty": "Du har ingen søknader.",
        "empty_subtitle": "Du har ingen søknader ennå. Start en ny søknad for å søke om mesterbrev.",
        "new": "Ny søknad",
        "col_slug": "Saksnr.",
        "col_kind": "Type",
        "col_trade": "Fag",
        "col_state": "Status",
        "continue_draft": "Fortsett utkast"
      },
      "new": {
        "title": "Ny søknad",
        "start_action": "Start søknad",
        "error_summary": "Rett feilene før du starter søknaden",
        "errors": {
          "kind_required": "Velg hvilken søknad du vil starte.",
          "trade_required": "Velg faget du søker mesterbrev i.",
          "kind_unavailable": "Denne søknadstypen er ikke tilgjengelig. Velg en annen.",
          "trade_invalid": "Faget er ikke tilgjengelig. Velg et fag fra listen.",
          "general": "Søknaden kunne ikke opprettes"
        }
      },
      "edit": {
        "title": "Rediger søknad"
      },
      "wizard": {
        "title": "Din søknad",
        "error_summary": "Kontroller opplysningene",
        "back_to_menu": "Tilbake til menyen",
        "next": "Neste",
        "navigation_failed": "Steget kunne ikke forlates. Bekreft nye personopplysninger med lagringsknappen, eller vent til lagring og dokumentbehandling er ferdig og prøv igjen.",
        "save_section": "Lagre seksjonen",
        "incomplete_notice": "Fyll ut alle påkrevde steg før du sender inn søknaden.",
        "submitted_notice": "Søknaden er sendt inn.",
        "coming_soon": "Dette steget kommer snart.",
        "status": {
          "complete": "Registrert",
          "incomplete": "Må fullføres",
          "optional": "Valgfritt"
        },
        "steps": {
          "personal_and_declaration": "Personopplysninger og egenerklæring",
          "trade_and_practice": "Fag og praksis i faget",
          "leadership_practice": "Praksis som næringsdrivende eller leder",
          "self_assessment": "Egenvurdering",
          "exemption_scope": "Fritak",
          "self_assessment_business": "Bedriftsledelse – Egenvurdering",
          "self_assessment_leadership": "Faglig ledelse – Egenvurdering",
          "self_assessment_specialization": "Faglig fordypning – Egenvurdering",
          "self_declaration": "Egenerklæring",
          "business_registration": "Næringsoppgave/næringsspesifikasjon/årsregnskap",
          "company_certificate": "Firmaattest",
          "course_certificate": "Kurs og utdanning",
          "personal_details": "Personopplysninger",
          "trade": "Fag og fag-/svennebrev",
          "education": "Utdanning og innvilget fritak",
          "practice": "Praksis i faget",
          "other_documentation": "Tilleggsopplysninger (valgfritt)",
          "review": "Kontroller, betal og send inn",
          "practice_employed": "Praksis som ansatt",
          "other_relevant_information": "Annen relevant informasjon"
        },
        "short": {
          "personal_and_declaration": "Personopplysninger og egenerklæring",
          "trade_and_practice": "Fag og praksis",
          "leadership_practice": "Lederpraksis",
          "self_assessment": "Egenvurdering",
          "exemption_scope": "Fritak",
          "self_assessment_business": "Bedriftsledelse",
          "self_assessment_leadership": "Faglig ledelse",
          "self_assessment_specialization": "Faglig fordypning",
          "self_declaration": "Egenerklæring",
          "business_registration": "Næringsoppgaver",
          "company_certificate": "Firmaattest",
          "course_certificate": "Kurs",
          "personal_details": "Personopplysninger",
          "trade": "Fag",
          "education": "Utdanning",
          "practice": "Praksis",
          "other_documentation": "Tilleggsopplysninger",
          "review": "Innsending",
          "practice_employed": "Praksis (ansatt)",
          "other_relevant_information": "Annen info"
        },
        "steps_label": "Steg i søknaden",
        "steps_summary": "%{done} av %{total} steg fullført",
        "step_status": {
          "complete": "Fullført",
          "remaining": "Gjenstår",
          "optional": "Valgfritt"
        },
        "descriptions": {
          "exemption_scope": "Velg fagområdene eller modulene du søker fritak for, og last opp dokumentasjonen som hører til.",
          "self_assessment_business": "Last opp samlet egenvurdering i bedriftsledelse og vedleggene som hører til.",
          "self_assessment_leadership": "Velg modulen i faglig ledelse egenvurderingen din dekker.",
          "self_assessment_specialization": "Velg modulen i faglig fordypning egenvurderingen din dekker.",
          "self_declaration": "Bekreft egenerklæringen for å kunne sende inn søknaden.",
          "business_registration": "Last opp næringsoppgaver hvis du har praksis som personlig næringsdrivende.",
          "company_certificate": "Last opp firmaattest hvis du har praksis som personlig næringsdrivende.",
          "course_certificate": "Last opp dokumentasjon på relevante kurs og utdanning.",
          "personal_details": "Kontroller at opplysningene dine stemmer. Navn og adresse henter vi fra Folkeregisteret og må endres der. E-post og mobilnummer kan du endre selv.",
          "trade": "Velg faget du søker mesterbrev i, og oppgi dato for bestått fag-/svenneprøve.",
          "education": "Velg ett eller flere grunnlag. Du kan registrere mesterutdanning, annen godkjent utdanning og innvilget fritak i samme søknad. Hver utdanning må ha egne opplysninger og vitnemål.",
          "practice": "Registrer praksis opparbeidet som ansatt og/eller som selvstendig næringsdrivende.",
          "other_documentation": "Her kan du gi tilleggsopplysninger og legge ved dokumenter som ikke hører til de andre stegene. Dette er valgfritt.",
          "review": "Kontroller opplysningene, betal behandlingsgebyret og send inn søknaden.",
          "practice_employed": "Registrer praksis som ansatt i faget, med attest per arbeidssted.",
          "other_relevant_information": "Last opp annen dokumentasjon du mener er relevant for søknaden."
        }
      },
      "person": {
        "heading": "Personopplysninger",
        "given_name": "Fornavn",
        "middle_name": "Mellomnavn",
        "family_name": "Etternavn",
        "email": "E-post",
        "street_address": "Adresse",
        "co_address": "C/O-adresse",
        "postcode": "Postnr",
        "city": "Poststed",
        "country": "Land",
        "mobile_number": "Mobilnr",
        "country_code": "Landkode",
        "register_explain": "Navn og adresse henter vi fra Folkeregisteret, og de kan ikke endres her. Stemmer noe ikke, må du melde det til Folkeregisteret.",
        "register_missing": "Denne opplysningen har vi ikke fra Folkeregisteret ennå. Fyll den inn her, så bruker vi den i søknaden.",
        "contact_explain": "E-post og mobilnummer bruker vi til å kontakte deg om denne søknaden. Du kan endre dem her. Endringen gjelder bare denne søknaden."
      },
      "fag": {
        "passed_exam_date": "Dato for bestått prøve",
        "passed_exam_hint": "Oppgi dato for bestått praktisk prøve, ikke dato for utstedelse av fag-/svennebrev.",
        "certificate_upload_hint": "Last opp ditt fag-/svennebrev."
      },
      "praksis": {
        "role": "Rolle / stilling",
        "employment_percentage": "Stillingsprosent",
        "documentation": "Dokumentasjon for perioden",
        "documentation_hint": "Last opp dokumentasjon som underbygger opplysningene om denne praksisperioden.",
        "remove_documents_first": "Fjern dokumentene enkeltvis før du fjerner perioden. Perioder med tilbaketrukket dokumentasjon må beholdes.",
        "type_label": "Type praksis",
        "type_employed": "Ansatt",
        "type_self_employed": "Selvstendig næringsdrivende",
        "label_employed": "Arbeidssted",
        "label_self_employed": "Navn på egen bedrift",
        "from_month": "Fra måned",
        "from_year": "Fra år",
        "to_month": "Til måned",
        "to_year": "Til år",
        "from_date": "Fra dato",
        "to_date": "Til dato",
        "month_placeholder": "Velg måned",
        "months": {
          "m1": "Januar",
          "m2": "Februar",
          "m3": "Mars",
          "m4": "April",
          "m5": "Mai",
          "m6": "Juni",
          "m7": "Juli",
          "m8": "August",
          "m9": "September",
          "m10": "Oktober",
          "m11": "November",
          "m12": "Desember"
        },
        "duration": "Varighet: %{duration}",
        "total_duration": "Samlet praksistid: %{duration}.",
        "overlap_note": "Overlappende perioder telles bare én gang.",
        "ongoing_label": "Praksisen pågår fortsatt",
        "ongoing": "Pågående",
        "ongoing_hint": "Du trenger ikke oppgi sluttdato. Praksistiden beregnes til datoen du sender inn søknaden.",
        "as_of_note": "Praksistid beregnet til %{date}.",
        "duration_years": {
          "one": "%{count} år",
          "other": "%{count} år"
        },
        "duration_months": {
          "one": "%{count} måned",
          "other": "%{count} måneder"
        },
        "duration_days": {
          "one": "%{count} dag",
          "other": "%{count} dager"
        },
        "add_entry": "Legg til praksis",
        "remove": "Fjern",
        "empty": "Ingen praksis registrert ennå."
      },
      "annet": {
        "note_label": "Merknad (valgfritt)"
      },
      "show": {
        "title": "Søknad",
        "submit_action": "Send inn søknad",
        "slug": "Saksnummer",
        "trade": "Fag",
        "kind": "Type",
        "state": "Status",
        "documents_heading": "Dokumenter",
        "no_documents": "Ingen dokumenter.",
        "withdraw": "Trekk søknad",
        "withdraw_confirm": {
          "title": "Vil du trekke søknaden?",
          "body": "Vi avslutter saken og stopper behandlingen. Har du betalt behandlingsgebyr, får du ikke pengene tilbake. Vil du søke senere, må du sende en ny søknad.",
          "cancel": "Avbryt",
          "confirm": "Trekk søknad"
        },
        "withdraw_result": {
          "success": "Søknaden er trukket.",
          "invalid_state": "Du kan ikke lenger trekke denne søknaden. Oppdater siden for å se hvor saken står nå.",
          "failed": "Vi klarte ikke å trekke søknaden. Prøv igjen. Hjelper det ikke, kontakt oss på post@mesterbrev.no."
        },
        "summary": {
          "title": "Søknaden min",
          "back": "Tilbake til søknaden",
          "case_details": "Saksopplysninger",
          "submitted_details": "Opplysninger i søknaden",
          "no_details": "Ingen skjemafelter er registrert for denne søknaden. Se dokumentene nedenfor.",
          "documents_intro": "Her finner du dokumentene du har sendt inn, også det du har ettersendt.",
          "documentation_title": "Vi trenger mer dokumentasjon",
          "documentation_body": "Saksbehandleren har bedt om opplysningene nedenfor. Åpne forespørselen for å lese hele beskjeden og laste opp dokumenter.",
          "next_steps": "Hva skjer videre?",
          "draft_body": "Søknaden er et utkast og er ikke sendt til behandling. Fortsett å fylle ut søknaden når du er klar.",
          "withdrawn_body": "Søknaden er trukket og blir ikke behandlet videre. Opplysningene og dokumentene er fortsatt tilgjengelige her.",
          "closed_body": "Saken er avsluttet. Opplysningene og dokumentene er fortsatt tilgjengelige her.",
          "created_at": "Opprettet",
          "submitted_at": "Sendt inn",
          "closed_at": "Avsluttet",
          "not_submitted": "Ikke sendt inn",
          "document_count": "Innsendte dokumenter",
          "contact": "Kontaktopplysninger",
          "contact_intro": "Kontaktinformasjonen vi bruker for denne søknaden.",
          "certificate_title": "Fag-/svennebrev",
          "third_party_consent": "Samtykke til å innhente opplysninger fra tredjepart",
          "yes_label": "Ja",
          "no_label": "Nei"
        },
        "checklist": {
          "title": "Ettersend dokumentasjon",
          "intro": "Vi trenger flere dokumenter for å behandle søknaden din.",
          "deadline": "Frist for ettersending",
          "requested_count": {
            "one": "Én dokumenttype etterspurt",
            "other": "%{count} dokumenttyper etterspurt"
          },
          "document_number": "Dokumenttype %{number} av %{total}",
          "requested": "Etterspurt",
          "upload_hint": "Last opp dokumentasjonen saksbehandleren ber om ovenfor.",
          "upload_document": "Last opp %{document}",
          "immediate_upload": "Filene sendes til Mesterbrevnemnda med én gang du laster dem opp. Saksbehandler vurderer om dokumentasjonen er tilstrekkelig.",
          "upload_unavailable": "Søknaden tar ikke imot flere dokumenter nå. Kontakt oss på post@mesterbrev.no hvis du trenger hjelp.",
          "file_help": "PDF, JPG, PNG, TIFF eller Word (DOCX) · Maks 25 MB per fil",
          "existing_files": "Dokumenter i denne kategorien som er sendt inn",
          "received_at": "Mottatt %{date}",
          "history": "Tidligere innsendt og opplysninger om søknaden"
        },
        "deficiencies": {
          "title": "Dette mangler i søknaden din",
          "intro": "Saksbehandleren trenger mer fra deg før søknaden kan behandles ferdig. Send inn det som står her.",
          "documents_label": "Dokumenter vi ber om",
          "note_label": "Fra saksbehandleren",
          "due_at": "Frist: %{date}",
          "no_due_at": "Ingen frist er satt.",
          "overdue": "Fristen er gått ut. Send inn så snart du kan – vi tar fortsatt imot dokumentene.",
          "how_to": "Last opp dokumentene her. Saksbehandleren får dem med en gang. Er noe uklart, ta kontakt på post@mesterbrev.no."
        },
        "issued_documents_heading": "Dine offisielle dokumenter",
        "no_issued_documents": "Ingen offisielle dokumenter er utstedt ennå.",
        "shared_documents_heading": "Delt med deg",
        "download": "Last ned",
        "preview": "Forhåndsvis",
        "download_document": "Last ned %{document}",
        "preview_document": "Forhåndsvis %{document}",
        "requirement_response": {
          "title": "Dokumentasjon til søknaden",
          "intro": "Her ser du hva saksbehandleren har bedt om. Last opp dokumentene til riktig krav.",
          "received": "Dokumentasjon mottatt",
          "received_hint": "Saksbehandleren vurderer svaret. Du kan fortsatt legge til flere dokumenter her."
        }
      },
      "form": {
        "kind_label": "Søknadstype",
        "trade_label": "Fag",
        "trade_placeholder": "Velg fag",
        "kind_placeholder": "Velg søknadstype",
        "grounds_label": "Begrunnelse for særlige grunner",
        "grounds_placeholder": "Beskriv grunnlaget for dispensasjon",
        "save_draft": "Lagre utkast",
        "saving": "Lagrer…",
        "saved": "Lagret"
      },
      "kinds": {
        "ordinary_grant": "Mesterbrev – utdanning eller innvilget fritak",
        "prior_learning_assessment": "Realkompetansevurdering",
        "equivalent_education_exemption": "Annen utdanning / fritak",
        "foreign_qualification": "Mesterkvalifikasjon fra andre land",
        "special_grounds_dispensation": "Særlige grunner (dispensasjon)",
        "master_certificate_with_exemption_letter": "Mesterbrev med innvilget fritak",
        "exemption_from_master_education": "Fritak for mesterutdanning"
      },
      "chooser": {
        "heading": "Velg søknadsskjema",
        "instruction": "Kryss av for å komme til riktig søknadsskjema.",
        "unavailable": "Denne søknadstypen er ikke tilgjengelig for øyeblikket",
        "fee_from": "fra %{amount}",
        "options": {
          "ordinary_grant": {
            "label": "Mesterbrev – utdanning eller innvilget fritak",
            "examples": "For deg som har mesterutdanning, annen godkjent utdanning eller et brev om innvilget fritak. Du kan kombinere flere grunnlag i samme søknad."
          },
          "equivalent_education_exemption": {
            "label": "Andre godkjente utdanninger",
            "examples": "Fagskole, Norges eiendomsakademi, bachelorstudier"
          },
          "master_certificate_with_exemption_letter": {
            "label": "Søknad om mesterbrev med brev om innvilget fritak for mesterutdanningen",
            "examples": ""
          },
          "exemption_from_master_education": {
            "label": "Søknad om fritak for mesterutdanning",
            "examples": "For deg som søker om nytt fritak fra hele eller deler av mesterutdanningen. Har du allerede fått fritak og skal søke mesterbrev, velger du felles søknad om mesterbrev."
          },
          "foreign_qualification": {
            "label": "Søknad om mesterbrev med bakgrunn i mesterkvalifikasjon fra andre land",
            "examples": "Du dokumenterer mesterkvalifikasjonen fra et annet land, studieplanen og praksisen din."
          },
          "prior_learning_assessment": {
            "label": "Realkompetanse",
            "examples": "For deg som søker på grunnlag av praksis og realkompetanse. Søknaden omfatter praksis i faget, lederpraksis og egenvurdering."
          }
        }
      },
      "states": {
        "draft": "Utkast",
        "submitted": "Innsendt",
        "under_review": "Under behandling",
        "awaiting_documentation": "Venter på dokumentasjon",
        "ready_for_decision": "Klar for vedtak",
        "awaiting_board": "Venter på nemnda",
        "decided": "Avgjort",
        "closed": "Avsluttet",
        "withdrawn": "Trukket",
        "appeal_under_review": "Klage under behandling",
        "awaiting_payment": "Venter på betaling"
      },
      "payment": {
        "heading": "Betal behandlingsgebyr",
        "explanation": "Søknaden er klar til innsending. Betal behandlingsgebyret for å sende den til behandling.",
        "fee_label": "Behandlingsgebyr: %{amount}",
        "pay_action": "Betal behandlingsgebyr",
        "retry_message": "Betalingen ble ikke fullført. Prøv på nytt for å sende inn søknaden.",
        "paid_confirmation": "Behandlingsgebyret er betalt. Søknaden er sendt til behandling."
      },
      "errors": {
        "kind_blank": "Søknadstype må velges",
        "required": "Dette feltet er påkrevd",
        "email_invalid": "Oppgi en gyldig e-postadresse",
        "phone_invalid": "Oppgi et gyldig telefonnummer",
        "date_future": "Dato kan ikke være i fremtiden",
        "at_least_one": "Velg minst ett alternativ",
        "year_range": "Fra-år kan ikke være etter til-år",
        "trade_blank": "Fag må velges",
        "kind_invalid": "Ugyldig søknadstype",
        "trade_not_found": "Faget ble ikke funnet",
        "not_in_draft": "Søknaden kan ikke redigeres i nåværende tilstand",
        "submission_failed": "Innsending mislyktes — sjekk at alle påkrevde felt er fylt ut",
        "withdraw_failed": "Tilbaketrekking mislyktes",
        "missing_required_fields": "Manglende påkrevde felt for denne søknadstypen",
        "entry_needs_document": "Hver oppføring må ha minst ett vedlegg.",
        "practice_label_required": "Oppgi arbeidssted eller navn på egen bedrift.",
        "practice_year_required": "Oppgi både startår og sluttår.",
        "practice_year_future": "Årstall kan ikke være i fremtiden.",
        "practice_year_min": "Oppgi et årstall med fire siffer, for eksempel 2014.",
        "practice_month_required": "Velg måned.",
        "practice_date_required": "Oppgi dato. Sluttdato kan bare utelates når praksisen pågår fortsatt.",
        "practice_date_invalid": "Oppgi en gyldig dato. Pågående praksis skal ikke ha sluttdato.",
        "practice_role_invalid": "Oppgi rolle som tekst med høyst 200 tegn.",
        "practice_percentage_invalid": "Oppgi en stillingsprosent over 0 og høyst 100.",
        "practice_metadata_invalid": "Kontroller rolle og stillingsprosent. Rollen kan ha høyst 200 tegn, og stillingsprosenten må være over 0 og høyst 100.",
        "practice_save_failed": "Praksisen ble ikke lagret. Prøv igjen før du går videre.",
        "practice_date_future": "Datoen kan ikke være i fremtiden.",
        "practice_period_order": "Fra-dato kan ikke være etter til-dato.",
        "practice_period_future": "Perioden kan ikke slutte i fremtiden."
      },
      "exemption_scope": {
        "options": {
          "one_of_three": "Ett av tre fagområder",
          "two_of_three": "To av tre fagområder",
          "three_of_three": "Alle tre fagområdene"
        },
        "required": "Velg hvor mange fagområder du søker fritak for."
      },
      "review": {
        "status_heading": "Status",
        "summary": {
          "heading": "Dette sender du inn",
          "person": "Person",
          "trade": "Fag",
          "exam_date": "Dato for bestått prøve",
          "education": "Utdanning",
          "practice": "Praksis",
          "leadership_practice": "Praksis som næringsdrivende eller leder",
          "third_party_consent": "Samtykke til kontroll hos tredjepart",
          "answer_yes": "Ja",
          "answer_no": "Nei",
          "documents": "Dokumenter",
          "fee": "Behandlingsgebyr",
          "missing_label": "Mangler:",
          "none": "Ikke oppgitt"
        }
      },
      "receipt": {
        "title": "Kvittering",
        "banner": "Søknaden er sendt inn.",
        "submitted_at": "Innsendt",
        "fee_paid": "Behandlingsgebyr betalt",
        "paid_at": "Betalingsdato",
        "next_steps": "Vi har mottatt søknaden din. Du får beskjed under Meldinger når saken er behandlet.",
        "messages_link": "Gå til Meldinger"
      },
      "decision": {
        "title": "Vedtak",
        "outcome": "Utfall",
        "decided_by_body": "Vedtaksorgan",
        "issued_at": "Vedtaksdato",
        "notified_at": "Du fikk beskjed",
        "appeal_deadline_at": "Klagefrist",
        "appeal_guidance": "Du kan klage på vedtaket. Fristen er tre uker fra du fikk beskjed om vedtaket. Klagen sender du til Mesterbrevnemnda, som forbereder saken for Klagenemnda for mesterbrev. Vedtaksbrevet forklarer hvordan du klager og hvilken rett du har til innsyn i saken.",
        "documents_hint": "Vedtaksbrevet ligger under «Dine offisielle dokumenter» lenger ned på siden.",
        "outcomes": {
          "granted": "Innvilget",
          "partially_granted": "Delvis innvilget",
          "denied": "Avslått",
          "returned": "Returnert",
          "written_off": "Henlagt",
          "upheld": "Stadfestet",
          "overturned": "Omgjort",
          "partially_upheld": "Delvis stadfestet"
        },
        "bodies": {
          "secretariat": "Sekretariatet",
          "board": "Nemnda",
          "appeals_board": "Klagenemnda"
        }
      },
      "branch": {
        "exemption_count": "Antall fritak",
        "institution": "Utdanningsinstitusjon",
        "grade": "Karakter",
        "origin_country": "Opprinnelsesland",
        "translation_provided": "Oversettelse vedlagt",
        "self_assessment_uploaded": "Egenvurdering lastet opp",
        "grounds": "Begrunnelse"
      },
      "documents": {
        "delete": "Slett",
        "states": {
          "received": "Mottatt",
          "processing": "Behandles",
          "archived": "Arkivert",
          "failed": "Feilet"
        },
        "bundle": {
          "empty": "Ingen dokumenter lastet opp ennå.",
          "upload": "Last opp dokument",
          "choose": "Velg filer",
          "add": "Legg til dokumenter",
          "drop_hint": "eller dra én eller flere filer hit",
          "open": "Åpne",
          "uploaded_count": {
            "one": "Ett dokument lastet opp",
            "other": "%{count} dokumenter lastet opp"
          },
          "uploaded": "Lastet opp",
          "uploading": "Laster opp…",
          "received": "%{filename} er mottatt."
        },
        "errors": {
          "content_type_not_allowed": "Filtypen er ikke tillatt.",
          "file_too_large": "Filen er for stor.",
          "bundle_full": "Maksimalt antall filer er nådd.",
          "upload_failed": "Opplastingen mislyktes.",
          "save_before_upload": "Opplysningene ble ikke lagret. Prøv å laste opp på nytt.",
          "delete_failed": "Sletting mislyktes."
        },
        "kinds": {
          "practice_certificate": "Praksisattest",
          "diploma": "Vitnemål",
          "decision_pdf": "Vedtak (PDF)",
          "appeal_filing": "Klage",
          "board_minutes": "Møteprotokoll",
          "application_attachment": "Søknadsvedlegg",
          "prior_notice_pdf": "Forhåndsvarsel (PDF)",
          "preliminary_response_pdf": "Foreløpig svar (PDF)",
          "correspondence": "Korrespondanse",
          "assessment_note": "Vurderingsnotat",
          "master_certificate": "Mesterbrev",
          "application_summary": "Søknadssammendrag",
          "business_registration": "Næringsoppgave/næringsspesifikasjon/årsregnskap",
          "company_certificate": "Firmaattest",
          "course_certificate": "Kurs og utdanning",
          "trade_certificate": "Fag-/svennebrev",
          "self_assessment": "Egenvurdering",
          "documentation_request_letter": "Mangelbrev",
          "closure_letter": "Avslutningsbrev"
        },
        "upload": "Last opp"
      },
      "egenvurdering": {
        "business": {
          "guidance": "Beskriv kompetansen du har opparbeidet i bedriftsledelse, målt mot læringsutbyttene i studieplanen. Velg modulene egenvurderingen din dekker."
        },
        "leadership": {
          "guidance": "Beskriv kompetansen du har opparbeidet i faglig ledelse, målt mot læringsutbyttene i studieplanen."
        },
        "specialization": {
          "guidance": "Beskriv kompetansen du har opparbeidet i faglig fordypning for mesterfaget, målt mot læringsutbyttene i studieplanen."
        },
        "modules": {
          "organisation_leadership_administration": "Organisasjon, ledelse og administrasjon",
          "economy_management": "Økonomistyring",
          "marketing_management": "Markedsføringsledelse",
          "professional_leadership": "Faglig ledelse",
          "professional_specialization": "Faglig fordypning"
        }
      },
      "egenerklaering": {
        "confirm_label": "Jeg bekrefter herved at:",
        "point_read_forskrift": "jeg har lest forskrift om søknad om mesterbrev på bakgrunn av realkompetanse",
        "point_studied_outcomes": "jeg har satt meg inn i læreplanenes læringsutbytter og hovedtemaer",
        "point_covers_roles": "jeg i min egenvurdering beskriver egen erfaring og kompetanse i faget både som utøvende og næringsdrivende eller leder, med faglig og forretningsmessig ansvar",
        "point_docs_correct": "den dokumentasjonen jeg har lagt ved søknaden er korrekt",
        "point_plagiarism_check": "at den dokumentasjonen jeg har levert kan kontrolleres ved «plagiatkontroll»",
        "third_party_label": "Jeg gir Mesterbrevnemnda fullmakt til eventuelt å kontakte tredjepart for å verifisere dokumentasjonen som er vedlagt min søknad om mesterbrev.",
        "consequence": "Dersom det er gitt uriktige opplysninger i søknaden vil søknaden kunne avslås.",
        "confirmation_required": "Du må bekrefte egenerklæringen for å gå videre.",
        "consent_required": "Du må gi samtykke til kontroll hos tredjepart for å gå videre."
      },
      "realkompetanse": {
        "fields": {
          "arbeidssted": "Arbeidssted",
          "fra_aar": "Fra år",
          "til_aar": "Til år",
          "from_date": "Fra dato",
          "to_date": "Til dato",
          "firma": "Firma",
          "aar": "År",
          "beskrivelse": "Beskrivelse",
          "module": "Velg modul",
          "role": "Rolle"
        },
        "roles": {
          "self_employed": "Næringsdrivende",
          "leader": "Leder"
        },
        "self_assessment": {
          "template_required": "Du må bruke Mesterbrevnemndas mal når du skriver egenvurderingen. Malen blir tilgjengelig her når den er klar.",
          "supplementary_heading": "Supplerende dokumentasjon",
          "supplementary_description": "Du kan også legge ved dokumentasjon på relevante kurs, utdanning og andre opplysninger."
        }
      },
      "entry": {
        "add": "Legg til",
        "remove": "Fjern",
        "empty": "Ingen dokumenter lastet opp ennå.",
        "attachment_count": "%{count} vedlegg",
        "add_title": "Legg til oppføring",
        "cancel": "Avbryt"
      },
      "guidance": {
        "personal_and_declaration": "Kontroller at personopplysningene stemmer før du bekrefter egenerklæringen.",
        "trade_and_practice": "Last opp fag- eller svennebrevet ditt og attester som dokumenterer praksisen i faget, jf. forskriften § 2 a–b.",
        "leadership_practice": "Registrer praksis som næringsdrivende eller leder fra de siste ti årene. Legg ved minst ett relevant dokument for hver oppføring, for eksempel firmaattest, næringsoppgave eller attest, jf. forskriften § 2 c.",
        "self_assessment": "Fyll ut egenvurderingen for bedriftsledelse, faglig ledelse og faglig fordypning, jf. forskriften § 2 d. Legg ved egenvurderingen og dokumentasjonen som hører til hvert fagområde.",
        "practice_employed": "Krav til praksis, jf. forskrift om søknad om mesterbrev på bakgrunn av realkompetanse pkt. 2b. Praksiskrav er 2 års praksis i faget etter bestått fag-/svenneprøve, alternativt 6 års praksis i faget. Praksis som ansatt dokumenteres med attest fra arbeidsgiver. Fyll ut feltene på nytt for hvert arbeidssted.",
        "business_registration": "Krav til praksis som næringsdrivende eller leder, jf. pkt. 2c. Last opp næringsoppgaver (del 2) for 6 av de siste 10 årene for bedriften du har hatt forretningsmessig ansvar i.",
        "company_certificate": "Last opp firmaattester/registerutskrift fra Brønnøysundregisteret for 6 av de siste 10 årene — samme år og bedrift som næringsoppgavene.",
        "self_assessment_business": "Egenvurdering i fagområdet bedriftsledelse (studieplanens tre moduler: organisasjon/ledelse/administrasjon, økonomistyring, markedsføringsledelse). Beskriv kompetansen din målt mot læringsutbyttene. Dokumentasjonen skal være nummerert og det skal henvises til den i egenvurderingen.",
        "self_assessment_leadership": "Egenvurdering i fagområdet faglig ledelse. Beskriv kompetansen du har opparbeidet gjennom yrkeserfaring som leder, målt mot læringsutbyttene i studieplanen.",
        "self_assessment_specialization": "Egenvurdering i fagområdet faglig fordypning (tilpasset det enkelte mesterfag). Beskriv kompetansen målt mot læringsutbyttene i studieplanen.",
        "course_certificate": "Oppgi eventuelle kurs og utdanninger som er relevante for søknaden. Alle kurs/utdanninger må dokumenteres med beskrivelse av innhold og bevis på gjennomføring; for utdanninger legg ved studieplaner og karakterutskrift eller vitnemål.",
        "other_relevant_information": "Her kan du laste opp annen dokumentasjon som du mener er relevant for søknaden."
      },
      "unified": {
        "name": "Navn",
        "contact": "Kontaktopplysninger",
        "required": "Påkrevd"
      }
    },
    "account": {
      "mastership_states": {
        "awaiting_first_fee": "Venter på første årsgebyr",
        "granted": "Aktivt",
        "lapsed": "Bortfalt",
        "revoked": "Tilbakekalt",
        "revoked_administrative": "Tilbakekalt",
        "deceased": "Avsluttet",
        "passive": "Passivt"
      },
      "awaiting_first_fee_body": "Søknaden er innvilget. Mesterbrevet blir aktivt når betalingen av første årsgebyr er registrert. Fakturaen sendes separat.",
      "title": "Mine opplysninger",
      "name_label": "Navn",
      "masterships_heading": {
        "one": "Mitt mesterbrev",
        "other": "Mine mesterbrev"
      },
      "no_masterships": "Du har ingen registrerte mesterbrev.",
      "no_masterships_subtitle": "Når du har fått et mesterbrev, vises det her.",
      "preferences_heading": "Mine preferanser",
      "notification_channel_label": "Foretrukket kanal for varsler",
      "notification_channel_hint": "Gjelder e-post og SMS. Reservasjon i Kontakt- og reservasjonsregisteret gjelder uansett.",
      "notification_channel_none": "Ingen preferanse",
      "notification_channel_email": "E-post",
      "notification_channel_sms": "SMS",
      "notification_channel_saved": "Lagret",
      "notification_channel_error": "Kunne ikke lagre varslingskanalen. Prøv igjen.",
      "register_reservation": {
        "heading": "Oppføring i Mesterregisteret",
        "explanation": "Mesterregisteret er et offentlig søkbart register over mestere. Du kan reservere deg mot å stå oppført. Reservasjonen gjelder til du fjerner den, og påvirker ikke mesterbrevet ditt.",
        "status_listed": "Oppført i registeret",
        "status_not_listed": "Ikke oppført i registeret",
        "status_reserved": "Reservert mot oppføring",
        "reserve": "Reserver meg mot oppføring",
        "unreserve": "Fjern reservasjonen",
        "error": "Kunne ikke lagre reservasjonen. Prøv igjen."
      },
      "contact": {
        "heading": "Personopplysninger",
        "error_summary": "Rett opp disse feltene før du lagrer",
        "register_explain": "Navn og adresse henter vi fra Folkeregisteret, og de kan ikke endres her. Stemmer noe ikke, må du melde det til Folkeregisteret.",
        "register_missing": "Denne opplysningen har vi ikke fra Folkeregisteret ennå. Fyll den inn her, så bruker vi den.",
        "edit": "Rediger",
        "save": "Lagre",
        "cancel": "Avbryt",
        "saved": "Lagret",
        "error": "Kunne ikke lagre. Kontroller feltene og prøv igjen.",
        "empty": "—",
        "given_name": "Fornavn",
        "middle_name": "Mellomnavn",
        "family_name": "Etternavn",
        "street_address": "Adresse",
        "co_address": "C/O-adresse",
        "postcode": "Postnr",
        "city": "Poststed",
        "country": "Land",
        "email": "E-post",
        "mobile_number": "Mobilnummer",
        "country_code": "Landkode",
        "errors": {
          "invalid": "Dette ser ikke riktig ut. Sjekk hva du har skrevet.",
          "blank": "Feltet må fylles ut.",
          "too_long": "Teksten er for lang."
        }
      },
      "mastership_detail": {
        "master_number": "Mesternr",
        "granted_at": "Tildelt",
        "fee_paid_through": "Årsavgift betalt for",
        "svennebrev": "Svennebrev"
      },
      "master_mark": {
        "heading": "Mestermerket",
        "body": "Som aktiv mester kan du laste ned mestermerket og bruke det i din markedsføring.",
        "download": "Last ned mestermerket"
      },
      "invoices_heading": "Fakturaer",
      "invoices_empty": "Du har ingen fakturaer.",
      "invoice_period": "År %{year}",
      "invoice_amount": "Beløp",
      "invoice_status": "Status",
      "invoice_due_on": "Forfall",
      "invoice_kid": "KID",
      "invoice_fag": "Fag",
      "invoice_download": "Last ned faktura (PDF)",
      "invoice_download_unavailable": "Faktura-PDF er ikke tilgjengelig.",
      "invoice_download_error": "Vi kunne ikke hente fakturaen. Prøv igjen om litt.",
      "invoice_demo": {
        "title": "Demofaktura – ikke et betalingskrav",
        "body": "Dette er en eksempelfil fra testmiljøet. Fakturareferanse: %{reference}"
      },
      "invoice_payment": {
        "paid": "Betalt",
        "credited": "Kreditert",
        "unpaid": "Ikke betalt"
      }
    },
    "landing": {
      "can": {
        "apply": "Søke om mesterbrev, eller om fritak og godkjenning av utdanning fra andre land.",
        "track": "Følge søknaden din, laste opp dokumentasjon og lese vedtaket når det er fattet.",
        "company": "Melde fra om hvilket firma du er faglig leder for."
      },
      "idporten_note": "Du logger inn med ID-porten. Vi henter navn og adresse fra Folkeregisteret og kontaktopplysninger fra Kontaktregisteret — navn og adresse endres hos Folkeregisteret, e-post og mobilnummer kan du endre selv.",
      "title": "Mitt mesterbrev",
      "intro": "Velkommen til Mesterbrevnemndas selvbetjeningsportal. Her kan du se dine mesterbrev og meldinger fra nemnda.",
      "login_cta": "Logg inn"
    },
    "dashboard": {
      "title": "Min side",
      "greeting": "Hei, %{name}",
      "lede": {
        "new": "Her søker du om mesterbrev og følger saken din underveis.",
        "applicant": "Her følger du søknaden din og beskjeder fra Mesterbrevnemnda.",
        "master": "Her finner du mesterbrevet ditt og beskjeder fra Mesterbrevnemnda."
      },
      "status": {
        "new_title": "Du har ingen søknader ennå",
        "new_body": "Her kan du søke om mesterbrev, om fritak eller om godkjenning av utdanning fra andre land. Utkastet lagres automatisk, så du kan fylle ut litt av gangen.",
        "start": "Start ny søknad",
        "draft_title": "Du har et påbegynt utkast",
        "draft_progress": "%{done} av %{total} steg fullført",
        "draft_continue": "Fortsett utkastet",
        "draft_pay": "Betal gebyret og send inn",
        "in_progress_title": "Søknaden din er under behandling",
        "decided_title": "Søknaden din er avgjort",
        "documentation_title": "Vi venter på dokumentasjon fra deg",
        "documentation_body": "Saksbehandleren har bedt om mer dokumentasjon. Last den opp på søknaden.",
        "see_application": "Se søknaden og dokumentene dine",
        "stage": {
          "received": "Innsendt",
          "in_review": "Under behandling",
          "decided": "Vedtak"
        },
        "stage_done": "Fullført",
        "stage_current": "Nåværende steg",
        "master_title": "Mester i %{trade}",
        "master_number_short": "Mesternr %{number}",
        "granted_on": "Tildelt %{date}",
        "fee_paid_until": "Årsgebyr betalt til 31.12.%{year}",
        "fee_due": "Faktura for årsgebyr %{year} forfaller %{date}.",
        "fee_unpaid": "Årsgebyret for %{year} er ikke betalt.",
        "see_invoice": "Se faktura",
        "received_body": "Vi har mottatt søknaden din. Du får beskjed under Meldinger når saken er behandlet.",
        "decided_body": "Saken er avgjort. Vedtaket finner du under Mine dokumenter.",
        "case_number": "Saksnr. %{number}"
      },
      "tasks": {
        "heading": "Hva vil du gjøre?",
        "start": "Start ny søknad",
        "start_sub": "Mesterbrev, fritak eller godkjenning av utdanning fra andre land",
        "continue_draft": "Fortsett utkastet mitt",
        "continue_draft_sub": "%{done} av %{total} steg fullført",
        "see_application": "Se søknaden min",
        "see_application_sub": "Status, dokumenter og meldinger på saken",
        "documentation": "Send inn etterspurt dokumentasjon",
        "documentation_sub": "Saksbehandleren venter på deg",
        "notifications": "Les meldinger",
        "notifications_sub": "Beskjeder fra Mesterbrevnemnda",
        "documents": "Mine dokumenter",
        "documents_sub": "Vedtak og brev vi har sendt deg",
        "applications": "Se søknadene mine",
        "applications_sub": "Tidligere og pågående søknader",
        "invoices": "Se fakturaer",
        "invoices_sub": "Årsgebyr med forfall og KID",
        "master_mark": "Last ned mestermerket",
        "master_mark_sub": "Bruk merket i markedsføringen din som aktiv mester",
        "profile": "Se og endre opplysningene dine",
        "profile_sub": "Adresse, e-post, mobilnummer, varslingskanal og registeroppføring",
        "profile_sub_no_master": "Adresse, e-post, mobilnummer og varslingskanal",
        "company": "Meld firmatilknytning",
        "company_sub": "Meld fra om hvilket firma du er faglig leder for",
        "company_sub_no_master": "Krever registrert mesterbrev"
      }
    },
    "notifications": {
      "title": "Meldinger",
      "empty": "Du har ingen meldinger.",
      "empty_subtitle": "Når nemnda sender deg en melding, vises den her.",
      "mark_read": "Merk som lest",
      "read_error": "Kunne ikke merke meldingen som lest. Prøv igjen med «Merk som lest».",
      "mark_all_read": "Merk alle som lest",
      "loading": "Henter meldinger …",
      "menu_error": "Kunne ikke oppdatere meldingene. Lukk menyen og prøv igjen.",
      "unread": "Ulest",
      "context": {
        "application": "Søknad: %{kind}",
        "documentation_title": "Vi trenger %{documents}",
        "document_title": "Nytt dokument: %{document}",
        "deadline": "Frist %{date}"
      },
      "titles": {
        "mastership": {
          "granted": "Mesterbrev tildelt",
          "lapsed": "Mesterbrev bortfalt"
        },
        "case": {
          "submitted": "Søknad mottatt",
          "documentation_requested": "Vi trenger dokumentasjon",
          "decided": "Søknaden er avgjort"
        },
        "document": {
          "shared": "Nytt dokument"
        },
        "fallback": "Ny melding"
      },
      "unread_badge": "%{count} ulest",
      "templates": {
        "mastership": {
          "granted": "Mesterbrevet ditt er tildelt.",
          "lapsed": "Et av mesterbrevene dine er bortfalt."
        },
        "case": {
          "submitted": "Søknaden din er mottatt.",
          "documentation_requested": "Saksbehandleren trenger mer dokumentasjon fra deg.",
          "decided": "Søknaden din er avgjort."
        },
        "document": {
          "shared": "Et nytt dokument er tilgjengelig på Min side."
        },
        "fallback": "Du har en ny melding."
      }
    },
    "documents": {
      "title": "Mine dokumenter",
      "empty": "Du har ingen delte dokumenter.",
      "empty_subtitle": "Her samler vi dokumentene Mesterbrevnemnda har delt med deg i sakene dine. Når nemnda deler et dokument, finner du det her.",
      "case_link": "Gå til saken",
      "shared_on": "Delt %{date}",
      "case_types": {
        "application": "Søknad",
        "appeal": "Klage",
        "sanction": "Sanksjon",
        "change": "Endring",
        "access_request": "Innsynskrav"
      }
    },
    "nav": {
      "home": "Hjem",
      "account": "Min side",
      "notifications": "Meldinger",
      "company_membership": "Meld firmatilknytning",
      "documents": "Mine dokumenter",
      "back_to_min_side": "Tilbake til Min side",
      "bell_label": {
        "one": "Meldinger, 1 ulest",
        "other": "Meldinger, %{count} uleste"
      }
    },
    "footer": {
      "org": "© %{year} Mesterbrevnemnda",
      "nav_label": "Bunntekst",
      "personvern": "Personvernerklæring",
      "tilgjengelighet": "Tilgjengelighetserklæring",
      "kontakt": "Kontakt oss",
      "kontakt_email": "post@mesterbrev.no"
    },
    "accessibility": {
      "title": "Tilgjengelighetserklæring",
      "intro": "Mesterbrevnemnda arbeider for at «Mitt mesterbrev» og Mesterregisteret skal kunne brukes av alle. Denne siden beskriver hvor løsningen står i dag.",
      "status": {
        "heading": "Status",
        "body": "Løsningen er under utvikling og er ennå ikke fullt ut vurdert mot WCAG 2.1 nivå AA. En formell tilgjengelighetserklæring blir publisert på uustatus.no når vurderingen er gjennomført."
      },
      "known": {
        "heading": "Kjente mangler",
        "body": "Vi kjenner til at enkelte sider mangler overskrift, at noen skjemafelt kan være vanskelige å bruke med tastatur alene, og at kontrasten i enkelte statusmerker ikke er kontrollert. Vi retter dette fortløpende."
      },
      "feedback": {
        "heading": "Si fra om noe ikke virker",
        "body": "Får du ikke tak i informasjon eller utført noe du har rett til, vil vi gjerne høre fra deg. Vi svarer så raskt vi kan, og hjelper deg videre på en annen måte i mellomtiden.",
        "contact": "Kontakt: post@mesterbrev.no"
      }
    },
    "privacy": {
      "title": "Personvernerklæring",
      "intro": "Denne personvernerklæringen forklarer hvordan Mesterbrevnemnda behandler personopplysninger i søknadsportalen «Mitt mesterbrev», i saksbehandlingen og i det offentlige mesterregisteret.",
      "controller": {
        "heading": "Behandlingsansvarlig",
        "body": "Mesterbrevnemnda er behandlingsansvarlig for personopplysningene som behandles i denne løsningen. Nemnda er oppnevnt i medhold av lov om mesterbrev i håndverk og annen næring (mesterbrevloven).",
        "contact": "Kontakt: post@mesterbrev.no. Har du spørsmål om personvern, kan du henvende deg til oss på denne adressen."
      },
      "processing": {
        "heading": "Hvilke opplysninger vi behandler, og hvorfor",
        "login": "Innlogging. Du logger inn med ID-porten, for eksempel med BankID. Ved innlogging brukes fødselsnummeret ditt til å identifisere deg og til oppslag mot offentlige registre. Vi lagrer fødselsnummeret kryptert, slik at vi kan holde opplysningene dine oppdaterte mot Folkeregisteret og kjenne deg igjen hvis du søker på nytt. Bare saksbehandlere som trenger det, kan se nummeret, og hver visning blir logget.",
        "application": "Søknad om mesterbrev. Når du søker, behandler vi opplysningene du selv oppgir: navn, kontaktopplysninger, utdanning, praksis og vedlagte dokumenter som vitnemål og praksisattester. Formålet er å behandle søknaden din etter mesterbrevloven med forskrifter. Behandlingen er nødvendig for å utøve offentlig myndighet, jf. personvernforordningen artikkel 6 nr. 1 bokstav e.",
        "lookups": "Oppslag i offentlige registre. For å sikre riktige opplysninger henter vi navn og adresse fra Folkeregisteret, og digital kontaktinformasjon og reservasjonsstatus fra Kontakt- og reservasjonsregisteret (KRR). Opplysninger om firma hentes fra Enhetsregisteret.",
        "register": "Det offentlige mesterregisteret. Når du er tildelt mesterbrev, publiseres navnet ditt, faget og eventuell firmatilknytning i det offentlige mesterregisteret. Registeret gjør det mulig for allmennheten å kontrollere hvem som har gyldig mesterbrev, jf. mesterbrevloven § 1.",
        "fees": "Gebyrer og fakturering. Ved søknad betaler du behandlingsgebyr gjennom vår betalingsleverandør. Mestere faktureres årlig gebyr, og navn, adresse og fakturaopplysninger behandles i vårt regnskapssystem. Lagring av regnskapsmateriale følger bokføringsloven.",
        "notifications": "Varsler. Vi sender deg varsler om saken din på e-post eller SMS. Har du reservert deg mot digital kommunikasjon i KRR, respekteres dette, og du får informasjonen per brev.",
        "appeals": "Klagebehandling. Klager du på et vedtak, behandles klagen etter forvaltningsloven, og opplysningene i saken inngår i klagebehandlingen."
      },
      "retention": {
        "heading": "Arkivering, journalføring og lagringstid",
        "body": "Mesterbrevnemnda er et forvaltningsorgan. Saksdokumenter journalføres og arkiveres i samsvar med arkivlovgivningen, og kan derfor ikke slettes selv om saken er avsluttet. Opplysninger som ikke er arkivpliktige, lagres bare så lenge det er nødvendig for formålet."
      },
      "sharing": {
        "heading": "Hvem vi deler opplysninger med",
        "body": "Vi bruker databehandlere for drift av løsningen. Løsningen driftes i skytjenester med lagring i Norge. Arkivtjenesten leveres av Documaster, regnskapstjenesten av Tripletex, og betaling gjennomføres av vår betalingsleverandør. Databehandlerne behandler opplysninger bare etter avtale med nemnda og ikke for egne formål. Utover dette utleveres opplysninger bare der nemnda har rettslig plikt til det, for eksempel ved innsyn etter offentleglova, med de unntak som gjelder for taushetsbelagte opplysninger."
      },
      "rights": {
        "heading": "Dine rettigheter",
        "body": "Du har rett til innsyn i opplysningene vi behandler om deg, og rett til å få rettet uriktige opplysninger. Retten til sletting er begrenset av arkiv- og journalføringsplikten. Du kan også ha rett til begrensning av behandlingen. Henvend deg til kontaktpunktet over for å bruke rettighetene dine. Mener du at behandlingen er i strid med regelverket, kan du klage til Datatilsynet."
      },
      "cookies": {
        "heading": "Informasjonskapsler (cookies)",
        "body": "Løsningen bruker kun én nødvendig informasjonskapsel: en sesjonskapsel som holder deg innlogget. Den inneholder ikke sporingsinformasjon og slettes når sesjonen avsluttes. Vi bruker ingen analyse- eller markedsføringskapsler."
      },
      "changes": {
        "heading": "Endringer",
        "body": "Denne erklæringen oppdateres ved endringer i behandlingen. Vesentlige endringer varsles i portalen."
      }
    },
    "errors": {
      "not_found": {
        "title": "Fant ikke siden",
        "body": "Siden du leter etter finnes ikke, eller den er flyttet.",
        "back": "Til Min side"
      },
      "forbidden": {
        "title": "Ingen tilgang",
        "body": "Du har ikke tilgang til denne siden.",
        "back": "Til Min side"
      },
      "server_error": {
        "title": "Noe gikk galt",
        "body": "Det oppstod en uventet feil. Prøv igjen senere.",
        "back": "Til Min side"
      }
    },
    "company_membership": {
      "new": {
        "title": "Meld firmatilknytning",
        "intro": "Knytt et av dine fag til et firma som faglig leder eller annen rolle.",
        "mastership_label": "Fag (mesterbrev)",
        "company_label": "Organisasjonsnummer",
        "company_hint": "Oppgi organisasjonsnummeret til firmaet (9 siffer).",
        "lookup_found": "Firma: %{name}",
        "lookup_pending": "Henter firma fra Enhetsregisteret …",
        "validation_summary": "Kontroller feltene før du sender inn",
        "role_label": "Rolle",
        "position_label": "Stillingsprosent",
        "position_hint": "Andel av full stilling, mellom 1 og 100.",
        "position_hint_optional": "Andel av full stilling, mellom 1 og 100. Valgfritt for denne rollen.",
        "submit": "Send inn",
        "cancel": "Avbryt",
        "select_placeholder": "Velg…",
        "no_masterships": "Du har ingen fag å knytte til et firma.",
        "no_masterships_subtitle": "Du må ha minst ett mesterbrev før du kan melde en firmatilknytning.",
        "errors": {
          "required": "Feltet må fylles ut.",
          "invalid_organization_number": "Skriv et gyldig organisasjonsnummer. Kontroller sifrene og prøv igjen.",
          "company_not_found": "Fant ikke firmaet i Enhetsregisteret.",
          "register_unavailable": "Enhetsregisteret svarer ikke nå. Prøv igjen senere.",
          "position_percent_range": "Stillingsprosenten må være mellom 1 og 100.",
          "conflict": "Noen andre endret denne firmatilknytningen mens du fylte ut. Last siden på nytt og prøv igjen.",
          "failed": "Vi klarte ikke å registrere firmatilknytningen. Se om noe mangler i feltene over."
        }
      },
      "flash": {
        "created": "Firmatilknytning registrert for %{company}"
      }
    }
  },
  "auth": {
    "failed": "Innlogging mislyktes.",
    "entra": {
      "no_account": "Du har ikke tilgang til saksbehandlingsflaten. Kontakt sekretariatet for å få opprettet en bruker.",
      "identity_conflict": "Innloggingen kunne ikke fullføres. Sekretariatet har fått beskjed og følger opp.",
      "user_cancelled": "Innloggingen ble avbrutt. Prøv igjen."
    },
    "idporten": {
      "sign_in": "Logg inn med ID-porten",
      "acr_too_low": "Innloggingsnivået er for lavt. Prøv igjen med BankID eller annet godkjent nivå.",
      "user_cancelled": "Innloggingen ble avbrutt. Prøv igjen.",
      "logged_out": {
        "heading": "Du er logget ut",
        "body": "Du er nå logget ut av Mitt mesterbrev.",
        "login_again": "Logg inn igjen"
      }
    }
  },
  "events": {
    "invoice": {
      "credit_reconciled": {
        "title": "Kreditering bekreftet i Tripletex"
      },
      "transfer_confirmed": {
        "title": "Tripletex-overføring avklart"
      },
      "issued": {
        "title": "Faktura utstedt"
      },
      "sent": {
        "title": "Faktura sendt"
      },
      "paid": {
        "title": "Faktura betalt"
      },
      "reconciled": {
        "title": "Faktura avstemt"
      },
      "credited": {
        "title": "Faktura kreditert"
      },
      "error": {
        "title": "Fakturafeil"
      }
    },
    "billing_run": {
      "prepared": {
        "title": "Fakturagrunnlag kontrollert"
      },
      "started": {
        "title": "Fakturakjøring startet"
      },
      "completed": {
        "title": "Fakturakjøring ferdig behandlet"
      }
    },
    "case": {
      "deficiency_reviewed": {
        "title": "Dokumentasjonskrav behandlet"
      },
      "deficiency_supplement_requested": {
        "title": "Supplerende dokumentasjon etterspurt"
      },
      "assessment_saved": {
        "title": "Vurdering lagret"
      },
      "created": {
        "title": "Sak opprettet"
      },
      "submitted": {
        "title": "Søknad innsendt"
      },
      "picked_up": {
        "title": "Sak tatt til behandling"
      },
      "deficiency_registered": {
        "title": "Mangel registrert"
      },
      "documentation_requested": {
        "title": "Dokumentasjon etterspurt"
      },
      "documentation_received": {
        "title": "Dokumentasjon mottatt"
      },
      "decision_prepared": {
        "title": "Vedtak forberedt"
      },
      "referred_to_board": {
        "title": "Henvist til nemnda"
      },
      "advance_notice_sent": {
        "title": "Forhåndsvarsel sendt"
      },
      "decided": {
        "title": "Vedtak fattet"
      },
      "notified": {
        "title": "Underretning registrert"
      },
      "closed": {
        "title": "Sak avsluttet"
      },
      "withdrawn": {
        "title": "Søknad trukket"
      },
      "written_off": {
        "title": "Sak avskrevet"
      },
      "appeal_filed": {
        "title": "Klage registrert"
      },
      "reopened": {
        "title": "Sak gjenåpnet"
      },
      "transitioned": {
        "title": "Statusendring"
      },
      "list_exported": {
        "title": "Saksliste eksportert"
      },
      "sanction_closure_prepared": {
        "title": "Avslutningsbrev klargjort"
      },
      "sanction_closure_review_requested": {
        "title": "Avslutningsbrev sendt til godkjenning"
      },
      "sanction_closure_approved": {
        "title": "Avslutningsbrev godkjent"
      },
      "sanction_closure_returned": {
        "title": "Avslutningsbrev returnert for endringer"
      },
      "sanction_closure_dispatched": {
        "title": "Avslutningsbrev sendt og saken avsluttet"
      },
      "sanction_closure_cancelled": {
        "title": "Klargjøring av avslutningsbrev avbrutt"
      },
      "sanction_response_recorded": {
        "title": "Tilsvar registrert"
      },
      "sanction_notice_review_requested": {
        "title": "Varsel sendt til godkjenning"
      },
      "sanction_notice_approved": {
        "title": "Varsel godkjent"
      },
      "sanction_notice_returned": {
        "title": "Varsel returnert for endringer"
      },
      "sanction_updated": {
        "title": "Saksgrunnlag eller oppfølging oppdatert"
      },
      "sanction_notice_recorded": {
        "title": "Utsending av varsel om mulig gebyr registrert"
      },
      "sanction_closed": {
        "title": "Sak om ulovlig bruk avsluttet uten gebyr"
      }
    },
    "document": {
      "withdrawn": {
        "title": "Dokument trukket"
      },
      "issued": {
        "title": "Dokument utstedt"
      },
      "uploaded": {
        "title": "Dokument lastet opp"
      },
      "shared_with_applicant": {
        "title": "Dokument delt med søker"
      },
      "unshared_with_applicant": {
        "title": "Deling med søker fjernet"
      },
      "archival_started": {
        "title": "Arkivering av dokument startet"
      },
      "archived": {
        "title": "Dokument arkivert"
      },
      "archival_failed": {
        "title": "Arkivering av dokument mislyktes"
      }
    },
    "comment": {
      "added": {
        "title": "Kommentar lagt til"
      }
    },
    "user": {
      "passivated": {
        "title": "Satt passiv"
      },
      "reactivated": {
        "title": "Reaktivert"
      },
      "passivation_scheduled": {
        "title": "Passivering planlagt"
      },
      "passivation_rescheduled": {
        "title": "Passivering omplanlagt"
      },
      "passivation_cancelled": {
        "title": "Planlagt passivering avbrutt"
      },
      "data_exported": {
        "title": "Persondata eksportert"
      },
      "register_opt_out_changed": {
        "title": "Registerreservasjon endret"
      },
      "national_id_recorded": {
        "title": "Fødselsnummer registrert"
      },
      "national_id_revealed": {
        "title": "Fødselsnummer vist"
      },
      "national_id_copied": {
        "title": "Fødselsnummer kopiert"
      },
      "national_id_access_refused": {
        "title": "Innsyn i fødselsnummer avvist"
      }
    },
    "mastership": {
      "became_current": {
        "title": "Aktiv i Mesterregisteret"
      },
      "demand_sent": {
        "title": "Krav om årsavgift sendt"
      },
      "fee_paid_still_lapsed": {
        "title": "Årsavgift betalt – fortsatt bortfalt"
      },
      "lapsed": {
        "title": "Mesterbrev bortfalt"
      },
      "marked_deceased": {
        "title": "Markert som død"
      },
      "reinstated": {
        "title": "Mesterbrev gjeninnsatt"
      },
      "revoked": {
        "title": "Mesterbrev tilbakekalt"
      },
      "revoked_administrative": {
        "title": "Mesterbrev tilbakekalt (administrativt)"
      }
    },
    "archive": {
      "case_opened": {
        "title": "Saksmappe opprettet i arkivet"
      },
      "case_attached": {
        "title": "Koblet til eksisterende saksmappe"
      },
      "case_closed": {
        "title": "Saksmappe avsluttet i arkivet"
      },
      "case_reopened": {
        "title": "Saksmappe gjenåpnet i arkivet"
      },
      "bundle_stored": {
        "title": "Dokumentpakke journalført"
      },
      "records_pulled": {
        "title": "Journalposter hentet fra arkivet"
      },
      "legacy_import": {
        "title": "Historisk arkivsak importert"
      },
      "sync_failed": {
        "title": "Arkivering mislyktes"
      },
      "sync_retried": {
        "title": "Arkivering forsøkt på nytt"
      },
      "sync_drift_detected": {
        "title": "Avvik mot arkivet oppdaget"
      },
      "dead_letter": {
        "title": "Arkivering satt til manuell oppfølging"
      }
    },
    "auth": {
      "login_succeeded": {
        "title": "Logget inn"
      },
      "logged_out": {
        "title": "Logget ut"
      },
      "login_failed": {
        "title": "Innlogging mislyktes"
      },
      "acr_too_low": {
        "title": "Innlogging avvist – for lavt sikkerhetsnivå"
      },
      "token_validation_failed": {
        "title": "Tokenvalidering mislyktes"
      },
      "m2m_token_minted": {
        "title": "Maskinporten-token utstedt"
      }
    },
    "company": {
      "brreg_snapshot_updated": {
        "title": "Firmaopplysninger oppdatert fra Enhetsregisteret"
      }
    },
    "company_membership": {
      "created": {
        "title": "Firmatilknytning registrert"
      },
      "revoked": {
        "title": "Firmatilknytning avsluttet"
      }
    },
    "notification": {
      "dispatched": {
        "title": "Varsel sendt"
      },
      "delivered": {
        "title": "Varsel levert"
      },
      "failed": {
        "title": "Varsel mislyktes"
      },
      "retried": {
        "title": "Varsel forsøkt sendt på nytt"
      },
      "routed_to_paper": {
        "title": "Varsel sendt til papirutsending"
      }
    },
    "payment": {
      "requested": {
        "title": "Krav om behandlingsgebyr opprettet"
      },
      "captured": {
        "title": "Behandlingsgebyr betalt"
      },
      "manually_registered": {
        "title": "Behandlingsgebyr registrert manuelt"
      },
      "credited": {
        "title": "Behandlingsgebyr refundert"
      },
      "capture_orphaned": {
        "title": "Betaling satt til manuell oppfølging"
      }
    },
    "review_task": {
      "created": {
        "title": "Kontrolloppgave opprettet"
      },
      "resolved": {
        "title": "Kontrolloppgave løst"
      }
    },
    "public_register": {
      "refresh_started": {
        "title": "Oppdatering av Mesterregisteret startet"
      },
      "refresh_completed": {
        "title": "Oppdatering av Mesterregisteret fullført"
      }
    },
    "register": {
      "brreg_sweep_completed": {
        "title": "Registersjekk mot Enhetsregisteret fullført"
      },
      "freg_sweep_completed": {
        "title": "Registersjekk mot Folkeregisteret fullført"
      }
    },
    "municipality": {
      "list_refreshed": {
        "title": "Kommuneliste oppdatert"
      }
    },
    "trade_group": {
      "list_refreshed": {
        "title": "Faggruppeliste oppdatert"
      }
    },
    "report": {
      "exported": {
        "title": "Rapport eksportert"
      }
    },
    "setting": {
      "changed": {
        "title": "Innstilling endret"
      }
    },
    "system": {
      "bootstrap": {
        "title": "Systemet initialisert"
      },
      "config_validated": {
        "title": "Konfigurasjon validert"
      }
    },
    "verifier": {
      "ok": {
        "title": "Hendelseslogg verifisert"
      },
      "break_detected": {
        "title": "Brudd i hendelsesloggen oppdaget"
      }
    },
    "letter": {
      "dispatch_requested": {
        "title": "Brev publisert og varsling bestilt"
      },
      "paper_sent": {
        "title": "Papirutsending registrert"
      },
      "receipt_recorded": {
        "title": "Brevmottak registrert"
      },
      "draft_saved": {
        "title": "Brevutkast lagret"
      }
    },
    "document_template": {
      "changed": {
        "title": "Brevmal endret"
      }
    }
  },
  "locale_name": {
    "nb": "Norsk (bokmål)",
    "nn": "Norsk (nynorsk)",
    "en": "English"
  },
  "locale_switcher": {
    "label": "Velg språk"
  },
  "app": {
    "name": "Mesterbrev"
  },
  "common": {
    "skip_to_content": "Hopp til hovedinnhold",
    "errors": {
      "not_found": {
        "title": "Fant ikke siden",
        "body": "Siden du leter etter finnes ikke, eller den er flyttet.",
        "back": "Til forsiden"
      }
    }
  },
  "greeting": "Hei %{name}",
  "items": {
    "one": "%{count} element",
    "other": "%{count} elementer"
  },
  "only_nb": "Berre bokmål",
  "chrome": {
    "combobox": {
      "open": "Vis valg for %{label}",
      "close": "Skjul valg for %{label}",
      "clear": "Nullstill %{label}",
      "remove": "Fjern %{label}",
      "results": "Tilgjengelige valg: %{count}.",
      "selected": "Valgt: %{count}."
    },
    "dialog": {
      "label": "Dialogvindu",
      "panel_label": "Sidepanel"
    },
    "table": {
      "select_all": "Velg alle rader",
      "select_row": "Velg rad %{id}",
      "resize_column": "Endre bredden på kolonnen %{column}",
      "scroll_hint": "Rull sidelengs for å se alle kolonnene."
    },
    "document_strip": {
      "previous": "Vis tidligere dokumenter",
      "next": "Vis flere dokumenter"
    },
    "topbar": {
      "search_placeholder": "Søk saker, personer, bedrifter…",
      "search_hint": "Søk i saker og sider",
      "search_shortcut": "⌘ K",
      "search_no_results": "Ingen treff for «%{query}»",
      "search_group_cases": "Saker",
      "search_group_people": "Personer",
      "search_group_companies": "Bedrifter",
      "search_group_documents": "Dokumenter",
      "search_group_pages": "Gå til",
      "user_menu_label": "Brukermeny",
      "display_settings": "Visning og tema",
      "display_settings_readability": "Visning",
      "help": "Hjelp og lovgrunnlag",
      "profile": "Min profil",
      "switch_role": "Bytt rolle/enhet",
      "sign_out": "Logg ut"
    },
    "sidebar": {
      "collapse": "Skjul meny",
      "expand": "Vis meny",
      "resize": "Endre bredden på menyen"
    },
    "nav": {
      "label": "Navigasjon",
      "groups": {
        "cases": "Saksbehandling"
      }
    },
    "toast": {
      "dismiss": "Lukk varsel"
    },
    "breadcrumb": {
      "label": "Brødsmule"
    },
    "actions": {
      "close": "Lukk",
      "reset_to_default": "Tilbakestill til standard"
    },
    "filter_bar": {
      "filters": "Filtre",
      "clear_all": "Nullstill filtre"
    }
  },
  "register": {
    "brand_subtitle": "Mesterregisteret",
    "retired": {
      "title": "Mesterregisteret er flyttet",
      "body": "Denne visningen av Mesterregisteret er avviklet. Du finner registeret på mesterbrev.no.",
      "link": "Gå til mesterbrev.no"
    },
    "landing": {
      "title": "Mesterregisteret",
      "intro": "Søk etter mestere og mesterbedrifter registrert hos Mesterbrevnemnda.",
      "search_cta": "Søk i registeret"
    },
    "errors": {
      "not_found": {
        "title": "Fant ikke siden",
        "body": "Siden du leter etter finnes ikke, eller den er flyttet.",
        "back": "Til forsiden"
      }
    },
    "trade_groups": {
      "byggfag": "Byggfag",
      "mat_og_servicefag": "Mat- og servicefag",
      "designfag": "Designfag",
      "ovrige_handverksfag": "Øvrige håndverksfag"
    },
    "lookup": {
      "title": "Søk i Mesterregisteret",
      "intro": "Søk etter mestere og mesterbedrifter. Du kan filtrere på fag, fagområde, kommune og fylke.",
      "search_label": "Søk",
      "search_placeholder": "Navn, fag eller organisasjonsnummer",
      "search_hint": "Søk på navn, fag eller organisasjonsnummer.",
      "kind_label": "Type",
      "kind_all": "Alle",
      "kind_mester": "Mester",
      "kind_mesterbedrift": "Mesterbedrift",
      "trade_group_label": "Fagområde",
      "trade_label": "Fag",
      "county_label": "Fylke",
      "municipality_label": "Kommune",
      "municipality_hint": "Velg fylke først",
      "facet_all": "Alle",
      "filters_heading": "Filtre",
      "results_heading": "Treff",
      "result_count": "Viser %{shown} av om lag %{total} treff",
      "result_count_exact": "Viser %{shown} av %{total} treff",
      "load_more": "Vis flere",
      "loading": "Laster…",
      "col_name": "Navn",
      "col_kind": "Type",
      "col_trades": "Fag",
      "col_place": "Sted",
      "empty_title": "Ingen treff",
      "empty_subtitle": "Prøv et annet søkeord eller fjern noen filtre.",
      "error_title": "Kunne ikke hente treff",
      "error_subtitle": "Noe gikk galt. Prøv igjen.",
      "retry": "Prøv igjen",
      "view_details": "Vis detaljer",
      "back_to_results": "Tilbake til treff",
      "detail_kind": "Type",
      "detail_place": "Sted",
      "detail_trades": "Fag",
      "detail_trade_groups": "Fagområder",
      "detail_not_found_title": "Fant ikke oppføringen",
      "detail_not_found_subtitle": "Oppføringen finnes ikke eller er ikke lenger synlig i registeret."
    }
  },
  "design_forms": {
    "title": "Formelementer",
    "intro": "Prøv feltene med mus og tastatur. Bruk Tab for å se fokus. Alle felt skal fylles ut med mindre de er merket «valgfritt». Eksemplene lagres ikke.",
    "state": "Vis tilstand",
    "normal": "Normal",
    "error": "Feil",
    "readonly": "Skrivebeskyttet",
    "disabled": "Deaktivert",
    "readonly_hint": "Tekst kan markeres og kopieres. Nedtrekk, avkryssing og radiovalg er deaktivert fordi de ikke støtter skrivebeskyttelse.",
    "text": "Tekstfelt",
    "email": "E-postadresse",
    "email_hint": "Bruk en adresse du leser jevnlig.",
    "email_error": "Skriv inn en gyldig e-postadresse.",
    "native_select": "Nedtrekk – innebygd i nettleseren",
    "custom_select": "Nedtrekk – egen meny",
    "trade": "Fag",
    "trade_hint": "Velg faget du søker mesterbrev i.",
    "choose": "Velg fag",
    "carpenter": "Tømrerfaget",
    "plumber": "Rørleggerfaget",
    "trade_error": "Velg et fag.",
    "textarea": "Tekstområde",
    "notes": "Tilleggsopplysninger (valgfritt)",
    "notes_hint": "Ta med opplysninger som er relevante for søknaden.",
    "notes_error": "Kort ned teksten.",
    "widths": "Bredder tilpasset innholdet",
    "postcode": "Postnummer",
    "phone": "Telefonnummer",
    "date": "Fra dato",
    "choices": "Avkryssing og radiovalg",
    "consent": "Jeg bekrefter at opplysningene er riktige.",
    "consent_hint": "Les gjennom opplysningene før du bekrefter.",
    "consent_error": "Du må bekrefte at opplysningene er riktige.",
    "attachments": "Velg vedlegg (valgfritt)",
    "select_all": "Velg alle vedlegg",
    "diploma": "Fagbrev",
    "practice": "Praksisattest",
    "radio_plain": "Radiovalg",
    "radio_cards": "Radiokort",
    "radio_hint": "Velg ett alternativ. Bruk piltastene for å bytte valg.",
    "uploads": {
      "title": "Dokumentopplasting",
      "intro": "Prøv filvelgeren, dra inn én fil om gangen, eller slett et eksempelvedlegg. Filene sendes ikke til serveren. Fremdrift og feil er demonstrasjonstilstander.",
      "compact": "Kompakt opplasting",
      "compact_hint": "For ett bestemt dokument, som fagbrev eller vitnemål. Den opplastede filen erstatter filvelgeren.",
      "list": "Vedleggsliste",
      "list_hint": "For praksisattester og øvrige vedlegg. Eksempelet har plass til fem filer.",
      "empty": "Tom",
      "upload": "Last opp dokument",
      "choose": "Velg fil",
      "add": "Legg til et dokument",
      "remove": "Slett",
      "drop_hint": "eller dra filen hit",
      "uploaded": "Lastet opp",
      "uploading": "Laster opp…",
      "failure": "Opplastingen mislyktes. Prøv igjen."
    }
  },
  "design_product": {
    "reference_title": "Mesterbrev – profilreferanse",
    "reference_notice": "Her er temaet, komponentene og de interaktive eksemplene samlet. Referansen bruker de samme komponentene som løsningen.",
    "reference_components": "Komponentgalleri",
    "reference_logo_label": "Mesternemnda",
    "reference_navigation": "Innhold i designreferansen",
    "reference_theme": "Felles tema",
    "reference_theme_hint": "Fargene nedenfor kommer fra det genererte Mesterbrev-temaet i Designsystemet. Temaets kilde er designsystemet.config.json.",
    "title": "Komponenter i bruk",
    "page_intro": "Profil, byggeklosser og interaktive eksempler fra Mesterbrevnemndas løsninger.",
    "intro": "Anbefalte mønstre med komponentene som brukes i løsningen. Eksemplene bruker fiktive data og lagres ikke.",
    "list_standard": "Bruk luftige lister i selvbetjening og kompakte lister i tette arbeidsflater for saksbehandling.",
    "status_standard": "Vis status med tekst og ikon. Bruk rolige omriss til vanlige statuser og farget bakgrunn når noe krever oppfølging.",
    "controls_standard": "Korte lister trenger få kontroller. Legg til søk, filter og sortering når mengden innhold gjør det nyttig.",
    "documents": "Dokumentvelger",
    "preview_mode": "Vis dokumentkort med",
    "preview_pages": "Sideminiatyr (anbefalt)",
    "preview_fallback": "Filtypeikon (reserve)",
    "preview_hint": "Illustrerte eksempelsider. I løsningen vises første side av dokumentet når forhåndsvisning er tilgjengelig. Filnavnet er alltid lesbart under miniatyren.",
    "fallback_hint": "Når forhåndsvisning mangler, vises filikon og filtype. Dokumentet kan fortsatt velges.",
    "documents_hint": "Velg et dokument med mus eller tastatur. Hele filnavnet vises. Når listen ikke får plass, kan du rulle sidelengs eller bruke pilknappene.",
    "selected_document": "Valgt dokument",
    "sample": "Fiktivt sammendrag for å vise samspillet mellom komponentene.",
    "certificate_summary": "Fagbrevet dokumenterer bestått fagprøve i tømrerfaget.",
    "practice_summary": "Attesten beskriver arbeidsoppgaver og praksisperiode. Dokumentet venter på vurdering.",
    "education_summary": "Vitnemålet mangler en side. Fullstendig dokumentasjon må ettersendes.",
    "education": "Mesterutdanning",
    "approved": "Godkjent",
    "received": "Mottatt",
    "incomplete": "Må suppleres",
    "list": "Lister og statusmerker",
    "list_hint": "Velg bruksområde og datamengde for å prøve standardene. Innstillingene nedenfor hører til galleriet.",
    "demo_settings": "Prøv mønsteret",
    "context": "Bruksområde",
    "portal": "Selvbetjening",
    "admin": "Saksbehandling",
    "portal_hint": "Luftig liste med god leseavstand.",
    "admin_hint": "Kompakt liste for å få oversikt over mer informasjon samtidig.",
    "example": "Eksempel",
    "few": "Kort liste – 3 dokumenter",
    "many": "Lang liste – 12 dokumenter",
    "empty": "Ingen dokumenter ennå",
    "empty_title": "Ingen dokumenter ennå",
    "empty_hint": "Når du laster opp et dokument, vises det her.",
    "try_upload": "Prøv dokumentopplasting",
    "search": "Søk i dokumenter",
    "search_help": "Søket finner treff i både filnavn og dokumenttype. Prøv «fagbrev», eller skriv noe som ikke finnes for å se tomtilstanden.",
    "status": "Status",
    "all": "Alle statuser",
    "results": {
      "one": "%{count} dokument",
      "other": "%{count} dokumenter"
    },
    "filename": "Filnavn",
    "kind": "Dokumenttype",
    "no_results": "Ingen dokumenter passer søket og filtrene.",
    "reset": "Nullstill søk og filter"
  },
  "display": {
    "panel": {
      "title": "Visning",
      "subtitle": "Tilpass tema, skrift og lesbarhet",
      "subtitle_readability": "Tilpass tekst og lesbarhet"
    },
    "section": {
      "theme": "Tema",
      "font": "Skrift",
      "readability": "Lesbarhet"
    },
    "theme": {
      "label": "Modus",
      "options": {
        "light": "Lyst",
        "dark": "Mørkt",
        "system": "System"
      }
    },
    "accent": {
      "label": "Fargetema",
      "hint": "Farger på flater, navigasjon og knapper",
      "options": {
        "authority": "Standard",
        "fjord": "Fjord",
        "sand": "Sand",
        "slate": "Skifer",
        "aurora": "Nordlys",
        "gold": "Gull",
        "terminal": "Terminal",
        "civic": "Burgunder",
        "friday": "Fredag"
      }
    },
    "color_intensity": {
      "label": "Fargeintensitet"
    },
    "font": {
      "label": "Skrifttype",
      "options": {
        "source": {
          "name": "Inter",
          "note": "Standard"
        },
        "plex": {
          "name": "IBM Plex Sans",
          "note": "Teknisk"
        },
        "atkinson": {
          "name": "Atkinson",
          "note": "Lesevennlig"
        },
        "system": {
          "name": "System",
          "note": "Native"
        }
      }
    },
    "text_size": {
      "label": "Tekststørrelse",
      "hint": "Skalerer hele grensesnittet",
      "options": {
        "sm": "Liten",
        "md": "Standard",
        "lg": "Stor"
      }
    },
    "density": {
      "label": "Tetthet",
      "hint": "Plass mellom elementer og rader",
      "options": {
        "compact": "Kompakt",
        "normal": "Normal",
        "comfy": "Luftig"
      }
    },
    "crisp": {
      "label": "Skarphet",
      "hint_on": "Skarp tekstkant",
      "hint_off": "Myk, glattet tekst",
      "options": {
        "false": "Myk",
        "true": "Skarp"
      }
    },
    "contrast": {
      "label": "Høy kontrast",
      "hint": "Mørkere tekst og tydeligere kanter"
    },
    "motion": {
      "label": "Redusér bevegelse",
      "hint": "Slår av animasjoner og overganger"
    },
    "reset": {
      "label": "Tilbakestill til standard"
    }
  },
  "documents": {
    "generate": {
      "kinds": {
        "documentation_request_letter": "Mangelbrev",
        "decision_pdf": "Vedtaksbrev",
        "master_certificate": "Mesterbrev",
        "application_summary": "Søknadssammendrag"
      },
      "heading": "Generer dokumenter",
      "language_label": "Språk",
      "preview": "Forhåndsvis",
      "issue_vedtak": "Generer vedtaksbrev",
      "issue_mesterbrev": "Generer mesterbrev",
      "mesterbrev_blocked": "Mesterbrev kan utstedes når saken er innvilget og mesternummer er tildelt.",
      "issue_copy": "Generer gjenpart",
      "copy_blocked": "Gjenpart kan utstedes når et mesterbrev er utstedt.",
      "issue_summary": "Generer sammendrag",
      "summary_blocked": "Sammendrag kan genereres etter at søknaden er sendt inn.",
      "download": "Last ned",
      "needs_decision": "Vedtaksbrevet kan genereres når det er fattet et vedtak i saken.",
      "none_issued": "Ingen offisielle dokumenter er generert ennå.",
      "error": "Kunne ikke generere dokumentet. Prøv igjen.",
      "languages": {
        "nb": "Bokmål",
        "nn": "Nynorsk",
        "en": "Engelsk"
      }
    },
    "request_letter": {
      "title": "Vi trenger mer dokumentasjon",
      "case_label": "Saksnummer",
      "date_label": "Dato for forespørselen",
      "deadline_label": "Frist for å sende dokumentasjonen",
      "documents_label": "Dokumentasjon vi ber om",
      "preview": "Forhåndsvis mangelbrev",
      "issue": "Opprett brev og del på Min side",
      "working": "Lager brevet …"
    },
    "withdraw": {
      "action": "Trekk dokument",
      "withdrawn": "Trukket dokument",
      "explanation": "Dokumentet fjernes fra Min side og regnes ikke lenger som innsendt dokumentasjon. Originalen og begrunnelsen beholdes i saken og arkivet.",
      "reason": "Begrunnelse",
      "error": "Dokumentet kunne ikke trekkes. Prøv igjen."
    },
    "errors": {
      "unavailable": "Dokumentet er ikke tilgjengelig."
    },
    "authority": {
      "name": "Mesterbrevnemnda",
      "address": "Mesterbrevnemnda, Oslo",
      "footer": "Mesterbrevnemnda"
    },
    "states": {
      "received": "Mottatt",
      "processing": "Behandles",
      "archived": "Arkivert",
      "failed": "Feilet"
    },
    "vedtak": {
      "title": "Vedtak",
      "case_label": "Saksnummer",
      "date_label": "Vedtaksdato",
      "outcome_label": "Resultat",
      "rationale_heading": "Begrunnelse",
      "legal_basis_heading": "Rettslig grunnlag",
      "appeal": {
        "heading": "Klagerett",
        "body": "Du kan klage på dette vedtaket etter forvaltningsloven § 28. Klagefristen er tre uker regnet fra den dagen du mottok dette vedtaket. Klagen sendes til Mesterbrevnemnda, som kan omgjøre vedtaket eller sende saken videre til klagenemnda for mesterbrevordningen. Klagen må være skriftlig, vise til vedtaket du klager på, og begrunne hvilke endringer du ønsker."
      },
      "inspect": {
        "heading": "Innsyn i saksdokumentene",
        "body": "Du har etter forvaltningsloven § 18, jf. § 19, rett til å gjøre deg kjent med dokumentene i saken. Ta kontakt med Mesterbrevnemnda dersom du ønsker innsyn."
      }
    },
    "mesterbrev": {
      "title": "Mesterbrev",
      "preamble": "Mesterbrevnemnda tildeler herved mesterbrev i samsvar med mesterbrevloven § 1. Innehaveren har rett til å kalle seg mester i sitt fag.",
      "number_label": "Mesternummer",
      "date_label": "Utstedt",
      "signature": "Mesterbrevnemnda",
      "copy_mark": "GJENPART"
    },
    "application_summary": {
      "title": "Søknadssammendrag",
      "applicant_label": "Søker",
      "trade_label": "Fag",
      "status_label": "Status",
      "created_label": "Opprettet",
      "submitted_label": "Innsendt",
      "practice_heading": "Praksis i faget",
      "leadership_heading": "Praksis som næringsdrivende eller leder",
      "subject_areas_heading": "Registrerte fagområder",
      "documents_heading": "Innsendte dokumenter",
      "no_documents": "Ingen dokumenter er lastet opp."
    }
  },
  "feedback": {
    "trigger": "Meld feil",
    "title": "Meld feil",
    "intro": "Fant du noe som ikke virker? Fortell oss hva som skjedde, så kan vi rette feilen.",
    "category_label": "Hva gjelder det?",
    "body_label": "Hva skjedde?",
    "body_placeholder": "Beskriv hva du gjorde og hva du forventet skulle skje.",
    "body_required": "Skriv en kort beskrivelse før du sender.",
    "screenshot_label": "Legg ved skjermbilde",
    "screenshot_hint": "Skjermbildet viser siden slik den så ut da du klikket.",
    "screenshot_alt": "Skjermbilde av siden",
    "submit": "Send",
    "submitting": "Sender …",
    "cancel": "Avbryt",
    "close": "Lukk",
    "success_title": "Takk for meldingen",
    "success_body": "Vi svarer ikke på denne meldingen. Trenger du svar, kontakt oss på post@mesterbrev.no.",
    "error": "Vi klarte ikke å sende meldingen. Prøv igjen om litt."
  },
  "letters": {
    "delivery": {
      "unsent": "Ferdigstilt – ikke sendt",
      "published": "Publisert for søker",
      "unsent_hint": "Brevet er låst. Kontroller PDF-en og send når du er klar.",
      "send": "Send til søker",
      "preview": "Forhåndsvis ferdig brev",
      "confirm_title": "Send brevet til søker",
      "confirm_body": "Den lagrede PDF-en blir tilgjengelig for søker i portalen, og varsling bestilles. Kontaktopplysninger og reservasjon kontrolleres i varslingsløpet. Eventuelt papirbehov må følges opp.",
      "confirm_receipt": "Sending bekrefter ikke mottak. Registrer når brevet kom fram før klagefristen kan beregnes.",
      "refresh": "Oppdater utsendingsstatus",
      "retry": "Prøv varslingen på nytt",
      "retry_queued": "Nytt varslingsforsøk er bestilt. Oppdater status om litt.",
      "queued": "Varsel i kø",
      "sending": "Varsling klargjort – overlevering ikke bekreftet",
      "sent": "Varsel sendt – brevets mottak er ikke bekreftet",
      "failed": "Varslingen mislyktes",
      "uncertain": "Varslingsresultatet er uavklart – følg opp før ny sending",
      "routed_paper": "Papirutsending må følges opp",
      "portal_ready": "Melding tilgjengelig i portalen",
      "portal_pending": "Portalmelding behandles",
      "paper_sent": "Papirutsending registrert",
      "register_paper": "Registrer papirutsending",
      "paper_date": "Dato brevet ble sendt på papir",
      "register_receipt": "Registrer mottak",
      "edit_receipt": "Rett mottaksregistrering",
      "received_on": "Dato brevet kom fram",
      "receipt_basis": "Grunnlag for mottaksdatoen",
      "receipt_hint": "Beskriv hvordan mottaksdatoen er dokumentert. Ved retting må du også forklare hvorfor registreringen endres.",
      "save_receipt": "Lagre mottaksregistrering",
      "save_paper": "Lagre papirutsending",
      "missing_receipt": "Mottak er ikke registrert. Klagefristen er ikke bekreftet av denne utsendingen.",
      "appeal_deadline": "Klagefrist for vedtaket",
      "previous_receipt": "Vedtaket var allerede underrettet. Mottak av dette brevet endrer ikke den registrerte klagefristen.",
      "paper_hint": "Registrer faktisk papirutsending før mottak når varslingen er rutet til papir.",
      "choose_template_link": "Velg relevant mal fra saken. Eksisterende vedtak velges uttrykkelig."
    },
    "backend": {
      "letter_file_unavailable": "Den lagrede PDF-en er ikke tilgjengelig. Brevet er ikke publisert eller varslet. Få filen gjenopprettet før du prøver igjen.",
      "dispatch_unavailable": "Dette dokumentet kan ikke sendes gjennom vedtaksbrevløpet.",
      "recipient_changed": "Saks- eller mottakeropplysninger er endret siden brevet ble ferdigstilt. Kontroller grunnlaget og opprett et korrigert brev før sending.",
      "stale_delivery": "Utsendingsopplysningene er endret. Oppdater status før du lagrer på nytt. Inndataene dine er beholdt.",
      "invalid_delivery_date": "Oppgi en gyldig dato fra utsendingsbestillingen til og med i dag. Papirutsending kan ikke være etter registrert mottak.",
      "receipt_basis_required": "Oppgi grunnlaget for mottaksdatoen, maksimalt 2500 tegn.",
      "paper_not_required": "Denne utsendingen er ikke rutet til papir.",
      "paper_not_sent": "Registrer papirutsending før mottak. Mottaksdatoen kan ikke være før papirutsendingen.",
      "retry_unavailable": "Varslingen kan ikke gjentas automatisk. Oppdater status og kontroller resultatet.",
      "birth_date": "Fødselsdato",
      "decided_by_body": "Vedtaksorgan",
      "invalid_value": "Velg eller oppgi en gyldig verdi.",
      "too_long": "Teksten er for lang (maksimalt 20 000 tegn).",
      "required": "Fyll ut feltet.",
      "unknown_field": "Feltet er ikke tillatt i denne malen.",
      "locked": "Dette feltet er hentet fra vedtaket og kan ikke endres.",
      "invalid_date": "Oppgi en gyldig dato.",
      "area_mismatch": "Fordel alle omsøkte fagområder mellom innvilget og avslått, uten overlapp.",
      "missing_source": "En påkrevd opplysning mangler i saken eller brevet. Kontroller mottaker, adresse, datoer og fag.",
      "invalid_input": "Kontroller feltene før du fortsetter.",
      "unavailable": "Malen er ikke tilgjengelig for denne saken.",
      "issued": "Brevet er ferdigstilt og kan ikke endres.",
      "revision_changed": "Malen er oppdatert. Opprett et nytt utkast med gjeldende mal.",
      "wrong_outcome": "Malen passer ikke til det valgte vedtakets utfall.",
      "appeals_board_unsupported": "Denne malen gjelder vedtak i første instans. Klagenemndas endelige vedtak må bruke sin egen brevtekst.",
      "decision_not_ready": "Saken må være klar for vedtak eller ha et valgt eksisterende vedtak før brevet ferdigstilles.",
      "grant_decision_required": "Innvilgelsesbrevet krever et eksisterende innvilgelsesvedtak og tildelt mesternummer. Fatt vedtak fra saken og velg vedtaket når du oppretter brevet.",
      "notice_not_ready": "Forhåndsvarsel kan ferdigstilles mens saken er under vurdering, venter på dokumentasjon eller er klar for vedtak.",
      "appeal_not_ready": "Registrer klagen i saken før mottaksbrevet ferdigstilles.",
      "stale_draft": "Utkastet er endret. Last inn siste versjon før du fortsetter.",
      "stale_preview": "Saksopplysninger eller brevgrunnlag er endret. Oppdater forhåndsvisningen og kontroller brevet på nytt.",
      "render_failed": "PDF-en kunne ikke ferdigstilles. Endringene er ikke fullført. Prøv igjen."
    },
    "title": "Brev",
    "create_link": "Lag brev",
    "catalogue_title": "Brevmaler",
    "catalogue_hint": "Se bruksområder, felt og PDF-eksempler. Opprett brevet fra saken for å bruke en mal.",
    "template": "Mal",
    "category": "Kategori",
    "language": "Språk",
    "revision": "Revisjon",
    "status": "Status",
    "ready": "Klar",
    "awaiting_sanctions": "Avventer sanksjonsløp",
    "sanctions_hint": "Denne malen kan forhåndsvises med eksempeldata. Brev kan opprettes når sanksjonsløpet er tilgjengelig.",
    "search": "Søk i brevmaler",
    "all_categories": "Alle kategorier",
    "count": "%{count} av %{total} maler",
    "no_templates": "Ingen maler passer til søket",
    "example": "Eksempelbrev",
    "view_example": "Se eksempel",
    "view_template": "Se mal",
    "preview_actions": "Forhåndsvisning",
    "preview_choices": "Malalternativer",
    "placeholder_hint": "Tekst i [klammer] fylles inn fra saken eller av saksbehandleren. Malalternativene bestemmer hvilke faste avsnitt som vises.",
    "fields": "Opplysninger og tekstvalg",
    "about_template": "Om malen",
    "available_choices": "Tilgjengelige valg",
    "required_when_applicable": "Påkrevd når aktuelt",
    "required": "Påkrevd",
    "optional": "Valgfritt",
    "condition": "Vises når %{field}: %{values}",
    "loading": "Laster PDF …",
    "categories": {
      "application": "Søknad om mesterbrev",
      "foreign": "Utenlandske kvalifikasjoner",
      "prior_learning": "Realkompetanse",
      "exemption": "Fritak",
      "appeal": "Klage",
      "sanction": "Ulovlig tittelbruk"
    },
    "field_types": {
      "text": "Tekstfelt",
      "textarea": "Fritekst",
      "date": "Dato",
      "select": "Ett valg",
      "multiselect": "Flere valg"
    },
    "choose": "Velg …",
    "locked_field": "Hentet fra det tilknyttede vedtaket. Kan ikke endres i brevet.",
    "fields_hint": "Felt merket * må fylles ut før ferdigstilling. Du kan lagre et uferdig utkast. Brevets felt og innhold er på bokmål.",
    "language_hint": "Brevmalene og de ferdige brevene er på bokmål, uavhengig av språk i brukergrensesnittet.",
    "saved_letters": "Lagrede brev",
    "choose_draft": "Velg et brev …",
    "new_letter": "Nytt brev",
    "choose_template": "Velg en mal …",
    "decision": "Tilknytning til vedtak",
    "decision_hint": "Velg et eksisterende vedtak uttrykkelig, eller la brevet gjelde et nytt vedtak. Et utkast fatter ikke vedtak.",
    "new_decision": "Nytt vedtak – fattes ved ferdigstilling",
    "linked_decision": "Tilknyttet vedtak",
    "outcome": "Utfall",
    "create_draft": "Opprett utkast",
    "no_applicable_templates": "Ingen tilgjengelige maler for denne saken.",
    "no_drafts": "Ingen lagrede brev",
    "draft": "Utkast",
    "read_only": "Kun lesetilgang",
    "issued": "Ferdigstilt brev",
    "saved": "Utkast lagret",
    "unsaved": "Ulagrede endringer",
    "working": "Arbeider …",
    "source_title": "Opplysninger fra saken",
    "source_hint": "Disse opplysningene hentes fra saken og kan ikke endres her. Eventuelle feil må rettes i saken eller i riktig register.",
    "not_available": "Ikke registrert",
    "source": {
      "applicant_name": "Mottaker",
      "recipient_address": "Mottakeradresse",
      "case_number": "Saksnummer",
      "trade_name": "Fag",
      "application_date": "Søknadsdato",
      "caseworker_name": "Saksbehandler"
    },
    "save": "Lagre utkast",
    "preview": "Forhåndsvisning",
    "refresh_preview": "Oppdater forhåndsvisning",
    "save_before_preview": "Endringene er ikke lagret. Lagre utkastet før du oppdaterer forhåndsvisningen.",
    "preview_current": "Forhåndsvisningen gjelder det lagrede utkastet. Kontroller PDF-en før ferdigstilling.",
    "preview_required": "Kontroller PDF-forhåndsvisningen før brevet ferdigstilles.",
    "preview_incomplete": "Forhåndsvisningen viser et uferdig brev. Fullfør påkrevde felt og kontroller valgene før ferdigstilling.",
    "no_preview": "Ingen oppdatert forhåndsvisning",
    "master_number_hint": "Innvilgelsesbrevet bruker mesternummeret som er registrert etter innvilgelsesvedtaket.",
    "issue": "Ferdigstill brev",
    "decide_and_issue": "Fatt vedtak og ferdigstill brev",
    "confirm_decision": "Du fatter et nytt vedtak med utfallet nedenfor og ferdigstiller brevet med grunnlaget fra forhåndsvisningen. Vedtaket og brevet kan ikke redigeres etterpå.",
    "confirm_issue": "Du ferdigstiller brevet med grunnlaget fra forhåndsvisningen. Brevet kan ikke redigeres etterpå. Det opprettes ikke et nytt vedtak.",
    "confirm_not_sent": "Ferdigstilling sender ikke brevet. Vedtaksbrev publiseres og varsles gjennom det separate sendesteget.",
    "not_sent": "Brevet er generert. Se dokumentdeling og kommunikasjonsstatus i saken.",
    "download_pdf": "Last ned PDF",
    "back_to_case": "Til saken",
    "cancel": "Avbryt",
    "leave_dirty": "Du har ulagrede endringer. Vil du forkaste dem og fortsette?",
    "invalid_input": "Kontroller feltene nedenfor. Endringene dine er beholdt.",
    "error_summary": "Handlingen kunne ikke fullføres",
    "general_error": "Kontroller brevet og opplysningene i saken: %{message}",
    "request_failed": "Handlingen kunne ikke fullføres. Prøv igjen. Endringene dine er beholdt.",
    "conflict": "Utkastet eller grunnlaget for forhåndsvisningen er endret.",
    "conflict_hint": "Endringene dine er beholdt her. Kopier tekst du vil ta vare på, og last inn siste versjon før du fortsetter. Innlasting erstatter de lokale endringene.",
    "stale_preview_hint": "Forhåndsvisningen er utdatert. Oppdater den og kontroller PDF-en på nytt. Last inn siste versjon hvis utkastet er endret.",
    "reload": "Last inn siste versjon",
    "delivery_date_required": "Oppgi datoen."
  },
  "letter_documents": {
    "caseworker_title": "Saksbehandler",
    "authority": {
      "name": "Mesterbrevnemnda",
      "footer": "Mesterbrevnemnda · Postboks 5145, 0302 Oslo · Org.nr. 982 786 459\nTelefon 23 08 83 62 · post@mesterbrev.no · www.mesterbrev.no"
    },
    "labels": {
      "reference": "Vår referanse",
      "date": "Dato",
      "greeting": "Vennlig hilsen",
      "electronic_approval": "Brevet er godkjent elektronisk og sendes uten signatur."
    }
  },
  "letter_templates": {
    "preview_fields": {
      "applicant_name": "Mottakers navn",
      "recipient_address": "Mottakeradresse",
      "birth_date": "Fødselsdato",
      "trade_name": "Mesterfag",
      "case_number": "Saksnummer",
      "application_date": "Søknadsdato",
      "letter_date": "Brevdato",
      "caseworker_name": "Saksbehandlers navn",
      "caseworker_title": "Saksbehandlers tittel",
      "master_number": "Mesternummer"
    },
    "fields": {
      "outcome": "Utfall",
      "rationale": "Individuell begrunnelse",
      "legal_basis": "Rettslig grunnlag",
      "country": "Land mesterkvalifikasjonen er fra",
      "missing_documents": "Dokumentasjon som må ettersendes",
      "unmet_criteria": "Krav som ikke er oppfylt",
      "notice_date": "Dato for forhåndsvarsel eller første brev",
      "documentation_received": "Er dokumentasjon eller svar mottatt?",
      "documentation_received_date": "Dato dokumentasjon eller svar ble mottatt",
      "fee_payment_date": "Dato behandlingsgebyret ble betalt",
      "subject_areas": "Fagområder som ikke er tilstrekkelig dokumentert",
      "trade_group": "Faggruppe",
      "assessment_gaps": "Mangler i egenvurdering og dokumentasjon",
      "practice_summary": "Dokumentert praksis og perioder",
      "previous_dialog": "Tidligere dialog og frist for ettersending",
      "met_criteria": "Krav som er bekreftet oppfylt",
      "education_name": "Utdanning",
      "course_name": "Emne",
      "grade": "Faktisk eksamenskarakter",
      "practice_requirement": "Vurdering av praksiskravet",
      "requested_subject_areas": "Fagområder det er søkt fritak for",
      "granted_subject_areas": "Fagområder med innvilget fritak",
      "denied_subject_areas": "Fagområder med avslått fritak",
      "appeal_date": "Klagens dato",
      "decision_date": "Dato for vedtaket det klages på",
      "appeal_timeliness": "Vurdering av klagefristen",
      "company_name": "Bedriftens navn",
      "organisation_number": "Organisasjonsnummer",
      "observed_use": "Observert bruk av mestertittel eller mestermerke",
      "first_decision_date": "Dato for første gebyrvedtak",
      "second_decision_date": "Dato for andre gebyrvedtak"
    },
    "options": {
      "outcome": {
        "granted": "Innvilget",
        "partially_granted": "Delvis innvilget",
        "denied": "Avslått"
      },
      "missing_documents": {
        "trade_certificate": "Utenlandsk fag-/svennebrev",
        "recognition": "NOKUT-godkjenning av fag-/svennebrev",
        "master_certificate": "Utenlandsk mesterbrev",
        "curriculum": "Læreplaner for mesterutdanningen",
        "norwegian_standards": "Norske myndighetskrav og bransjestandarder",
        "practice": "Praksis i faget"
      },
      "foreign_criteria": {
        "master_qualification": "Mesterkvalifikasjon i et fag under mesterbrevordningen",
        "trade_certificate": "Norsk fag-/svennebrev eller bekreftet likeverdig fagutdanning",
        "equivalent_content": "Mesterutdanningens nivå og faglige innhold",
        "norwegian_standards": "Norske myndighetskrav og bransjestandarder",
        "practice": "Praksis som selvstendig yrkesutøver",
        "norwegian_documents": "Dokumentasjon på norsk"
      },
      "prior_criteria": {
        "trade_certificate": "2a – fag-/svennebrev",
        "practice": "2b – utøvende praksis",
        "leadership_practice": "2c – praksis som næringsdrivende eller leder",
        "learning_outcomes": "2d – læringsutbytte"
      },
      "documentation_received": {
        "not_received": "Ikke mottatt",
        "received": "Mottatt"
      },
      "subject_areas": {
        "business_management": "Bedriftsledelse",
        "technical_management": "Faglig ledelse",
        "technical_specialization": "Faglig fordypning"
      },
      "assessment_gaps": {
        "detail": "Manglende detaljeringsgrad",
        "references": "Mangelfulle henvisninger til dokumentasjon",
        "reflection": "Utilstrekkelig refleksjon opp mot regelverk og standarder",
        "evidence": "Manglende dokumentasjon som underbygger egenvurderingen"
      },
      "met_criteria": {
        "trade_certificate": "Bestått fag-/svenneprøve i mesterfaget",
        "master_education": "Fullført og bestått mesterutdanning eller annen godkjent utdanning"
      },
      "practice_requirement": {
        "met": "Oppfylt",
        "unmet": "Ikke dokumentert oppfylt",
        "not_assessed": "Ikke vurdert i dette brevet"
      },
      "appeal_timeliness": {
        "on_time": "Klagen er rettidig",
        "under_review": "Klagefristen er under vurdering",
        "late": "Klagen er fremsatt etter fristen"
      }
    },
    "headings": {
      "legal_basis": "Rettslig grunnlag",
      "facts": "Saksforhold",
      "facts_and_assessment": "Saksforhold og vurdering",
      "assessment": "Vurdering",
      "preliminary_assessment": "Foreløpig vurdering",
      "decision": "Vedtak",
      "advance_notice": "Forhåndsvarsel om avslag",
      "supplement_documentation": "Mulighet til å ettersende dokumentasjon",
      "improve_application": "Mulighet til å utbedre søknaden",
      "guidance": "Generelle råd og veiledning",
      "appeal": "Klageadgang",
      "inspection": "Innsyn i saksdokumentene",
      "appeals_board": "Om Klagenemnda for mesterbrevordningen",
      "met_criteria": "Følgende krav er oppfylt",
      "information": "Informasjon"
    },
    "legal_basis": {
      "master": "Mesterbrev tildeles etter søknad til den som oppfyller de kvalifikasjonskrav som blir stilt i medhold av mesterbrevloven, jf. lov 20. juni 1986 nr. 35 om mesterbrev i håndverk og annen næring (mesterbrevloven).",
      "foreign": "Mesterbrev tildeles etter søknad til den som oppfyller fastsatte kvalifikasjonskrav, jf. lov om mesterbrev i håndverk og annen næring. Ved søknad om mesterbrev med bakgrunn i mesterkvalifikasjon fra andre land vurderes søknaden etter forskrift om søknad om mesterbrev med bakgrunn i mesterkvalifikasjon fra andre land.",
      "prior_learning": "Mesterbrev tildeles etter søknad til den som oppfyller fastsatte kvalifikasjonskrav, jf. lov om mesterbrev i håndverk og annen næring. Ved søknad om mesterbrev på bakgrunn av realkompetanse skal Mesterbrevnemnda foreta en samlet vurdering av om søkers dokumenterte realkompetanse tilfredsstiller kravene, jf. forskrift om søknad om mesterbrev på bakgrunn av realkompetanse.",
      "practice": "Mesterbrev tildeles etter søknad til den som oppfyller fastsatte kvalifikasjonskrav, jf. lov om mesterbrev i håndverk og annen næring, forskrift om vilkår for å få mesterbrev og forskrift om vurdering av den praksis som godkjennes ved søknad om mesterbrev.",
      "grade": "Mesterbrev tildeles etter søknad til den som oppfyller fastsatte kvalifikasjonskrav, jf. lov om mesterbrev i håndverk og annen næring og forskrift om vilkår for å få mesterbrev. Karakterkravet følger av forskrift om godkjenning av annen utdanning i stedet for mesterutdanning.",
      "exemption": "Søknaden vurderes etter lov om mesterbrev i håndverk og annen næring og forskrift om godkjenning av annen utdanning i stedet for mesterutdanning.",
      "sanction": "Når det ikke er knyttet et gyldig mesterbrev til bedriften, er bruk av mestertittel eller mestermerke i strid med mesterbrevloven § 1 tredje ledd. Overtredelsesgebyr er hjemlet i mesterbrevloven § 1 fjerde ledd og mesterbrevforskriften § 6."
    },
    "contact": [
      "Ta gjerne kontakt ved spørsmål."
    ],
    "documentation": {
      "not_received": "Mesterbrevnemnda ba i forhåndsvarsel datert %{notice_date} om ytterligere dokumentasjon. Vi kan ikke se å ha mottatt svar fra deg, og søknaden er derfor behandlet på grunnlag av foreliggende dokumentasjon.",
      "received": "Mesterbrevnemnda ba i forhåndsvarsel datert %{notice_date} om ytterligere dokumentasjon. Vi har mottatt ettersendt dokumentasjon %{documentation_received_date}, og denne er vurdert i sin helhet sammen med den opprinnelige søknaden."
    },
    "appeal": {
      "standard": [
        "Vedtak fattet av Mesterbrevnemnda knyttet til avslag på søknad om mesterbrev kan påklages, jf. lov om behandlingsmåter i forvaltningssaker (forvaltningsloven). Klagefristen er tre uker fra orientering om endelig vedtak har kommet fram til søker.",
        "Klagen sendes til Mesterbrevnemnda. Dersom Mesterbrevnemnda ikke finner grunnlag for å omgjøre vedtaket, blir klagen sendt til Klagenemnda for mesterbrevordningen, som fatter endelig vedtak."
      ],
      "foreign": [
        "Vedtak fattet av Mesterbrevnemnda knyttet til avslag på søknad om mesterbrev med bakgrunn i mesterkvalifikasjon fra andre land kan påklages, jf. lov om behandlingsmåter i forvaltningssaker (forvaltningsloven).",
        "Dersom du ønsker å klage, må du angi hva du mener er feil i vedtaket eller i saksbehandlingen. Klagefristen er tre uker fra orientering om endelig vedtak har kommet fram til søker.",
        "Klagen sendes til Mesterbrevnemnda. Dersom Mesterbrevnemnda ikke finner grunnlag for å omgjøre vedtaket, blir klagen sendt til Klagenemnda for mesterbrevordningen, som fatter endelig vedtak."
      ],
      "prior_learning": [
        "Vedtak fattet av Mesterbrevnemnda knyttet til avslag på søknad om mesterbrev på bakgrunn av realkompetanse kan påklages, jf. lov om behandlingsmåter i forvaltningssaker (forvaltningsloven). Klagefristen er tre uker fra orientering om vedtaket har kommet fram til søker.",
        "Klagen sendes til Mesterbrevnemnda. Dersom Mesterbrevnemnda ikke finner grunnlag for å omgjøre vedtaket, blir klagen sendt til Klagenemnda for mesterbrevordningen, som fatter endelig vedtak."
      ],
      "exemption": [
        "Vedtak etter lov om mesterbrev i håndverk og annen næring og forskrift om godkjenning av annen utdanning kan påklages, jf. forvaltningsloven. Klagefristen er tre uker fra du har mottatt dette vedtaket.",
        "Klagen sendes til Mesterbrevnemnda. Dersom vi ikke finner grunnlag for å omgjøre vedtaket, sendes klagen videre til Klagenemnda for mesterbrevordningen, som fatter endelig vedtak."
      ],
      "board": [
        "Klagenemnda kan vurdere alle sider ved vedtak fattet av Mesterbrevnemnda."
      ],
      "board_with_meetings": [
        "Klagenemnda kan vurdere alle sider ved vedtak fattet av Mesterbrevnemnda.",
        "Klagenemnda for mesterbrevordningen har fire møter i året for behandling av innkomne klagesaker."
      ]
    },
    "foreign": {
      "notice_introduction": [
        "Mesterbrevnemnda viser til din søknad om mesterbrev i %{trade_name} med bakgrunn i mesterkvalifikasjon fra %{country}, datert %{application_date}."
      ],
      "notice_facts": [
        "Ved søknad om mesterbrev med bakgrunn i mesterkvalifikasjon fra andre land vurderes søknaden opp mot forskrift om søknad om mesterbrev med bakgrunn i mesterkvalifikasjon fra andre land.",
        "For at Mesterbrevnemnda skal kunne vurdere om du oppfyller forskriftens krav, må du levere relevant dokumentasjon. Nedenfor følger en liste over dokumentasjon du må ettersende."
      ],
      "request_documents": [
        "Vi ber om at du ettersender følgende dokumentasjon:"
      ],
      "documents": {
        "trade_certificate": "Kopi av det utenlandske svennebrevet i %{trade_name}.",
        "recognition": "NOKUT-godkjenning av ditt utenlandske fag-/svennebrev.",
        "master_certificate": "Kopi av ditt utenlandske mesterbrev.",
        "curriculum": "Læreplaner for den utenlandske mesterutdanningen (studieplan med faglig innhold).",
        "norwegian_standards": "Dokumentasjon på kompetanse i gjeldende norske myndighetskrav og bransjestandarder innen %{trade_name} (for eksempel kursbevis eller attest fra arbeidsgiver).",
        "practice": "Dokumentasjon på praksis i %{trade_name}, for eksempel attester fra nåværende eller tidligere arbeidsgivere."
      },
      "translation": "All dokumentasjon må være på norsk. Utenlandske dokumenter må være oversatt av autorisert oversetter.",
      "deadline": [
        "Manglende eller supplerende dokumentasjon kan sendes Mesterbrevnemnda innen 6 uker fra mottak av dette forhåndsvarselet om avslag.",
        "Dersom Mesterbrevnemnda ikke mottar ytterligere dokumentasjon innen fristen, vil søknadsbehandlingen avsluttes og din søknad om mesterbrev avslås.",
        "Får du et endelig vedtak om avslag, har du adgang til å klage, jf. lov om behandlingsmåter i forvaltningssaker (forvaltningsloven)."
      ],
      "criteria": {
        "master_qualification": "a. Søker må være mester i et fag som ligger under den norske mesterbrevordningen.",
        "trade_certificate": "b. Søker må ha norsk fag-/svennebrev, eller det må foreligge bekreftelse fra norsk myndighet på at den utenlandske fagutdanningen er på samme nivå som den norske fagutdanningen.",
        "equivalent_content": "c. Det utenlandske mesterbrevet må i grove trekk samsvare med det norske når det gjelder nivå og faglig innhold.",
        "norwegian_standards": "d. Søker må kunne dokumentere kompetanse i de til enhver tid gjeldende norske myndighetskrav og bransjestandarder innen mesterfaget. Dette inkluderer lover, forskrifter og standarder.",
        "practice": "e. Søker må kunne dokumentere praksis som selvstendig yrkesutøver i faget.",
        "norwegian_documents": "2. All dokumentasjon skal foreligge på norsk."
      },
      "decision": [
        "Søknaden om mesterbrev er avslått, jf. lov om mesterbrev i håndverk og annen næring og forskrift om søknad om mesterbrev med bakgrunn i mesterkvalifikasjon fra andre land. Etter en samlet vurdering av søknaden finner Mesterbrevnemnda ikke at kravene for innvilgelse er oppfylt."
      ],
      "unmet": "Følgende krav i forskriften er ikke dokumentert oppfylt:",
      "conclusion": "På bakgrunn av vurderingen som er foretatt, anser vi at din mesterkvalifikasjon fra %{country} ikke tilfredsstiller kravene i forskriften."
    },
    "prior_learning": {
      "notice_introduction": [
        "Mesterbrevnemnda viser til din søknad om mesterbrev på bakgrunn av realkompetanse, med innbetalt behandlingsgebyr %{fee_payment_date}, og øvrig dialog knyttet til behandlingen av søknaden."
      ],
      "denial_introduction": [
        "Mesterbrevnemnda viser til din søknad om mesterbrev på bakgrunn av realkompetanse, datert %{application_date}, samt forhåndsvarsel om avslag datert %{notice_date}."
      ],
      "notice_decision": [
        "Etter en helhetlig vurdering av dokumentasjonen finner Mesterbrevnemnda at vilkårene i forskrift om søknad om mesterbrev på bakgrunn av realkompetanse ikke er oppfylt. Det gis derfor med dette forhåndsvarsel om at søknaden vil kunne bli avslått."
      ],
      "denial_decision": [
        "Mesterbrevnemnda har foretatt en helhetlig og samlet vurdering av dokumentasjonen i saken. Nemnda har kommet til at vilkårene i forskrift om søknad om mesterbrev på bakgrunn av realkompetanse ikke er oppfylt. Søknaden avslås."
      ],
      "unmet": [
        "Følgende krav i realkompetanseforskriftens § 2 er ikke tilfredsstilt:"
      ],
      "criteria": {
        "trade_certificate": "2a) Fag-/svennebrev i det faget det søkes mesterbrev i.",
        "practice": "2b) Minst 6 års praksis som utøvende i faget, eller minst 2 år som utøvende i faget etter bestått fag-/svenneprøve.",
        "leadership_practice": "2c) Minst 6 års praksis innenfor de siste 10 årene som næringsdrivende eller leder i faget, med faglig og forretningsmessig ansvar.",
        "learning_outcomes": "2d) Oppnådd læringsutbytte slik det er beskrevet i studieplanen for det aktuelle mesterfaget i fagområdene:"
      },
      "subject_areas": {
        "business_management": "Bedriftsledelse",
        "technical_management": "Faglig ledelse, %{trade_group}",
        "technical_specialization": "Faglig fordypning, %{trade_name}"
      },
      "notice_assessment": [
        "Den innsendte egenvurderingen og dokumentasjonen underbygger ikke tilstrekkelig at læringsutbyttene i mesterutdanningens studieplaner er oppnådd. Det mangler:"
      ],
      "denial_assessment": [
        "Mesterbrevnemnda vurderer at den innsendte dokumentasjonen og egenvurderingen ikke tilstrekkelig underbygger at du har oppnådd læringsutbyttet som kreves. Det vises særlig til:"
      ],
      "notice_gaps": {
        "detail": "Tilstrekkelig detaljeringsgrad.",
        "references": "Relevante og tydelige henvisninger til dokumentasjon.",
        "reflection": "Refleksjon over valg av løsninger og vurderinger i lys av lover, forskrifter og bransjestandarder.",
        "evidence": "Dokumentasjon som underbygger beskrivelser i egenvurderingen."
      },
      "denial_gaps": {
        "detail": "Manglende detaljeringsnivå.",
        "references": "Mangelfulle og utydelige henvisninger til dokumentasjon.",
        "reflection": "Utilstrekkelig refleksjon opp mot relevante lover, forskrifter og bransjestandarder.",
        "evidence": "Manglende dokumentasjon som underbygger beskrivelser i egenvurderingen."
      },
      "learning_requirement": [
        "For å oppfylle forskriftens krav må egenvurderingen beskrive hvordan du har oppnådd læringsutbyttet i hvert hovedtema i studieplanene, og dokumentasjonen må underbygge beskrivelsene."
      ],
      "conclusion": "På dette grunnlaget finner nemnda at vilkårene for tildeling av mesterbrev etter realkompetanse ikke er oppfylt.",
      "deadline": [
        "Du får anledning til å sende inn supplerende dokumentasjon. Frist for innsending: 6 uker fra mottak av dette forhåndsvarselet.",
        "Dersom det ikke mottas ytterligere informasjon innen fristen, vil søknaden bli avslått. Du har rett til å klage på et eventuelt endelig vedtak om avslag etter forvaltningsloven."
      ],
      "learning_deadline": [
        "Du får anledning til å sende inn revidert egenvurdering og supplerende dokumentasjon. Frist for innsending: 6 uker fra mottak av dette forhåndsvarselet.",
        "Dersom du reviderer egenvurderingen, må det klart fremgå hvilke deler som er nye, og all dokumentasjon skal nummereres og henvises til i teksten.",
        "Dersom det ikke mottas ytterligere informasjon innen fristen, vil søknaden bli avslått. Du har rett til å klage på et eventuelt endelig vedtak om avslag etter forvaltningsloven."
      ],
      "guidance": [
        "Det er din dokumenterte realkompetanse opp mot studieplanenes læringsutbytte som vurderes. Vi anbefaler at du:"
      ],
      "guidance_items": [
        "Tar utgangspunkt i hovedtemaene i studieplanene.",
        "Beskriver din kompetanse og refleksjoner i hvert enkelt tema.",
        "Viser hvordan lover, forskrifter og regler påvirker dine valg og løsninger.",
        "Dokumenterer alle beskrivelser med relevant og tydelig merket dokumentasjon."
      ]
    },
    "ordinary": {
      "introduction": [
        "Mesterbrevnemnda viser til din søknad om mesterbrev i %{trade_name}, datert %{application_date}."
      ],
      "decision": [
        "Etter en vurdering av din søknad om mesterbrev er søknaden avslått, jf. lov om mesterbrev i håndverk og annen næring og forskrift om vilkår for å få mesterbrev."
      ],
      "unmet": [
        "I vurderingen er følgende krav ikke dokumentert oppfylt:"
      ],
      "practice_criterion": [
        "Minst 6 års praksis i faget eller minst 2 års praksis i faget etter svenneprøve/fagprøve."
      ],
      "grade_criterion": [
        "Karakterkravet D eller bedre i fag som inngår i vurderingsgrunnlaget."
      ],
      "met_criteria": {
        "trade_certificate": "Bestått fag-/svenneprøve i mesterfaget.",
        "master_education": "Fullført og bestått mesterutdanning eller annen godkjent utdanning."
      },
      "practice_requirement": [
        "For tildeling av mesterbrev er det krav om seks års utøvende praksis i faget eller minst to års praksis som utøvende i faget etter avlagt svenneprøve, jf. forskrift om vilkår for å få mesterbrev."
      ],
      "grade_assessment": [
        "For tildeling av mesterbrev på bakgrunn av annen godkjent utdanning må alle emner være bestått med karakteren D eller bedre. Ditt vitnemål fra %{education_name} viser at du har fått eksamenskarakteren %{grade} i emnet %{course_name}, og du oppfyller derfor ikke nevnte karakterkrav. Karakterkravet er også beskrevet i forskrift om godkjenning av annen utdanning i stedet for mesterutdanning, hvor det fremgår at eksamen må bestås med karakter D eller bedre i fag som inngår i vurderingsgrunnlaget.",
        "Vi viser også til våre hjemmesider, der det er informert om at unntatt fra karakterkravet er emnene yrkesrettede realfagsemner, yrkesrettet kommunikasjon og lokalt valgte emner."
      ],
      "grade_advice": [
        "På bakgrunn av vurderingen som er foretatt, tilfredsstiller du derfor ikke kravene for tildeling av mesterbrev.",
        "Dersom du ønsker å søke mesterbrev ved en senere anledning, råder vi deg til å undersøke med fagskolen om du kan forbedre karakteren i emnet %{course_name}, der du fikk %{grade}."
      ],
      "practice_advice": [
        "Husk også å levere attest fra arbeidsgiver(e)."
      ]
    },
    "exemption": {
      "introduction": [
        "Vi viser til din søknad om fritak fra mesterutdanningens fagområder %{requested_subject_areas} på bakgrunn av din utdanning %{education_name}."
      ],
      "decisions": {
        "granted": [
          "Etter en vurdering av din søknad om godkjenning av annen utdanning i stedet for mesterutdanning, jf. lov om mesterbrev i håndverk og annen næring og forskrift om godkjenning av annen utdanning i stedet for mesterutdanning, innvilges du fritak for mesterutdanningens fagområder %{granted_subject_areas}."
        ],
        "partially_granted": [
          "Etter en vurdering av din søknad om godkjenning av annen utdanning i stedet for mesterutdanning, jf. lov om mesterbrev i håndverk og annen næring og forskrift om godkjenning av annen utdanning i stedet for mesterutdanning, innvilges du delvis fritak. Fritak innvilges for %{granted_subject_areas}. Søknaden om fritak for %{denied_subject_areas} avslås."
        ],
        "denied": [
          "Etter en vurdering av din søknad om godkjenning av annen utdanning i stedet for mesterutdanning, jf. lov om mesterbrev i håndverk og annen næring og forskrift om godkjenning av annen utdanning i stedet for mesterutdanning, avslås søknaden om fritak for mesterutdanningens fagområder %{denied_subject_areas}."
        ]
      },
      "granted_assessment": [
        "Du har dokumentert at din utdanning tilfredsstiller forskriftens krav for fritak i fagområdene %{granted_subject_areas}."
      ],
      "denied_assessment": [
        "I vurderingen av fagområdene %{denied_subject_areas} finner vi at utdanningen ikke i tilstrekkelig grad samsvarer med mesterutdanningens innhold, og fritak innvilges derfor ikke for disse fagområdene."
      ],
      "information": [
        "Ønsker du å ta de resterende modulene og fagområdene i mesterutdanningen, finner du kontaktinformasjon til utdanningsaktørene på vår hjemmeside: www.mesterbrev.no",
        "Ved eventuell søknad om mesterbrev ber vi om at dette brevet legges ved som dokumentasjon."
      ]
    },
    "inspection": [
      "Du har etter forvaltningsloven § 18, jf. § 19, rett til å gjøre deg kjent med dokumentene i saken. Ta kontakt med Mesterbrevnemnda dersom du ønsker innsyn."
    ],
    "receipt": {
      "introduction": [
        "Mesterbrevnemnda bekrefter å ha mottatt din klage datert %{appeal_date} på vårt vedtak av %{decision_date}."
      ],
      "on_time": [
        "Din klage er fremsatt innen fristen på tre uker og vil bli behandlet av Mesterbrevnemnda.",
        "Dersom Mesterbrevnemnda ikke finner grunnlag for å omgjøre vedtaket, blir saken sendt til Klagenemnda for mesterbrevordningen, som fatter endelig vedtak."
      ],
      "under_review": [
        "Vi vurderer om klagen er fremsatt innen klagefristen.",
        "Dersom klagen tas til behandling og Mesterbrevnemnda ikke finner grunnlag for å omgjøre vedtaket, blir saken sendt til Klagenemnda for mesterbrevordningen, som fatter endelig vedtak."
      ],
      "late": [
        "Klagen er fremsatt etter klagefristen. Vi vurderer om klagen likevel kan tas til behandling.",
        "Dersom klagen tas til behandling og Mesterbrevnemnda ikke finner grunnlag for å omgjøre vedtaket, blir saken sendt til Klagenemnda for mesterbrevordningen, som fatter endelig vedtak."
      ],
      "board": [
        "Klagenemnda kan vurdere alle sider ved vedtak fattet av Mesterbrevnemnda. Klagenemnda for mesterbrevordningen har normalt fire møter i året for behandling av innkomne klagesaker."
      ]
    },
    "grant": {
      "congratulations": "Gratulerer som mester i %{trade_name}.",
      "master_number": [
        "Ditt mesternummer er %{master_number}.",
        "Bruk alltid dette nummeret ved henvendelser til oss."
      ],
      "next_steps": [
        "Faktura for årsavgiften blir sendt som eFaktura eller e-post. Når innbetalingen er registrert, vil mesterbrevet bli utstedt og sendt deg, og du vil være synlig i mesterregisteret på nettet – www.mesterregisteret.no",
        "Ta gjerne kontakt med oss dersom du har spørsmål.",
        "Lykke til som mester i faget ditt."
      ]
    },
    "sanction": {
      "company": [
        "%{company_name}, organisasjonsnummer %{organisation_number}.",
        "%{observed_use}"
      ],
      "response": {
        "not_received": [
          "Vi har ikke fått svar på vår henvendelse innen fristens utløp."
        ],
        "received": [
          "Vi har mottatt svar på vår henvendelse %{documentation_received_date}."
        ]
      },
      "appeal": [
        "Dersom klage på dette vedtaket ikke er mottatt innen tre uker, oversendes saken Statens innkrevingssentral for innkreving av overtredelsesgebyret. Eventuell klage vedrørende dette vedtaket sendes Mesterbrev, postboks 5145 Majorstuen, 0302 Oslo eller på e-post til post@mesterbrev.no. Det gjøres samtidig oppmerksom på at du har adgang til å se sakens dokumenter etter forvaltningsloven § 18 og § 19."
      ]
    },
    "templates": {
      "foreign_qualification_advance_notice": {
        "name": "Forhåndsvarsel – utenlandsk mesterkvalifikasjon",
        "description": "Forhåndsvarsel om avslag med valg av manglende dokumentasjon og seks ukers frist fra mottak.",
        "subject": "Forhåndsvarsel om avslag på søknad om mesterbrev i %{trade_name} med bakgrunn i mesterkvalifikasjon fra %{country} – %{applicant_name}, født %{birth_date}",
        "example": {
          "rationale": "Vi mangler dokumentasjon som viser hvilken opplæring du har gjennomført i norske myndighetskrav og bransjestandarder."
        }
      },
      "foreign_qualification_denial": {
        "name": "Avslag – utenlandsk mesterkvalifikasjon",
        "description": "Vedtak etter forhåndsvarsel, med vurdering av ettersendt dokumentasjon og valgte krav.",
        "subject": "Vedtak om avslag på søknad om mesterbrev i %{trade_name} med bakgrunn i mesterkvalifikasjon fra %{country} – %{applicant_name}, født %{birth_date}",
        "example": {
          "unmet_criteria": [
            "norwegian_standards"
          ],
          "rationale": "Dokumentasjonen beskriver opplæringen i hjemlandet, men underbygger ikke kompetanse i gjeldende norske myndighetskrav og bransjestandarder."
        }
      },
      "prior_learning_advance_notice": {
        "name": "Forhåndsvarsel – realkompetanse",
        "description": "Forhåndsvarsel med relevante krav i § 2, fagområder og mulighet til å utbedre søknaden.",
        "subject": "Forhåndsvarsel om avslag på søknad om mesterbrev i %{trade_name} på bakgrunn av realkompetanse – %{applicant_name}, født %{birth_date}",
        "example": {
          "unmet_criteria": [
            "learning_outcomes"
          ],
          "rationale": "Egenvurderingen beskriver ansvaret ditt overordnet, men viser ikke konkrete eksempler på økonomiske vurderinger og begrunnelser for valgte løsninger."
        }
      },
      "prior_learning_denial": {
        "name": "Avslag – realkompetanse",
        "description": "Vedtak etter en samlet vurdering av dokumentert realkompetanse og relevante krav.",
        "subject": "Vedtak om avslag på søknad om mesterbrev i %{trade_name} på bakgrunn av realkompetanse – %{applicant_name}, født %{birth_date}",
        "example": {
          "unmet_criteria": [
            "learning_outcomes"
          ],
          "rationale": "Egenvurderingen beskriver ansvaret ditt overordnet. Den ettersendte dokumentasjonen viser ikke konkrete eksempler som underbygger læringsutbyttet i bedriftsledelse."
        }
      },
      "ordinary_practice_denial": {
        "name": "Avslag – praksis",
        "description": "Vedtak med dokumentert praksis, perioder, tidligere dialog og individuell begrunnelse.",
        "subject": "Søknad fra %{applicant_name}, født %{birth_date}, om mesterbrev i %{trade_name}",
        "example": {
          "met_criteria": [
            "trade_certificate",
            "master_education"
          ],
          "rationale": "Den dokumenterte praksisen etter svenneprøven er kortere enn to år. Det er heller ikke dokumentert minst seks års samlet utøvende praksis i faget."
        }
      },
      "ordinary_grade_denial": {
        "name": "Avslag – karakterkrav",
        "description": "Vedtak med faktisk utdanning, emne og karakter. Praksismangel tas bare med når den er bekreftet.",
        "subject": "Søknad fra %{applicant_name}, født %{birth_date}, om mesterbrev i %{trade_name}",
        "example": {
          "met_criteria": [
            "trade_certificate"
          ],
          "rationale": "Emnet inngår i vurderingsgrunnlaget og er ikke blant emnene som er unntatt fra karakterkravet."
        }
      },
      "title_misuse_initial_notice": {
        "name": "Ulovlig bruk – første brev",
        "description": "Eksempel på første henvendelse om mestertittel eller mestermerke. Utførelse er ikke tilgjengelig ennå.",
        "subject": "Bruk av mestermerket/mestertittel",
        "introduction": [
          "Mesterbrev er gjort kjent med at bedriften %{company_name} anvender mestermerket/mestertittel. Vi kan ikke finne nevnte firma i Mesterregisteret.",
          "Vi minner om at såfremt ingen med mesterbrev er tilknyttet bedriften, er bruk av mestertittel og/eller mestermerke ulovlig, jf. mesterbrevloven § 1 tredje ledd."
        ],
        "body": [
          "Vi må derfor be om en bekreftelse fra en mester som er ansatt som faglig leder i minst 50 % stilling i firmaet, og som har knyttet sitt mesterbrev til bedriften. Om dette ikke kan etterkommes, ber vi om en bekreftelse på at all bruk av mestermerket er opphørt.",
          "Bedrifter som misbruker mestermerke/mestertittel kan pålegges å betale et overtredelsesgebyr på kr 5 000, kr 10 000 og kr 15 000 for henholdsvis 1., 2. og 3. gangs overtredelse, jf. mesterbrevloven § 1 fjerde ledd og mesterbrevforskriften § 6.",
          "I siste instans kan ulovlig bruk føre til politianmeldelse.",
          "Dersom vi ikke mottar et svar på dette brevet innen fire uker fra brevdato, vil vedtak om ileggelse av overtredelsesgebyr på kr 5 000 bli utferdiget.",
          "Vi imøteser en tilbakemelding på vår henvendelse."
        ],
        "example": {
          "rationale": "Kontrollen av Mesterregisteret viser ingen tilknyttet mester for eksempelbedriften."
        }
      },
      "title_misuse_first_decision": {
        "name": "Ulovlig bruk – første gebyrvedtak",
        "description": "Eksempel på første overtredelsesgebyr på 5 000 kroner. Utførelse er ikke tilgjengelig ennå.",
        "subject": "Vedtak om ileggelse av overtredelsesgebyr",
        "introduction": [
          "Vi viser til vårt brev av %{notice_date} vedrørende bruk av mestertittelen/mestermerket."
        ],
        "body": [
          "Vi gjør med dette oppmerksom på at det er gjort vedtak om ileggelse av overtredelsesgebyr på kr 5 000, jf. mesterbrevloven § 1 fjerde ledd og mesterbrevforskriften § 6."
        ],
        "example": {
          "documentation_received": "not_received",
          "rationale": "Eksempelbedriften bruker fortsatt mestermerket uten at et gyldig mesterbrev er knyttet til bedriften."
        }
      },
      "title_misuse_second_decision": {
        "name": "Ulovlig bruk – andre gebyrvedtak",
        "description": "Eksempel på andre overtredelsesgebyr på 10 000 kroner. Utførelse er ikke tilgjengelig ennå.",
        "subject": "Vedtak om ileggelse av 2. gangs overtredelsesgebyr",
        "introduction": [
          "Vi viser til våre brev av %{notice_date} og %{first_decision_date} vedrørende bruk av mestertittel/mestermerket. Mesterbrevnemnda er gjort oppmerksom på at nevnte firma fremdeles anvender navnet, dette til tross for tidligere ilagt 1. gangs overtredelsesgebyr."
        ],
        "body": [
          "Vi gjør med dette oppmerksom på at det er gjort vedtak om ileggelse av 2. gangs overtredelsesgebyr på kr 10 000, jf. mesterbrevloven § 1 fjerde ledd og mesterbrevforskriften § 6."
        ],
        "example": {
          "rationale": "En ny kontroll viser at eksempelbedriften fortsatt bruker mestertittelen etter det første gebyrvedtaket."
        }
      },
      "title_misuse_third_decision": {
        "name": "Ulovlig bruk – tredje gebyrvedtak",
        "description": "Eksempel på tredje overtredelsesgebyr på 15 000 kroner. Utførelse er ikke tilgjengelig ennå.",
        "subject": "Vedtak om ileggelse av 3. gangs overtredelsesgebyr",
        "introduction": [
          "Vi viser til våre brev av %{notice_date}, %{first_decision_date} og %{second_decision_date} vedrørende bruk av mestertittel/mestermerket. Mesterbrevnemnda er gjort oppmerksom på at mestermerket fremdeles anvendes, til tross for tidligere ilagt 1. og 2. gangs overtredelsesgebyr."
        ],
        "body": [
          "Vi gjør med dette oppmerksom på at det er gjort vedtak om ileggelse av 3. gangs overtredelsesgebyr på kr 15 000, jf. mesterbrevloven § 1 fjerde ledd og mesterbrevforskriften § 6."
        ],
        "example": {
          "rationale": "En ny kontroll viser at eksempelbedriften fortsatt bruker mestermerket etter det andre gebyrvedtaket."
        }
      },
      "appeal_receipt": {
        "name": "Mottatt klage",
        "description": "Bekreftelse på mottatt klage, med særskilt valg av om klagen er rettidig, sen eller under vurdering.",
        "subject": "Vedr. klage fra %{applicant_name}, født %{birth_date}, på vårt vedtak av %{decision_date}",
        "example": {
          "appeal_timeliness": "under_review"
        }
      },
      "education_exemption_decision": {
        "name": "Vedtak – fritak fra mesterutdanningen",
        "description": "Innvilgelse, delvis innvilgelse eller avslag med sammenhengende overskrift, vedtak og fagområder.",
        "subjects": {
          "granted": "Vedtak om innvilgelse av søknad fra %{applicant_name}, født %{birth_date}, om fritak fra mesterutdanningens fagområder",
          "partially_granted": "Vedtak om delvis innvilgelse av søknad fra %{applicant_name}, født %{birth_date}, om fritak fra mesterutdanningens fagområder",
          "denied": "Vedtak om avslag på søknad fra %{applicant_name}, født %{birth_date}, om fritak fra mesterutdanningens fagområder"
        },
        "example": {
          "outcome": "partially_granted",
          "rationale": "Vurderingen bygger på vitnemålet og de fremlagte emnebeskrivelsene. Innhold og omfang er vurdert opp mot studieplanene for de omsøkte fagområdene."
        }
      },
      "application_grant_letter": {
        "name": "Innvilgelsesbrev – mesterbrev",
        "description": "Informasjon om innvilget mesterbrev, mesternummer, årsavgift og videre prosess.",
        "subject": "Søknad om mesterbrev",
        "rationale": "Din søknad er ferdig behandlet og vi har gleden av å informere om at du er tildelt mesterbrev.",
        "example": {}
      }
    },
    "examples": {
      "base": {
        "applicant_name": "Ola Eksempel",
        "recipient_address": "Eksempelveien 12\n0123 Oslo",
        "birth_date": "15.04.1985",
        "trade_name": "tømrerfaget",
        "case_number": "MB-2026-000123",
        "application_date": "01.06.2026",
        "letter_date": "30.09.2026",
        "caseworker_name": "Kari Eksempel",
        "caseworker_title": "Rådgiver",
        "master_number": "123456"
      },
      "fields": {
        "country": "Tyskland",
        "missing_documents": [
          "norwegian_standards",
          "practice"
        ],
        "notice_date": "2026-07-01",
        "documentation_received": "received",
        "documentation_received_date": "2026-08-10",
        "fee_payment_date": "2026-06-01",
        "subject_areas": [
          "business_management",
          "technical_management"
        ],
        "trade_group": "Byggfag",
        "assessment_gaps": [
          "detail",
          "references",
          "reflection"
        ],
        "practice_summary": "Du har dokumentert ett års praksis som faglært tømrer hos Eksempelbygg AS i perioden 1. juni 2025 til 31. mai 2026.",
        "previous_dialog": "Vi viser til e-post av 1. juli 2026, der du fikk anledning til å ettersende praksisdokumentasjon med svarfrist 15. august 2026.",
        "education_name": "Toårig teknisk fagskoleutdanning i bygg",
        "course_name": "Prosjektledelse",
        "grade": "E",
        "requested_subject_areas": [
          "business_management",
          "technical_management"
        ],
        "granted_subject_areas": [
          "business_management"
        ],
        "denied_subject_areas": [
          "technical_management"
        ],
        "appeal_date": "2026-09-15",
        "decision_date": "2026-09-01",
        "company_name": "Eksempelbygg AS",
        "organisation_number": "000000000",
        "observed_use": "Bedriften bruker mestermerket på sin nettside og i annonsering.",
        "first_decision_date": "2026-08-01",
        "second_decision_date": "2026-09-01"
      }
    }
  },
  "notifications": {
    "templates": {
      "fallback": "Du har mottatt en ny melding fra Mesterbrevnemnda vedrørende sak %{case_number}.",
      "decision_notice": {
        "label": "Vedtaksunderretning",
        "email": {
          "subject": "Vedtak i sak %{case_number}",
          "body": "Hei %{applicant_name},\n\nMesterbrevnemnda har fattet vedtak i din sak %{case_number}. Du finner vedtaket og begrunnelsen på Min side i mesterbrevportalen.\n\nMed vennlig hilsen\nMesterbrevnemnda\n"
        }
      },
      "request_more_information": {
        "label": "Forespørsel om mer informasjon",
        "email": {
          "subject": "Vi trenger mer informasjon i sak %{case_number}",
          "body": "Hei %{applicant_name},\n\nMesterbrevnemnda trenger mer informasjon for å behandle din sak %{case_number}. Logg inn på Min side i mesterbrevportalen for å se hva som mangler og laste opp dokumentasjon.\n\nMed vennlig hilsen\nMesterbrevnemnda\n"
        },
        "sms": {
          "body": "Mesterbrevnemnda trenger mer informasjon i sak %{case_number}. Logg inn på Min side for detaljer."
        }
      },
      "appeal_received": {
        "label": "Bekreftelse på mottatt klage",
        "email": {
          "subject": "Vi har mottatt klagen din i sak %{case_number}",
          "body": "Hei %{applicant_name},\n\nMesterbrevnemnda har mottatt klagen din på vedtaket i sak %{case_number}. Klagen blir behandlet, og du vil bli varslet når det foreligger en avgjørelse.\n\nMed vennlig hilsen\nMesterbrevnemnda\n"
        }
      },
      "arsgebyr_paakrav": {
        "label": "Påkrav om årsgebyr",
        "email": {
          "subject": "Påkrav – ubetalt årsgebyr for mesterbrev i %{trade}",
          "body": "Hei,\n\nVi har ikke registrert betaling av årsgebyret for ditt mesterbrev i %{trade} for %{fee_period}.\n\nBetal snarest med KID-nummer %{kid}. Dersom årsgebyret fortsatt er ubetalt én måned etter dette påkravet, bortfaller mesterbrevet etter mesterbrevloven § 5.\n\nMed vennlig hilsen\nMesterbrevnemnda\n"
        },
        "sms": {
          "body": "Påkrav: årsgebyret for ditt mesterbrev (%{trade}, %{fee_period}) er ubetalt. Betal med KID %{kid}. Fortsatt ubetalt én måned etter dette medfører bortfall (mesterbrevloven § 5)."
        }
      }
    }
  },
  "template_management": {
    "baseline_summary": "Opprettet fra kodegrunnlaget for Azure dev/test.",
    "library": {
      "hint": "Finn og rediger brevmaler eller opprett en ny.",
      "new": "Ny brevmal",
      "create": "Opprett brevmal",
      "name": "Navn på brevmal",
      "create_hint": "Velg maltype og gi brevmalen et navn. Malen opprettes som et utkast. Du må publisere den før den kan brukes i brev.",
      "template": "Brevmal",
      "categories": "Kategorier",
      "search_hint": "Søk etter navn, maltype eller bruksområde",
      "filters": "Filtre",
      "remove_filter": "Fjern filter: %{label}",
      "count": {
        "one": "%{count} brevmal",
        "other": "%{count} brevmaler"
      },
      "sort": "Sortering",
      "sort_name": "Navn A–Å",
      "sort_changed": "Sist endret først",
      "edit": "Rediger",
      "preview": "Forhåndsvis",
      "original": "Opprinnelig mal",
      "about_type": "Om maltypen",
      "empty": "Ingen aktive brevmaler i dette utvalget",
      "no_matches": "Ingen brevmaler passer med søket eller filtrene",
      "first": "Opprett første brevmal"
    },
    "validation_summary": "Rett feilene før du publiserer",
    "title": "Malforvaltning",
    "variants": "Malvarianter",
    "manage": "Forvalt varianter",
    "pilot": "Alle maltyper kan opprettes som redigerbare varianter.",
    "create": "Opprett variant",
    "create_from_template": "Opprett variant fra denne malen",
    "items_from": "Gjenta listepunkter for",
    "fixed_items": "Fast punktliste",
    "current_item": "Gjeldende valg i listen",
    "items_from_hint": "Hvert listepunkt gjentas for de valgte verdiene. Bruk item i Liquid-vilkår for å velge tekst for hvert valg.",
    "name": "Navn på brevmal",
    "description": "Brukes når",
    "owner": "Ansvarlig",
    "type": "Maltype",
    "version": "Versjon",
    "history": "Versjonshistorikk",
    "published": "Publisert",
    "draft": "Arbeidsutkast",
    "archived": "Arkivert",
    "default": "Standard",
    "set_default": "Bruk som standard",
    "archive": "Arkiver brevmal",
    "restore": "Gjenåpne brevmal",
    "revise": "Ny versjon fra denne",
    "save": "Lagre arbeidsutkast",
    "saved": "Arbeidsutkast lagret",
    "unsaved": "Ulagrede endringer",
    "publish": "Publiser versjon",
    "confirm_publish": "Publiser denne versjonen for nye brev? Eksisterende brevutkast beholder sin versjon.",
    "confirm_archive": "Vil du arkivere brevmalen? Den kan da ikke velges til nye brev. Eksisterende brev og malversjoner beholdes.",
    "summary": "Endringsbeskrivelse",
    "subject": "Emne",
    "sections": "Seksjoner",
    "section": "Seksjon %{number}",
    "heading": "Overskrift",
    "paragraph": "Avsnitt %{number}",
    "item": "Listepunkt %{number}",
    "add_section": "Legg til seksjon",
    "add_paragraph": "Legg til avsnitt",
    "add_item": "Legg til listepunkt",
    "remove": "Fjern",
    "up": "Flytt opp",
    "down": "Flytt ned",
    "insert_field": "Sett inn opplysning",
    "choose_field": "Velg felt …",
    "fields": "Tilgjengelige flettefelt",
    "liquid_help": "Bruk flettefeltene for saksopplysninger. Avanserte tekstvalg kan bruke Liquid if, unless, case og for. Verdier er tekst; HTML og Typst-kode kjøres ikke.",
    "preview": "PDF med eksempeldata",
    "preview_hint": "Lagre for å oppdatere PDF-en. Eksemplet bruker fiktive opplysninger.",
    "back": "Til maloversikten",
    "working": "Arbeider …",
    "leave": "Du har ulagrede endringer. Vil du fortsette uten å lagre?",
    "usage": "Brev som bruker versjonen",
    "author": "Opprettet av",
    "publisher": "Publisert av",
    "published_at": "Publisert dato",
    "legacy": "Opprinnelig kodemal",
    "choose_variant": "Malvariant",
    "placeholder": "[Mangler opplysning]",
    "content": "Innhold",
    "details": "Detaljer",
    "current": "Gjeldende",
    "previous": "Tidligere versjon",
    "edit": "Rediger mal",
    "continue_draft": "Rediger utkast",
    "actions": "Flere handlinger",
    "section_actions": "Seksjonshandlinger",
    "add_heading": "Legg til overskrift",
    "section_removed": "Seksjonen er fjernet.",
    "content_removed": "Teksten er fjernet.",
    "section_actions_for": "Handlinger for seksjon %{number}",
    "remove_paragraph": "Fjern avsnitt %{number}",
    "remove_item": "Fjern listepunkt %{number}",
    "undo": "Angre fjerning",
    "confirm_publication": "Bekreft publisering",
    "cancel": "Avbryt",
    "paper_hint": "Eksemplet bruker fiktive opplysninger. PDF-arket beholder brevets utskriftsprofil, mens verktøyene følger temaet ditt.",
    "preview_stale": "Viser forrige forhåndsvisning. Endringene er ikke med ennå.",
    "preview_invalid": "Rett feilene i teksten for å oppdatere PDF-en.",
    "saving": "Lagrer …",
    "save_failed": "Ikke lagret – prøv igjen",
    "retry_save": "Prøv lagring igjen",
    "preview_current": "PDF-en er oppdatert",
    "preview_loading": "Oppdaterer PDF …",
    "preview_waiting": "Venter på gyldig, lagret innhold",
    "preview_error": "PDF-en kunne ikke vises. Prøv igjen.",
    "retry_preview": "Prøv forhåndsvisning på nytt",
    "scenario": "Eksempel",
    "scenarios": {
      "standard": "Standardeksempel",
      "long_recipient": "Langt navn og adresse",
      "long_rationale": "Lang begrunnelse",
      "without_optional": "Uten valgfrie opplysninger",
      "all_choices": "Alle listevalg",
      "reversed_choices": "Listevalg i motsatt rekkefølge"
    },
    "search_fields": "Søk etter opplysning",
    "no_fields": "Ingen opplysninger passer med søket.",
    "example": "Eksempel: %{value}",
    "line": "Linje %{number}",
    "technical_detail": "Teknisk forklaring",
    "pdf": "PDF",
    "fullscreen": "Fullskjerm",
    "exit_fullscreen": "Avslutt fullskjerm",
    "fullscreen_error": "Fullskjerm kunne ikke åpnes. PDF-en er fortsatt tilgjengelig her.",
    "status": "Status",
    "letter_count": "Brev",
    "property": "Opplysning",
    "value": "Verdi",
    "example_label": "Eksempel",
    "drag_section": "Dra seksjon %{number}",
    "reorder_help": "Dra håndtaket for å flytte seksjonen. Du kan også bruke pil opp og pil ned når håndtaket har fokus.",
    "section_moved": "Seksjonen er flyttet til plass %{number} av %{count}.",
    "catalogue_hint": "Finn maltype og variant, eller opprett en ny variant.",
    "catalogue_count": "%{types} maltyper · %{variants} varianter",
    "search_catalogue": "Søk",
    "all_types": "Alle maltyper",
    "clear_filters": "Fjern søk og filtre",
    "last_changed": "Sist endret",
    "versions": "Versjoner",
    "draft_version": "Utkast v%{number}",
    "code_based": "Kodebasert",
    "copy": "Kopier brevmal",
    "copy_suffix": " – kopi",
    "copy_source": "Velg versjonen du vil kopiere",
    "copy_hint": "Kopien får samme maltype og språk som originalen. Den opprettes som et utkast og må publiseres før bruk.",
    "create_copy": "Opprett kopi",
    "variant_actions": "Handlinger for %{name}",
    "retry_versions": "Hent versjoner på nytt",
    "edit_metadata": "Rediger navn og beskrivelse",
    "save_metadata": "Lagre endringer",
    "metadata_name_hint": "Du endrer navnet i maloversikten. Navnet i eksisterende versjoner endres ikke.",
    "version_name": "Navn i denne versjonen",
    "based_on": "Basert på",
    "compare": {
      "title": "Sammenlign versjoner",
      "open": "Se endringer",
      "from": "Fra",
      "to": "Til",
      "text": "Tekst og struktur",
      "await_save": "Kladden må være lagret før den kan sammenlignes. Lukk denne visningen for å rette eventuelle lagringsfeil.",
      "no_source": "Denne versjonen har ingen lagret versjon å sammenligne med.",
      "retry": "Prøv sammenligning igjen",
      "summary": "Nye seksjoner: %{added} · Fjernet: %{removed} · Flyttet: %{moved} · Tekstendringer: %{text} · Endrede opplysninger: %{metadata}",
      "identical": "Ingen endringer mellom disse versjonene.",
      "show_all": "Vis hele innholdet",
      "added": "Lagt til",
      "removed": "Fjernet",
      "changed": "Endret",
      "unchanged": "Uendret",
      "moved": "Flyttet fra plass %{from} til %{to}",
      "paragraphs": "Avsnitt",
      "items": "Listepunkt",
      "empty_text": "Tom tekst",
      "variant_name": "Versjonsnavn endret",
      "definition": "Felt- eller prosesskontrakt endret",
      "layout_revision": "Layoutrevisjon endret",
      "pdf_hint": "Begge PDF-er bruker samme fiktive eksempel. Dette er nye forhåndsvisninger, ikke historiske utstedte brev."
    },
    "status_filters": {
      "active": "Alle aktive",
      "drafts": "Med utkast",
      "published": "Publiserte",
      "draft_only": "Kun utkast",
      "archived": "Arkiverte"
    },
    "groups": {
      "recipient": "Mottaker",
      "case": "Sak",
      "decision": "Vedtak",
      "sender": "Avsender"
    },
    "errors": {
      "structure": "Ugyldig malstruktur eller for mye innhold.",
      "immutable": "Publiserte versjoner kan ikke endres. Opprett en ny versjon.",
      "field": "Ukjent eller utilgjengelig flettefelt: %{field}",
      "filter": "Malen bruker et filter som ikke er tilgjengelig.",
      "missing": "En påkrevd opplysning mangler i teksten.",
      "empty": "Malen må ha emne og synlig innhold.",
      "unsupported": "Denne maltypen er ikke overført til Liquid ennå.",
      "version": "Velg en publisert versjon som tilhører varianten.",
      "archived": "Varianten er arkivert.",
      "operation": "Ugyldig handling.",
      "conflict": "Noen har endret malen. Last siden på nytt før du prøver igjen. Dine endringer er beholdt her.",
      "request": "Handlingen kunne ikke fullføres. Prøv igjen.",
      "scenario": "Velg et tilgjengelig eksempel.",
      "syntax": "Ugyldig Liquid-uttrykk. Kontroller feltnavn, betingelser og avsluttende tegn eller tagger.",
      "layout": "Denne layoutrevisjonen kan ikke forhåndsvises med tilgjengelig brevprofil."
    }
  }
}
